
      var $parcel$global = globalThis;
    // Import the functions you need from the SDKs you need
const $a7f559d5d89c892f$export$6d3c090e66a883b1 = ()=>({
        "config": {
            "apiKey": "AIzaSyBzpYas5BAcVubWIKkCURbKzKo-gel47Yw",
            "appId": "1:604775691532:web:07bba4f95857c89ff14529",
            "authDomain": "niram-616e5.firebaseapp.com",
            "databaseURL": "",
            "messagingSenderId": "604775691532",
            "projectId": "niram-616e5",
            "storageBucket": "niram-616e5.firebasestorage.app"
        },
        "emulatorHosts": {}
    });


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $029952e65115eee5$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $029952e65115eee5$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $029952e65115eee5$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $029952e65115eee5$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $029952e65115eee5$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $029952e65115eee5$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $029952e65115eee5$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($029952e65115eee5$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $029952e65115eee5$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $029952e65115eee5$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $029952e65115eee5$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $029952e65115eee5$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $029952e65115eee5$var$stringToByteArray$1(str);
    return $029952e65115eee5$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $029952e65115eee5$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $029952e65115eee5$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $029952e65115eee5$export$c62426fdd000a97e = function(str) {
    try {
        return $029952e65115eee5$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $029952e65115eee5$export$6c40052bed430212(value) {
    return $029952e65115eee5$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $029952e65115eee5$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$029952e65115eee5$var$isValidKey(prop)) continue;
        target[prop] = $029952e65115eee5$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $029952e65115eee5$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $029952e65115eee5$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$getDefaultsFromGlobal = ()=>$029952e65115eee5$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $029952e65115eee5$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $cfae44f0dfdf62c0$exports === "undefined" || typeof $cfae44f0dfdf62c0$exports.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $029952e65115eee5$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $029952e65115eee5$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $029952e65115eee5$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $a7f559d5d89c892f$export$6d3c090e66a883b1)() || $029952e65115eee5$var$getDefaultsFromGlobal() || $029952e65115eee5$var$getDefaultsFromEnvVariable() || $029952e65115eee5$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $029952e65115eee5$export$9c11895284c8adad = (productName)=>$029952e65115eee5$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $029952e65115eee5$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $029952e65115eee5$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $029952e65115eee5$export$3dfb6827a9f89756 = ()=>$029952e65115eee5$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $029952e65115eee5$export$5539a1a3afe87d6 = (name)=>$029952e65115eee5$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $029952e65115eee5$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $029952e65115eee5$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith("http://") || url.startsWith("https://") ? new URL(url).hostname : url;
        return host.endsWith(".cloudworkstations.dev");
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $029952e65115eee5$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: "include"
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(header)),
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
const $029952e65115eee5$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $029952e65115eee5$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($029952e65115eee5$var$emulatorStatus))if ($029952e65115eee5$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $029952e65115eee5$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement("div");
        parentDiv.setAttribute("id", id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $029952e65115eee5$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $029952e65115eee5$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === "undefined" || typeof document === "undefined" || !$029952e65115eee5$export$5b4d24b45140ad90(window.location.host) || $029952e65115eee5$var$emulatorStatus[name] === isRunningEmulator || $029952e65115eee5$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $029952e65115eee5$var$previouslyDismissed) return;
    $029952e65115eee5$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = "__firebase__banner";
    const summary = $029952e65115eee5$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = "flex";
        bannerEl.style.background = "#7faaf0";
        bannerEl.style.position = "fixed";
        bannerEl.style.bottom = "5px";
        bannerEl.style.left = "5px";
        bannerEl.style.padding = ".5em";
        bannerEl.style.borderRadius = "5px";
        bannerEl.style.alignItems = "center";
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute("width", "24");
        prependIcon.setAttribute("id", iconId);
        prependIcon.setAttribute("height", "24");
        prependIcon.setAttribute("viewBox", "0 0 24 24");
        prependIcon.setAttribute("fill", "none");
        prependIcon.style.marginLeft = "-6px";
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement("span");
        closeBtn.style.cursor = "pointer";
        closeBtn.style.marginLeft = "16px";
        closeBtn.style.fontSize = "24px";
        closeBtn.innerHTML = " &times;";
        closeBtn.onclick = ()=>{
            $029952e65115eee5$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute("id", learnMoreId);
        learnMoreLink.innerText = "Learn more";
        learnMoreLink.href = "https://firebase.google.com/docs/studio/preview-apps#preview-backend";
        learnMoreLink.setAttribute("target", "__blank");
        learnMoreLink.style.paddingLeft = "5px";
        learnMoreLink.style.textDecoration = "underline";
    }
    function setupDom() {
        const banner = $029952e65115eee5$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId("text");
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement("span");
        const learnMoreId = prefixedId("learnmore");
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement("a");
        const prependIconId = prefixedId("preprendIcon");
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS("http://www.w3.org/2000/svg", "svg");
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = "Preview backend running in this workspace.";
        }
        firebaseText.setAttribute("id", firebaseTextId);
    }
    if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $029952e65115eee5$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $029952e65115eee5$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($029952e65115eee5$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $029952e65115eee5$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $029952e65115eee5$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $029952e65115eee5$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $029952e65115eee5$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $029952e65115eee5$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $029952e65115eee5$export$ad9e9b75cb9fb797() {
    return typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers";
}
function $029952e65115eee5$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $029952e65115eee5$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $029952e65115eee5$export$f2f6a8999f8ebd30() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $029952e65115eee5$export$7e7b1a9668aaed8() {
    const ua = $029952e65115eee5$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $029952e65115eee5$export$202944b2d2824246() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $029952e65115eee5$export$5d1d834fbbf8bab7() {
    return $029952e65115eee5$export$588c7fdda06fbb0a.NODE_CLIENT === true || $029952e65115eee5$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $029952e65115eee5$export$95df08bae54cb4df() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/** Returns true if we are running in Safari or WebKit */ function $029952e65115eee5$export$ef10bcfb06572016() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes("Safari") || navigator.userAgent.includes("WebKit")) && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $029952e65115eee5$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $029952e65115eee5$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $029952e65115eee5$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $029952e65115eee5$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $029952e65115eee5$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $029952e65115eee5$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $029952e65115eee5$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $029952e65115eee5$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $029952e65115eee5$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $029952e65115eee5$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $029952e65115eee5$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $029952e65115eee5$var$replaceTemplate(template, data) {
    return template.replace($029952e65115eee5$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $029952e65115eee5$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $029952e65115eee5$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $029952e65115eee5$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[0]) || "");
        claims = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$5f870fcca7ae6a88 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$701c661ec91095f2 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $029952e65115eee5$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$fc970ed23da99565 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $029952e65115eee5$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $029952e65115eee5$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $029952e65115eee5$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $029952e65115eee5$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($029952e65115eee5$var$isObject(aProp) && $029952e65115eee5$var$isObject(bProp)) {
            if (!$029952e65115eee5$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $029952e65115eee5$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $029952e65115eee5$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $029952e65115eee5$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $029952e65115eee5$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $029952e65115eee5$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $029952e65115eee5$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $029952e65115eee5$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $029952e65115eee5$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $029952e65115eee5$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $029952e65115eee5$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($029952e65115eee5$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $029952e65115eee5$var$noop;
        if (observer.error === undefined) observer.error = $029952e65115eee5$var$noop;
        if (observer.complete === undefined) observer.complete = $029952e65115eee5$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $029952e65115eee5$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $029952e65115eee5$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $029952e65115eee5$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $029952e65115eee5$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $029952e65115eee5$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $029952e65115eee5$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $029952e65115eee5$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $029952e65115eee5$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $029952e65115eee5$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $029952e65115eee5$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $029952e65115eee5$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $029952e65115eee5$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $029952e65115eee5$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($029952e65115eee5$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $029952e65115eee5$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $029952e65115eee5$var$indicator(i);
}
function $029952e65115eee5$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5782dd2556309534$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $5782dd2556309534$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $029952e65115eee5$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($5782dd2556309534$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $5782dd2556309534$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $5782dd2556309534$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $5782dd2556309534$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $5782dd2556309534$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $5782dd2556309534$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $5782dd2556309534$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $5782dd2556309534$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $59d1e3b150b2f36d$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $59d1e3b150b2f36d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($59d1e3b150b2f36d$export$243e62d78d3b544d || ($59d1e3b150b2f36d$export$243e62d78d3b544d = {}));
const $59d1e3b150b2f36d$var$levelStringToEnum = {
    "debug": $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG,
    "verbose": $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE,
    "info": $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO,
    "warn": $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN,
    "error": $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR,
    "silent": $59d1e3b150b2f36d$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $59d1e3b150b2f36d$var$defaultLogLevel = $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $59d1e3b150b2f36d$var$ConsoleMethod = {
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG]: "log",
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE]: "log",
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.INFO]: "info",
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.WARN]: "warn",
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $59d1e3b150b2f36d$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $59d1e3b150b2f36d$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $59d1e3b150b2f36d$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $59d1e3b150b2f36d$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $59d1e3b150b2f36d$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $59d1e3b150b2f36d$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $59d1e3b150b2f36d$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $59d1e3b150b2f36d$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $59d1e3b150b2f36d$export$c622e99c0ce7b1c9(level) {
    $59d1e3b150b2f36d$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $59d1e3b150b2f36d$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $59d1e3b150b2f36d$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $59d1e3b150b2f36d$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $59d1e3b150b2f36d$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === "function") return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $da032767b57a4aa4$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($5e587d655f0a08bb$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $5e587d655f0a08bb$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $5e587d655f0a08bb$var$name$q = "@firebase/app";
const $5e587d655f0a08bb$var$version$1 = "0.14.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$logger = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)("@firebase/app");
const $5e587d655f0a08bb$var$name$p = "@firebase/app-compat";
const $5e587d655f0a08bb$var$name$o = "@firebase/analytics-compat";
const $5e587d655f0a08bb$var$name$n = "@firebase/analytics";
const $5e587d655f0a08bb$var$name$m = "@firebase/app-check-compat";
const $5e587d655f0a08bb$var$name$l = "@firebase/app-check";
const $5e587d655f0a08bb$var$name$k = "@firebase/auth";
const $5e587d655f0a08bb$var$name$j = "@firebase/auth-compat";
const $5e587d655f0a08bb$var$name$i = "@firebase/database";
const $5e587d655f0a08bb$var$name$h = "@firebase/data-connect";
const $5e587d655f0a08bb$var$name$g = "@firebase/database-compat";
const $5e587d655f0a08bb$var$name$f = "@firebase/functions";
const $5e587d655f0a08bb$var$name$e = "@firebase/functions-compat";
const $5e587d655f0a08bb$var$name$d = "@firebase/installations";
const $5e587d655f0a08bb$var$name$c = "@firebase/installations-compat";
const $5e587d655f0a08bb$var$name$b = "@firebase/messaging";
const $5e587d655f0a08bb$var$name$a = "@firebase/messaging-compat";
const $5e587d655f0a08bb$var$name$9 = "@firebase/performance";
const $5e587d655f0a08bb$var$name$8 = "@firebase/performance-compat";
const $5e587d655f0a08bb$var$name$7 = "@firebase/remote-config";
const $5e587d655f0a08bb$var$name$6 = "@firebase/remote-config-compat";
const $5e587d655f0a08bb$var$name$5 = "@firebase/storage";
const $5e587d655f0a08bb$var$name$4 = "@firebase/storage-compat";
const $5e587d655f0a08bb$var$name$3 = "@firebase/firestore";
const $5e587d655f0a08bb$var$name$2 = "@firebase/ai";
const $5e587d655f0a08bb$var$name$1 = "@firebase/firestore-compat";
const $5e587d655f0a08bb$var$name = "firebase";
const $5e587d655f0a08bb$var$version = "12.2.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $5e587d655f0a08bb$export$9f30fa0c10967f7f = "[DEFAULT]";
const $5e587d655f0a08bb$var$PLATFORM_LOG_STRING = {
    [$5e587d655f0a08bb$var$name$q]: "fire-core",
    [$5e587d655f0a08bb$var$name$p]: "fire-core-compat",
    [$5e587d655f0a08bb$var$name$n]: "fire-analytics",
    [$5e587d655f0a08bb$var$name$o]: "fire-analytics-compat",
    [$5e587d655f0a08bb$var$name$l]: "fire-app-check",
    [$5e587d655f0a08bb$var$name$m]: "fire-app-check-compat",
    [$5e587d655f0a08bb$var$name$k]: "fire-auth",
    [$5e587d655f0a08bb$var$name$j]: "fire-auth-compat",
    [$5e587d655f0a08bb$var$name$i]: "fire-rtdb",
    [$5e587d655f0a08bb$var$name$h]: "fire-data-connect",
    [$5e587d655f0a08bb$var$name$g]: "fire-rtdb-compat",
    [$5e587d655f0a08bb$var$name$f]: "fire-fn",
    [$5e587d655f0a08bb$var$name$e]: "fire-fn-compat",
    [$5e587d655f0a08bb$var$name$d]: "fire-iid",
    [$5e587d655f0a08bb$var$name$c]: "fire-iid-compat",
    [$5e587d655f0a08bb$var$name$b]: "fire-fcm",
    [$5e587d655f0a08bb$var$name$a]: "fire-fcm-compat",
    [$5e587d655f0a08bb$var$name$9]: "fire-perf",
    [$5e587d655f0a08bb$var$name$8]: "fire-perf-compat",
    [$5e587d655f0a08bb$var$name$7]: "fire-rc",
    [$5e587d655f0a08bb$var$name$6]: "fire-rc-compat",
    [$5e587d655f0a08bb$var$name$5]: "fire-gcs",
    [$5e587d655f0a08bb$var$name$4]: "fire-gcs-compat",
    [$5e587d655f0a08bb$var$name$3]: "fire-fst",
    [$5e587d655f0a08bb$var$name$1]: "fire-fst-compat",
    [$5e587d655f0a08bb$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$5e587d655f0a08bb$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $5e587d655f0a08bb$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $5e587d655f0a08bb$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5e587d655f0a08bb$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $5e587d655f0a08bb$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $5e587d655f0a08bb$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $5e587d655f0a08bb$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($5e587d655f0a08bb$export$9566bce3835c0f28.has(componentName)) {
        $5e587d655f0a08bb$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $5e587d655f0a08bb$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $5e587d655f0a08bb$export$b4e3c36c855b14b5.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $5e587d655f0a08bb$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$38e311c93c671bec(obj) {
    if ($5e587d655f0a08bb$export$110778f8e98b8257(obj)) return false;
    return "authIdToken" in obj || "appCheckToken" in obj || "releaseOnDeref" in obj || "automaticDataCollectionEnabled" in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $5e587d655f0a08bb$export$3685d89b9c3cdfaf() {
    $5e587d655f0a08bb$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $5e587d655f0a08bb$var$ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)("app", "Firebase", $5e587d655f0a08bb$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $5e587d655f0a08bb$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $029952e65115eee5$export$c62426fdd000a97e)(base64Token.split(".")[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $5e587d655f0a08bb$var$FirebaseServerAppImpl extends $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.authIdToken, "authIdToken");
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.appCheckToken, "appCheckToken");
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, "serverapp");
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $5e587d655f0a08bb$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $5e587d655f0a08bb$export$31499a9cd224b78c = $5e587d655f0a08bb$var$version;
function $5e587d655f0a08bb$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $5e587d655f0a08bb$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== "string" || !name) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!options) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(name);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseAppImpl(options, config, container);
    $5e587d655f0a08bb$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $5e587d655f0a08bb$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $029952e65115eee5$export$4e09c449d6c407f7)() && !(0, $029952e65115eee5$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($5e587d655f0a08bb$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($5e587d655f0a08bb$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(nameString);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $5e587d655f0a08bb$export$f9962582c9e66d99(name = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    const app = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $5e587d655f0a08bb$export$9f30fa0c10967f7f && (0, $029952e65115eee5$export$3dfb6827a9f89756)()) return $5e587d655f0a08bb$export$c55cfd413944906d();
    if (!app) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $5e587d655f0a08bb$export$68ddedf7d44b3bdf() {
    return Array.from($5e587d655f0a08bb$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $5e587d655f0a08bb$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($5e587d655f0a08bb$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $5e587d655f0a08bb$export$b4e3c36c855b14b5.delete(name);
    } else if ($5e587d655f0a08bb$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $5e587d655f0a08bb$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $5e587d655f0a08bb$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $5e587d655f0a08bb$var$logger.warn(warning.join(" "));
        return;
    }
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $5e587d655f0a08bb$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $59d1e3b150b2f36d$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $5e587d655f0a08bb$export$c622e99c0ce7b1c9(logLevel) {
    (0, $59d1e3b150b2f36d$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$DB_NAME = "firebase-heartbeat-database";
const $5e587d655f0a08bb$var$DB_VERSION = 1;
const $5e587d655f0a08bb$var$STORE_NAME = "firebase-heartbeat-store";
let $5e587d655f0a08bb$var$dbPromise = null;
function $5e587d655f0a08bb$var$getDbPromise() {
    if (!$5e587d655f0a08bb$var$dbPromise) $5e587d655f0a08bb$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($5e587d655f0a08bb$var$DB_NAME, $5e587d655f0a08bb$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($5e587d655f0a08bb$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $5e587d655f0a08bb$var$dbPromise;
}
async function $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME);
        const result = await tx.objectStore($5e587d655f0a08bb$var$STORE_NAME).get($5e587d655f0a08bb$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
async function $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($5e587d655f0a08bb$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $5e587d655f0a08bb$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
function $5e587d655f0a08bb$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$MAX_HEADER_BYTES = 1024;
const $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $5e587d655f0a08bb$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $5e587d655f0a08bb$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $5e587d655f0a08bb$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $029952e65115eee5$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
            return "";
        }
    }
}
function $5e587d655f0a08bb$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $5e587d655f0a08bb$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $5e587d655f0a08bb$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $5e587d655f0a08bb$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return false;
        else return (0, $029952e65115eee5$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $5e587d655f0a08bb$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $029952e65115eee5$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5e587d655f0a08bb$var$registerCoreComponents(variant) {
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("platform-logger", (container)=>new $5e587d655f0a08bb$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("heartbeat", (container)=>new $5e587d655f0a08bb$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, "esm2020");
    // Register platform SDK identifier (no version).
    $5e587d655f0a08bb$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $5e587d655f0a08bb$var$registerCoreComponents("");


var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "12.2.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, "app");






/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$9e5f44173e64f162 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registered for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: "The supplied auth credential is incorrect, malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements.",
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $2f7f285d50ad74d4$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $2f7f285d50ad74d4$export$7f8ddf7c7c20b3cd = $2f7f285d50ad74d4$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $2f7f285d50ad74d4$export$9bb611d729802a56 = $2f7f285d50ad74d4$var$_prodErrorMap;
const $2f7f285d50ad74d4$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)("auth", "Firebase", $2f7f285d50ad74d4$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$b4171a6734a65d42 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type",
    INVALID_HOSTING_LINK_DOMAIN: "auth/invalid-hosting-link-domain"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$logClient = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)("@firebase/auth");
function $2f7f285d50ad74d4$var$_logWarn(msg, ...args) {
    if ($2f7f285d50ad74d4$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) $2f7f285d50ad74d4$var$logClient.warn(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $2f7f285d50ad74d4$var$_logError(msg, ...args) {
    if ($2f7f285d50ad74d4$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) $2f7f285d50ad74d4$var$logClient.error(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$export$28f7fcd39efa255(authOrCode, ...rest) {
    throw $2f7f285d50ad74d4$var$createErrorInternal(authOrCode, ...rest);
}
function $2f7f285d50ad74d4$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $2f7f285d50ad74d4$var$createErrorInternal(authOrCode, ...rest);
}
function $2f7f285d50ad74d4$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...$2f7f285d50ad74d4$export$9bb611d729802a56(),
        [code]: message
    };
    const factory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $2f7f285d50ad74d4$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function $2f7f285d50ad74d4$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $2f7f285d50ad74d4$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $2f7f285d50ad74d4$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $2f7f285d50ad74d4$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $2f7f285d50ad74d4$export$24baa2b76016ce0e(assertion, authOrCode, ...rest) {
    if (!assertion) throw $2f7f285d50ad74d4$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $2f7f285d50ad74d4$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $2f7f285d50ad74d4$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(assertion, message) {
    if (!assertion) $2f7f285d50ad74d4$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$_getCurrentUrl() {
    return typeof self !== "undefined" && self.location?.href || "";
}
function $2f7f285d50ad74d4$var$_isHttpOrHttps() {
    return $2f7f285d50ad74d4$var$_getCurrentScheme() === "http:" || $2f7f285d50ad74d4$var$_getCurrentScheme() === "https:";
}
function $2f7f285d50ad74d4$var$_getCurrentScheme() {
    return typeof self !== "undefined" && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $2f7f285d50ad74d4$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($2f7f285d50ad74d4$var$_isHttpOrHttps() || (0, $029952e65115eee5$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $2f7f285d50ad74d4$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $2f7f285d50ad74d4$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $029952e65115eee5$export$872f8323f01d7ae0)() || (0, $029952e65115eee5$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$2f7f285d50ad74d4$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$_emulatorUrl(config, path) {
    $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$export$f96d196f7728bb5 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== "undefined") return fetch;
        $2f7f285d50ad74d4$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== "undefined") return Headers;
        $2f7f285d50ad74d4$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
        if (typeof Response !== "undefined") return Response;
        $2f7f285d50ad74d4$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $2f7f285d50ad74d4$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $2f7f285d50ad74d4$var$DEFAULT_API_TIMEOUT_MS = new $2f7f285d50ad74d4$var$Delay(30000, 60000);
function $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function $2f7f285d50ad74d4$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $2f7f285d50ad74d4$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $029952e65115eee5$export$ac4103b836844853)({
            key: auth.config.apiKey,
            ...params
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method: method,
            headers: headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $029952e65115eee5$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = "no-referrer";
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) fetchArgs.credentials = "include";
        return $2f7f285d50ad74d4$export$f96d196f7728bb5.fetch()(await $2f7f285d50ad74d4$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $2f7f285d50ad74d4$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...$2f7f285d50ad74d4$var$SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new $2f7f285d50ad74d4$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $2f7f285d50ad74d4$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $2f7f285d50ad74d4$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $2f7f285d50ad74d4$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $2f7f285d50ad74d4$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $2f7f285d50ad74d4$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $2f7f285d50ad74d4$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $2f7f285d50ad74d4$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $2f7f285d50ad74d4$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $2f7f285d50ad74d4$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($2f7f285d50ad74d4$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $2f7f285d50ad74d4$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $2f7f285d50ad74d4$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($2f7f285d50ad74d4$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $2f7f285d50ad74d4$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $2f7f285d50ad74d4$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $2f7f285d50ad74d4$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $2f7f285d50ad74d4$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $2f7f285d50ad74d4$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $2f7f285d50ad74d4$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$getRecaptchaParams(auth) {
    return (await $2f7f285d50ad74d4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $2f7f285d50ad74d4$var$getRecaptchaConfig(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$deleteAccount(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $2f7f285d50ad74d4$var$deleteLinkedAccounts(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $2f7f285d50ad74d4$var$getAccountInfo(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$7a38258bbe170828(user, forceRefresh = false) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$2f6ca3d3b1f80bf5(user, forceRefresh = false) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $2f7f285d50ad74d4$var$_parseToken(token);
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase?.["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $2f7f285d50ad74d4$var$utcTimestampToDateString($2f7f285d50ad74d4$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $2f7f285d50ad74d4$var$utcTimestampToDateString($2f7f285d50ad74d4$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $2f7f285d50ad74d4$var$utcTimestampToDateString($2f7f285d50ad74d4$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.["sign_in_second_factor"] || null
    };
}
function $2f7f285d50ad74d4$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $2f7f285d50ad74d4$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $2f7f285d50ad74d4$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $029952e65115eee5$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $2f7f285d50ad74d4$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $2f7f285d50ad74d4$var$_logError("Caught error parsing JWT payload as JSON", e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $2f7f285d50ad74d4$var$_tokenExpiresIn(token) {
    const parsedToken = $2f7f285d50ad74d4$var$_parseToken(token);
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56) && $2f7f285d50ad74d4$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $2f7f285d50ad74d4$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $2f7f285d50ad74d4$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $2f7f285d50ad74d4$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$_reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(user, $2f7f285d50ad74d4$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? $2f7f285d50ad74d4$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $2f7f285d50ad74d4$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $2f7f285d50ad74d4$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$6554612db691658e(user) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $2f7f285d50ad74d4$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $2f7f285d50ad74d4$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $2f7f285d50ad74d4$var$extractProviderData(providers) {
    return providers.map(({ providerId: providerId, ...provider })=>{
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$requestStsToken(auth, refreshToken) {
    const response = await $2f7f285d50ad74d4$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $029952e65115eee5$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $2f7f285d50ad74d4$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) options.credentials = "include";
        return $2f7f285d50ad74d4$export$f96d196f7728bb5.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $2f7f285d50ad74d4$var$revokeToken(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $2f7f285d50ad74d4$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $2f7f285d50ad74d4$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $2f7f285d50ad74d4$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $2f7f285d50ad74d4$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $2f7f285d50ad74d4$var$StsTokenManager();
        if (refreshToken) {
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $2f7f285d50ad74d4$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $2f7f285d50ad74d4$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$assertStringOrUndefined(assertion, appName) {
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $2f7f285d50ad74d4$export$91477dc880baac21 {
    constructor({ uid: uid, auth: auth, stsTokenManager: stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $2f7f285d50ad74d4$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $2f7f285d50ad74d4$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $2f7f285d50ad74d4$export$2f6ca3d3b1f80bf5(this, forceRefresh);
    }
    reload() {
        return $2f7f285d50ad74d4$export$6554612db691658e(this);
    }
    _assign(user) {
        if (this === user) return;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $2f7f285d50ad74d4$export$91477dc880baac21({
            ...this,
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $2f7f285d50ad74d4$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $2f7f285d50ad74d4$var$_logoutIfInvalidated(this, $2f7f285d50ad74d4$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $2f7f285d50ad74d4$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $2f7f285d50ad74d4$var$assertStringOrUndefined(displayName, auth.name);
        $2f7f285d50ad74d4$var$assertStringOrUndefined(email, auth.name);
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $2f7f285d50ad74d4$var$assertStringOrUndefined(phoneNumber, auth.name);
        $2f7f285d50ad74d4$var$assertStringOrUndefined(photoURL, auth.name);
        $2f7f285d50ad74d4$var$assertStringOrUndefined(tenantId, auth.name);
        $2f7f285d50ad74d4$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $2f7f285d50ad74d4$var$assertStringOrUndefined(createdAt, auth.name);
        $2f7f285d50ad74d4$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $2f7f285d50ad74d4$export$91477dc880baac21({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $2f7f285d50ad74d4$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $2f7f285d50ad74d4$export$91477dc880baac21({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $2f7f285d50ad74d4$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $2f7f285d50ad74d4$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new $2f7f285d50ad74d4$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $2f7f285d50ad74d4$export$91477dc880baac21({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $2f7f285d50ad74d4$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$instanceCache = new Map();
function $2f7f285d50ad74d4$export$cf2f7c5792f80b46(cls) {
    $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(cls instanceof Function, "Expected a class definition");
    let instance = $2f7f285d50ad74d4$var$instanceCache.get(cls);
    if (instance) {
        $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $2f7f285d50ad74d4$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$2f7f285d50ad74d4$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$e7c866399fa523f5 = $2f7f285d50ad74d4$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $2f7f285d50ad74d4$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $2f7f285d50ad74d4$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $2f7f285d50ad74d4$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === "string") {
            const response = await $2f7f285d50ad74d4$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $2f7f285d50ad74d4$export$91477dc880baac21._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $2f7f285d50ad74d4$export$91477dc880baac21._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $2f7f285d50ad74d4$var$PersistenceUserManager($2f7f285d50ad74d4$export$cf2f7c5792f80b46($2f7f285d50ad74d4$export$e7c866399fa523f5), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $2f7f285d50ad74d4$export$cf2f7c5792f80b46($2f7f285d50ad74d4$export$e7c866399fa523f5);
        const key = $2f7f285d50ad74d4$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === "string") {
                    const response = await $2f7f285d50ad74d4$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $2f7f285d50ad74d4$export$91477dc880baac21._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $2f7f285d50ad74d4$export$91477dc880baac21._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $2f7f285d50ad74d4$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new $2f7f285d50ad74d4$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $2f7f285d50ad74d4$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($2f7f285d50ad74d4$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($2f7f285d50ad74d4$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($2f7f285d50ad74d4$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($2f7f285d50ad74d4$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($2f7f285d50ad74d4$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $2f7f285d50ad74d4$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($2f7f285d50ad74d4$export$9fa96a7d116ea3ce(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $2f7f285d50ad74d4$var$_isFirefox(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $2f7f285d50ad74d4$var$_isSafari(userAgent = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $2f7f285d50ad74d4$var$_isChromeIOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $2f7f285d50ad74d4$var$_isIEMobile(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $2f7f285d50ad74d4$export$9fa96a7d116ea3ce(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $2f7f285d50ad74d4$var$_isBlackBerry(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $2f7f285d50ad74d4$var$_isWebOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $2f7f285d50ad74d4$export$92108d983e8ee699(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $2f7f285d50ad74d4$export$9d398bebfec1c039(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $2f7f285d50ad74d4$var$_isIOSStandalone(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return $2f7f285d50ad74d4$export$92108d983e8ee699(ua) && !!window.navigator?.standalone;
}
function $2f7f285d50ad74d4$var$_isIE10() {
    return (0, $029952e65115eee5$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $2f7f285d50ad74d4$var$_isMobileBrowser(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $2f7f285d50ad74d4$export$92108d983e8ee699(ua) || $2f7f285d50ad74d4$export$9fa96a7d116ea3ce(ua) || $2f7f285d50ad74d4$var$_isWebOS(ua) || $2f7f285d50ad74d4$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $2f7f285d50ad74d4$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $2f7f285d50ad74d4$export$faec65b429be379(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $2f7f285d50ad74d4$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$2f7f285d50ad74d4$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $5e587d655f0a08bb$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $2f7f285d50ad74d4$var$_getPasswordPolicy(auth, request = {}) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $2f7f285d50ad74d4$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $2f7f285d50ad74d4$var$PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? $2f7f285d50ad74d4$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join("") ?? "";
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$export$9f4f30ee63539e24 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $2f7f285d50ad74d4$var$Subscription(this);
        this.idTokenSubscription = new $2f7f285d50ad74d4$var$Subscription(this);
        this.beforeStateQueue = new $2f7f285d50ad74d4$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $2f7f285d50ad74d4$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $2f7f285d50ad74d4$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await $2f7f285d50ad74d4$var$PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $2f7f285d50ad74d4$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $2f7f285d50ad74d4$export$91477dc880baac21._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn("FirebaseServerApp could not login user with provided authIdToken: ", err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $2f7f285d50ad74d4$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $2f7f285d50ad74d4$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $029952e65115eee5$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $2f7f285d50ad74d4$export$24baa2b76016ce0e(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($2f7f285d50ad74d4$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $2f7f285d50ad74d4$var$_getPasswordPolicy(this);
        const passwordPolicy = new $2f7f285d50ad74d4$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: "apple.com",
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $2f7f285d50ad74d4$var$revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $2f7f285d50ad74d4$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $2f7f285d50ad74d4$var$PersistenceUserManager.create(this, [
                $2f7f285d50ad74d4$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $2f7f285d50ad74d4$export$faec65b429be379(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $2f7f285d50ad74d4$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $2f7f285d50ad74d4$export$23ebac1979863676(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $2f7f285d50ad74d4$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $029952e65115eee5$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $2f7f285d50ad74d4$var$externalJSProvider = {
    async loadJS () {
        throw new Error("Unable to load external scripts");
    },
    recaptchaV2Script: "",
    recaptchaEnterpriseScript: "",
    gapiScript: ""
};
function $2f7f285d50ad74d4$var$_setExternalJSProvider(p) {
    $2f7f285d50ad74d4$var$externalJSProvider = p;
}
function $2f7f285d50ad74d4$var$_loadJS(url) {
    return $2f7f285d50ad74d4$var$externalJSProvider.loadJS(url);
}
function $2f7f285d50ad74d4$var$_recaptchaV2ScriptUrl() {
    return $2f7f285d50ad74d4$var$externalJSProvider.recaptchaV2Script;
}
function $2f7f285d50ad74d4$var$_recaptchaEnterpriseScriptUrl() {
    return $2f7f285d50ad74d4$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $2f7f285d50ad74d4$var$_gapiScriptUrl() {
    return $2f7f285d50ad74d4$var$externalJSProvider.gapiScript;
}
function $2f7f285d50ad74d4$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$_SOLVE_TIME_MS = 500;
const $2f7f285d50ad74d4$var$_EXPIRATION_TIME_MS = 60000;
const $2f7f285d50ad74d4$var$_WIDGET_ID_START = 1000000000000;
class $2f7f285d50ad74d4$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $2f7f285d50ad74d4$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $2f7f285d50ad74d4$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || $2f7f285d50ad74d4$var$_WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || $2f7f285d50ad74d4$var$_WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || "";
    }
    async execute(optWidgetId) {
        const id = optWidgetId || $2f7f285d50ad74d4$var$_WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return "";
    }
}
class $2f7f285d50ad74d4$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $2f7f285d50ad74d4$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve("token");
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return "";
    }
}
class $2f7f285d50ad74d4$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve("token");
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return "";
    }
}
class $2f7f285d50ad74d4$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $2f7f285d50ad74d4$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $2f7f285d50ad74d4$var$_EXPIRATION_TIME_MS);
        }, $2f7f285d50ad74d4$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $2f7f285d50ad74d4$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $2f7f285d50ad74d4$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $2f7f285d50ad74d4$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $2f7f285d50ad74d4$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $2f7f285d50ad74d4$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $2f7f285d50ad74d4$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $2f7f285d50ad74d4$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $2f7f285d50ad74d4$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($2f7f285d50ad74d4$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($2f7f285d50ad74d4$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $2f7f285d50ad74d4$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute("siteKey", {
                action: "verify"
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $2f7f285d50ad74d4$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    let url = $2f7f285d50ad74d4$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $2f7f285d50ad74d4$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $2f7f285d50ad74d4$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $2f7f285d50ad74d4$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $2f7f285d50ad74d4$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ("phoneEnrollmentInfo" in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                "phoneEnrollmentInfo": {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ("phoneSignInInfo" in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                "phoneSignInInfo": {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $2f7f285d50ad74d4$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $2f7f285d50ad74d4$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $2f7f285d50ad74d4$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $2f7f285d50ad74d4$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $2f7f285d50ad74d4$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $2f7f285d50ad74d4$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + " provider is not supported.");
}
async function $2f7f285d50ad74d4$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    const response = await $2f7f285d50ad74d4$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $2f7f285d50ad74d4$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $2f7f285d50ad74d4$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $2f7f285d50ad74d4$export$3466f893ebf79586(app, deps) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(initialOptions, deps ?? {})) return auth;
        else $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $2f7f285d50ad74d4$var$_initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($2f7f285d50ad74d4$export$cf2f7c5792f80b46);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$61196ced6d74a310(auth, url, options) {
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = $2f7f285d50ad74d4$var$extractProtocol(url);
    const { host: host, port: port } = $2f7f285d50ad74d4$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $2f7f285d50ad74d4$export$24baa2b76016ce0e((0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulator, authInternal.config.emulator) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $029952e65115eee5$export$5b4d24b45140ad90)(host)) {
        (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`${protocol}//${host}${portStr}`);
        (0, $029952e65115eee5$export$fd3d2954543183b1)("Auth", true);
    } else if (!disableWarnings) $2f7f285d50ad74d4$var$emitEmulatorWarning();
}
function $2f7f285d50ad74d4$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $2f7f285d50ad74d4$var$extractHostAndPort(url) {
    const protocol = $2f7f285d50ad74d4$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $2f7f285d50ad74d4$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $2f7f285d50ad74d4$var$parsePort(port)
        };
    }
}
function $2f7f285d50ad74d4$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $2f7f285d50ad74d4$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $2f7f285d50ad74d4$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $2f7f285d50ad74d4$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $2f7f285d50ad74d4$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $2f7f285d50ad74d4$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$resetPassword(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
async function $2f7f285d50ad74d4$var$updateEmailPassword(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $2f7f285d50ad74d4$var$linkEmailPassword(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $2f7f285d50ad74d4$var$applyActionCode$1(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$signInWithPassword(auth, request) {
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
async function $2f7f285d50ad74d4$var$sendOobCode(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
async function $2f7f285d50ad74d4$var$sendEmailVerification$1(auth, request) {
    return $2f7f285d50ad74d4$var$sendOobCode(auth, request);
}
async function $2f7f285d50ad74d4$var$sendPasswordResetEmail$1(auth, request) {
    return $2f7f285d50ad74d4$var$sendOobCode(auth, request);
}
async function $2f7f285d50ad74d4$var$sendSignInLinkToEmail$1(auth, request) {
    return $2f7f285d50ad74d4$var$sendOobCode(auth, request);
}
async function $2f7f285d50ad74d4$var$verifyAndChangeEmail(auth, request) {
    return $2f7f285d50ad74d4$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$signInWithEmailLink$1(auth, request) {
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
async function $2f7f285d50ad74d4$var$signInWithEmailLinkForLinking(auth, request) {
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$a07804094c3ecf2d extends $2f7f285d50ad74d4$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $2f7f285d50ad74d4$export$a07804094c3ecf2d(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $2f7f285d50ad74d4$export$a07804094c3ecf2d(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $2f7f285d50ad74d4$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $2f7f285d50ad74d4$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $2f7f285d50ad74d4$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $2f7f285d50ad74d4$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $2f7f285d50ad74d4$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $2f7f285d50ad74d4$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$signInWithIdp(auth, request) {
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$3722cfe417b6ed86 extends $2f7f285d50ad74d4$export$3a1a48c8f6ef640e {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $2f7f285d50ad74d4$export$3722cfe417b6ed86(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $2f7f285d50ad74d4$export$28f7fcd39efa255("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new $2f7f285d50ad74d4$export$3722cfe417b6ed86(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $2f7f285d50ad74d4$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $029952e65115eee5$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$sendPhoneVerificationCode(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
async function $2f7f285d50ad74d4$var$signInWithPhoneNumber$1(auth, request) {
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
async function $2f7f285d50ad74d4$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $2f7f285d50ad74d4$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $2f7f285d50ad74d4$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $2f7f285d50ad74d4$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: "REAUTH"
    };
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, apiRequest), $2f7f285d50ad74d4$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$3a6d5c9ae78a2c08 extends $2f7f285d50ad74d4$export$3a1a48c8f6ef640e {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $2f7f285d50ad74d4$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $2f7f285d50ad74d4$export$3a6d5c9ae78a2c08({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $2f7f285d50ad74d4$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $2f7f285d50ad74d4$var$linkWithPhoneNumber$1(auth, {
            idToken: idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $2f7f285d50ad74d4$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $2f7f285d50ad74d4$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $2f7f285d50ad74d4$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $2f7f285d50ad74d4$var$parseDeepLink(url) {
    const link = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$3b513254972cfc9c {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = $2f7f285d50ad74d4$var$parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $2f7f285d50ad74d4$var$parseDeepLink(link);
        try {
            return new $2f7f285d50ad74d4$export$3b513254972cfc9c(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$21579262ef46735b(link) {
    return $2f7f285d50ad74d4$export$3b513254972cfc9c.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$71cec2538cb2c617 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $2f7f285d50ad74d4$export$71cec2538cb2c617.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $2f7f285d50ad74d4$export$a07804094c3ecf2d._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $2f7f285d50ad74d4$export$3b513254972cfc9c.parseLink(emailLink);
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $2f7f285d50ad74d4$export$a07804094c3ecf2d._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $2f7f285d50ad74d4$export$71cec2538cb2c617.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $2f7f285d50ad74d4$export$71cec2538cb2c617.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $2f7f285d50ad74d4$export$71cec2538cb2c617.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $2f7f285d50ad74d4$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $2f7f285d50ad74d4$var$BaseOAuthProvider extends $2f7f285d50ad74d4$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $2f7f285d50ad74d4$export$71511d61b312f219 extends $2f7f285d50ad74d4$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $2f7f285d50ad74d4$export$3722cfe417b6ed86._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $2f7f285d50ad74d4$export$3722cfe417b6ed86._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $2f7f285d50ad74d4$export$71511d61b312f219.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $2f7f285d50ad74d4$export$71511d61b312f219.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $2f7f285d50ad74d4$export$71511d61b312f219(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $2f7f285d50ad74d4$export$78acf4525d8a74c4 extends $2f7f285d50ad74d4$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $2f7f285d50ad74d4$export$3722cfe417b6ed86._fromParams({
            providerId: $2f7f285d50ad74d4$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $2f7f285d50ad74d4$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $2f7f285d50ad74d4$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $2f7f285d50ad74d4$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $2f7f285d50ad74d4$export$78acf4525d8a74c4.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $2f7f285d50ad74d4$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $2f7f285d50ad74d4$export$78acf4525d8a74c4.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $2f7f285d50ad74d4$export$8743009a87fcb00f extends $2f7f285d50ad74d4$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $2f7f285d50ad74d4$export$3722cfe417b6ed86._fromParams({
            providerId: $2f7f285d50ad74d4$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $2f7f285d50ad74d4$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $2f7f285d50ad74d4$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $2f7f285d50ad74d4$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $2f7f285d50ad74d4$export$8743009a87fcb00f.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $2f7f285d50ad74d4$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $2f7f285d50ad74d4$export$8743009a87fcb00f.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $2f7f285d50ad74d4$export$dc98b0b04f4c7758 extends $2f7f285d50ad74d4$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $2f7f285d50ad74d4$export$3722cfe417b6ed86._fromParams({
            providerId: $2f7f285d50ad74d4$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $2f7f285d50ad74d4$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $2f7f285d50ad74d4$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $2f7f285d50ad74d4$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $2f7f285d50ad74d4$export$dc98b0b04f4c7758.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $2f7f285d50ad74d4$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $2f7f285d50ad74d4$export$dc98b0b04f4c7758.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $2f7f285d50ad74d4$export$738ab4df8bf92ae9 extends $2f7f285d50ad74d4$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $2f7f285d50ad74d4$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $2f7f285d50ad74d4$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $2f7f285d50ad74d4$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$3d8c2f653ac9d0b9 extends $2f7f285d50ad74d4$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(providerId.startsWith($2f7f285d50ad74d4$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $2f7f285d50ad74d4$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $2f7f285d50ad74d4$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $2f7f285d50ad74d4$export$738ab4df8bf92ae9.fromJSON(json);
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $2f7f285d50ad74d4$export$738ab4df8bf92ae9._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $2f7f285d50ad74d4$export$34aec0b863436764 extends $2f7f285d50ad74d4$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $2f7f285d50ad74d4$export$3722cfe417b6ed86._fromParams({
            providerId: $2f7f285d50ad74d4$export$34aec0b863436764.PROVIDER_ID,
            signInMethod: $2f7f285d50ad74d4$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $2f7f285d50ad74d4$export$34aec0b863436764.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $2f7f285d50ad74d4$export$34aec0b863436764.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $2f7f285d50ad74d4$export$34aec0b863436764.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $2f7f285d50ad74d4$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $2f7f285d50ad74d4$export$34aec0b863436764.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$signUp(auth, request) {
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $2f7f285d50ad74d4$export$91477dc880baac21._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $2f7f285d50ad74d4$var$providerIdForResponse(idTokenResponse);
        const userCred = new $2f7f285d50ad74d4$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $2f7f285d50ad74d4$var$providerIdForResponse(response);
        return new $2f7f285d50ad74d4$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $2f7f285d50ad74d4$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$3c2fa207a37baaea(auth) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $2f7f285d50ad74d4$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $2f7f285d50ad74d4$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $2f7f285d50ad74d4$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$MultiFactorError extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2f7f285d50ad74d4$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $2f7f285d50ad74d4$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $2f7f285d50ad74d4$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $2f7f285d50ad74d4$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $2f7f285d50ad74d4$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$8a5498727ef6be21(user, providerId) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $2f7f285d50ad74d4$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $2f7f285d50ad74d4$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $2f7f285d50ad74d4$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $2f7f285d50ad74d4$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $2f7f285d50ad74d4$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $2f7f285d50ad74d4$var$_assertLinkedStatus(expected, user, provider) {
    await $2f7f285d50ad74d4$var$_reloadWithoutSaving(user);
    const providerIds = $2f7f285d50ad74d4$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(user, $2f7f285d50ad74d4$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $2f7f285d50ad74d4$var$_parseToken(response.idToken);
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $2f7f285d50ad74d4$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $2f7f285d50ad74d4$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $2f7f285d50ad74d4$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$ce26c07117d59d6a(auth, credential) {
    return $2f7f285d50ad74d4$var$_signInWithCredential($2f7f285d50ad74d4$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$6559d589eb85fbb6(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $2f7f285d50ad74d4$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $2f7f285d50ad74d4$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$efca4cbe5dd06740(user, credential) {
    return $2f7f285d50ad74d4$var$_reauthenticate((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$signInWithCustomToken$1(auth, request) {
    return $2f7f285d50ad74d4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$a8550f7dbe79f93a(auth, customToken) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    const response = await $2f7f285d50ad74d4$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $2f7f285d50ad74d4$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $2f7f285d50ad74d4$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $2f7f285d50ad74d4$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $2f7f285d50ad74d4$var$PhoneMultiFactorInfoImpl extends $2f7f285d50ad74d4$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $2f7f285d50ad74d4$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $2f7f285d50ad74d4$var$TotpMultiFactorInfoImpl extends $2f7f285d50ad74d4$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $2f7f285d50ad74d4$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof actionCodeSettings.linkDomain === "undefined" || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $2f7f285d50ad74d4$var$recachePasswordPolicy(auth) {
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$2e2af4578d910ddf(auth, email, actionCodeSettings) {
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $2f7f285d50ad74d4$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $2f7f285d50ad74d4$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $2f7f285d50ad74d4$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$a93c5207d687da10(auth, oobCode, newPassword) {
    await $2f7f285d50ad74d4$var$resetPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $2f7f285d50ad74d4$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$c3950d9923825c02(auth, oobCode) {
    await $2f7f285d50ad74d4$var$applyActionCode$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$a9c996f45e5784d0(auth, oobCode) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const response = await $2f7f285d50ad74d4$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $2f7f285d50ad74d4$var$MultiFactorInfoImpl._fromServerResponse($2f7f285d50ad74d4$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$7910e0436ed8d1de(auth, code) {
    const { data: data } = await $2f7f285d50ad74d4$export$a9c996f45e5784d0((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$555508cbc6add439(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $2f7f285d50ad74d4$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $2f7f285d50ad74d4$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $2f7f285d50ad74d4$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $2f7f285d50ad74d4$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$2219238a014317b0(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $2f7f285d50ad74d4$export$ce26c07117d59d6a((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), $2f7f285d50ad74d4$export$71cec2538cb2c617.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $2f7f285d50ad74d4$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$4c3d22f3d993c33f(auth, email, actionCodeSettings) {
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $2f7f285d50ad74d4$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $2f7f285d50ad74d4$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $2f7f285d50ad74d4$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$f787f51d84a910ad(auth, emailLink) {
    const actionCodeUrl = $2f7f285d50ad74d4$export$3b513254972cfc9c.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$c9170ad7d4cd7e57(auth, email, emailLink) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const credential = $2f7f285d50ad74d4$export$71cec2538cb2c617.credentialWithLink(email, emailLink || $2f7f285d50ad74d4$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $2f7f285d50ad74d4$export$ce26c07117d59d6a(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$createAuthUri(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $2f7f285d50ad74d4$export$ee7c8ad385a60b7b(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $2f7f285d50ad74d4$var$_isHttpOrHttps() ? $2f7f285d50ad74d4$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $2f7f285d50ad74d4$var$createAuthUri((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$995eb9fca571757(user, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $2f7f285d50ad74d4$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $2f7f285d50ad74d4$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$f38c853ae54ed474(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $2f7f285d50ad74d4$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $2f7f285d50ad74d4$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$var$updateProfile$1(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$ab83b03e4111b1d0(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(userInternal, $2f7f285d50ad74d4$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$1a82df3d29112e01(user, newEmail) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $2f7f285d50ad74d4$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$306ddfe3a8403e2(user, newPassword) {
    return $2f7f285d50ad74d4$var$updateEmailOrPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $2f7f285d50ad74d4$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(user, $2f7f285d50ad74d4$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $2f7f285d50ad74d4$var$_fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = $2f7f285d50ad74d4$var$_parseToken(idTokenResponse.idToken)?.firebase?.["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $2f7f285d50ad74d4$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $2f7f285d50ad74d4$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $2f7f285d50ad74d4$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $2f7f285d50ad74d4$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $2f7f285d50ad74d4$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $2f7f285d50ad74d4$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $2f7f285d50ad74d4$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $2f7f285d50ad74d4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $2f7f285d50ad74d4$var$FederatedAdditionalUserInfoWithUsername extends $2f7f285d50ad74d4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $2f7f285d50ad74d4$var$FacebookAdditionalUserInfo extends $2f7f285d50ad74d4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $2f7f285d50ad74d4$var$GithubAdditionalUserInfo extends $2f7f285d50ad74d4$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === "string" ? profile?.login : null);
    }
}
class $2f7f285d50ad74d4$var$GoogleAdditionalUserInfo extends $2f7f285d50ad74d4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $2f7f285d50ad74d4$var$TwitterAdditionalUserInfo extends $2f7f285d50ad74d4$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$d24c54395ce0c509(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $2f7f285d50ad74d4$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $2f7f285d50ad74d4$export$625550452a3fa3ec(auth, persistence) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$90a7f3efeed30595(auth) {
    return $2f7f285d50ad74d4$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$efccba1c4a2ef57b(auth, password) {
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $2f7f285d50ad74d4$export$4a5767248b18ef41(auth, callback, onAbort) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$df995fae86a55f06(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$ef35774e6d314e91(auth) {
    (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$e7094788287c5e9b(auth, user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$96f57966bedc81b4(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$a9c23c6ac3fc3eca(auth, token) {
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$2329c99376c9d0a4(user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $2f7f285d50ad74d4$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $2f7f285d50ad74d4$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return $2f7f285d50ad74d4$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return $2f7f285d50ad74d4$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $2f7f285d50ad74d4$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$2f7f285d50ad74d4$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $2f7f285d50ad74d4$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $2f7f285d50ad74d4$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $2f7f285d50ad74d4$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $2f7f285d50ad74d4$export$24baa2b76016ce0e(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $2f7f285d50ad74d4$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$493d36ec626b6698(auth, error) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $2f7f285d50ad74d4$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$startEnrollPhoneMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
function $2f7f285d50ad74d4$var$finalizeEnrollPhoneMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
function $2f7f285d50ad74d4$var$startEnrollTotpMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
function $2f7f285d50ad74d4$var$finalizeEnrollTotpMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
function $2f7f285d50ad74d4$var$withdrawMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
class $2f7f285d50ad74d4$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$2f7f285d50ad74d4$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $2f7f285d50ad74d4$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $2f7f285d50ad74d4$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $2f7f285d50ad74d4$var$_logoutIfInvalidated(this.user, $2f7f285d50ad74d4$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $2f7f285d50ad74d4$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$1fbe638ecf81657e(user) {
    const userModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if (!$2f7f285d50ad74d4$var$multiFactorUserCache.has(userModular)) $2f7f285d50ad74d4$var$multiFactorUserCache.set(userModular, $2f7f285d50ad74d4$var$MultiFactorUserImpl._fromUser(userModular));
    return $2f7f285d50ad74d4$var$multiFactorUserCache.get(userModular);
}
const $2f7f285d50ad74d4$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $2f7f285d50ad74d4$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($2f7f285d50ad74d4$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($2f7f285d50ad74d4$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $2f7f285d50ad74d4$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $2f7f285d50ad74d4$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $2f7f285d50ad74d4$var$BrowserLocalPersistence extends $2f7f285d50ad74d4$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $2f7f285d50ad74d4$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($2f7f285d50ad74d4$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $2f7f285d50ad74d4$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $2f7f285d50ad74d4$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$2f7f285d50ad74d4$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$8b22cf2602fb60ce = $2f7f285d50ad74d4$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $2f7f285d50ad74d4$var$getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function $2f7f285d50ad74d4$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === "http:";
    return `${isDevMode ? "__dev_" : "__HOST-"}FIREBASE_${key.split(":")[3]}`;
}
class $2f7f285d50ad74d4$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set("finalTarget", originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === "boolean" && !isSecureContext) return false;
        if (typeof navigator === "undefined" || typeof document === "undefined") return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $2f7f285d50ad74d4$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return $2f7f285d50ad74d4$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $2f7f285d50ad74d4$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: "DELETE"
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $2f7f285d50ad74d4$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener("change", cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener("change", cb);
        }
        let lastValue = $2f7f285d50ad74d4$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $2f7f285d50ad74d4$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $2f7f285d50ad74d4$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$2f7f285d50ad74d4$var$CookiePersistence.type = "COOKIE";
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $2f7f285d50ad74d4$export$407448d2b89b1813 = $2f7f285d50ad74d4$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$BrowserSessionPersistence extends $2f7f285d50ad74d4$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$2f7f285d50ad74d4$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$db3b6bfb95261072 = $2f7f285d50ad74d4$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $2f7f285d50ad74d4$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $2f7f285d50ad74d4$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $2f7f285d50ad74d4$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $2f7f285d50ad74d4$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$2f7f285d50ad74d4$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$export$c03999cb2f36933f(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $2f7f285d50ad74d4$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $2f7f285d50ad74d4$export$c03999cb2f36933f("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $2f7f285d50ad74d4$var$_window() {
    return window;
}
function $2f7f285d50ad74d4$var$_setWindowLocation(url) {
    $2f7f285d50ad74d4$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$_isWorker() {
    return typeof $2f7f285d50ad74d4$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $2f7f285d50ad74d4$var$_window()["importScripts"] === "function";
}
async function $2f7f285d50ad74d4$var$_getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function $2f7f285d50ad74d4$var$_getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function $2f7f285d50ad74d4$var$_getWorkerGlobalScope() {
    return $2f7f285d50ad74d4$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$DB_NAME = "firebaseLocalStorageDb";
const $2f7f285d50ad74d4$var$DB_VERSION = 1;
const $2f7f285d50ad74d4$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $2f7f285d50ad74d4$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $2f7f285d50ad74d4$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $2f7f285d50ad74d4$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $2f7f285d50ad74d4$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($2f7f285d50ad74d4$var$DB_OBJECTSTORE_NAME);
}
function $2f7f285d50ad74d4$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($2f7f285d50ad74d4$var$DB_NAME);
    return new $2f7f285d50ad74d4$var$DBPromise(request).toPromise();
}
function $2f7f285d50ad74d4$var$_openDatabase() {
    const request = indexedDB.open($2f7f285d50ad74d4$var$DB_NAME, $2f7f285d50ad74d4$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($2f7f285d50ad74d4$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $2f7f285d50ad74d4$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($2f7f285d50ad74d4$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $2f7f285d50ad74d4$var$_deleteDatabase();
                resolve(await $2f7f285d50ad74d4$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $2f7f285d50ad74d4$var$_putObject(db, key, value) {
    const request = $2f7f285d50ad74d4$var$getObjectStore(db, true).put({
        [$2f7f285d50ad74d4$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $2f7f285d50ad74d4$var$DBPromise(request).toPromise();
}
async function $2f7f285d50ad74d4$var$getObject(db, key) {
    const request = $2f7f285d50ad74d4$var$getObjectStore(db, false).get(key);
    const data = await new $2f7f285d50ad74d4$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $2f7f285d50ad74d4$var$_deleteObject(db, key) {
    const request = $2f7f285d50ad74d4$var$getObjectStore(db, true).delete(key);
    return new $2f7f285d50ad74d4$var$DBPromise(request).toPromise();
}
const $2f7f285d50ad74d4$var$_POLLING_INTERVAL_MS = 800;
const $2f7f285d50ad74d4$var$_TRANSACTION_RETRY_COUNT = 3;
class $2f7f285d50ad74d4$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $2f7f285d50ad74d4$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $2f7f285d50ad74d4$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $2f7f285d50ad74d4$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $2f7f285d50ad74d4$var$Receiver._getInstance($2f7f285d50ad74d4$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $2f7f285d50ad74d4$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $2f7f285d50ad74d4$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $2f7f285d50ad74d4$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $2f7f285d50ad74d4$var$_openDatabase();
            await $2f7f285d50ad74d4$var$_putObject(db, $2f7f285d50ad74d4$var$STORAGE_AVAILABLE_KEY, "1");
            await $2f7f285d50ad74d4$var$_deleteObject(db, $2f7f285d50ad74d4$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$2f7f285d50ad74d4$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$2f7f285d50ad74d4$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$2f7f285d50ad74d4$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $2f7f285d50ad74d4$var$getObjectStore(db, false).getAll();
            return new $2f7f285d50ad74d4$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $2f7f285d50ad74d4$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$2f7f285d50ad74d4$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$23f2a1d2818174ef = $2f7f285d50ad74d4$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$startSignInPhoneMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
function $2f7f285d50ad74d4$var$finalizeSignInPhoneMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
function $2f7f285d50ad74d4$var$finalizeSignInTotpMfa(auth, request) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $2f7f285d50ad74d4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $2f7f285d50ad74d4$var$_JSLOAD_CALLBACK = $2f7f285d50ad74d4$var$_generateCallbackName("rcb");
const $2f7f285d50ad74d4$var$NETWORK_TIMEOUT_DELAY = new $2f7f285d50ad74d4$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $2f7f285d50ad74d4$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!$2f7f285d50ad74d4$var$_window().grecaptcha?.render;
    }
    load(auth, hl = "") {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e($2f7f285d50ad74d4$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $2f7f285d50ad74d4$var$isV2($2f7f285d50ad74d4$var$_window().grecaptcha)) return Promise.resolve($2f7f285d50ad74d4$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $2f7f285d50ad74d4$var$_window().setTimeout(()=>{
                reject($2f7f285d50ad74d4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $2f7f285d50ad74d4$var$NETWORK_TIMEOUT_DELAY.get());
            $2f7f285d50ad74d4$var$_window()[$2f7f285d50ad74d4$var$_JSLOAD_CALLBACK] = ()=>{
                $2f7f285d50ad74d4$var$_window().clearTimeout(networkTimeout);
                delete $2f7f285d50ad74d4$var$_window()[$2f7f285d50ad74d4$var$_JSLOAD_CALLBACK];
                const recaptcha = $2f7f285d50ad74d4$var$_window().grecaptcha;
                if (!recaptcha || !$2f7f285d50ad74d4$var$isV2(recaptcha)) {
                    reject($2f7f285d50ad74d4$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$2f7f285d50ad74d4$var$_recaptchaV2ScriptUrl()}?${(0, $029952e65115eee5$export$ac4103b836844853)({
                onload: $2f7f285d50ad74d4$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $2f7f285d50ad74d4$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($2f7f285d50ad74d4$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$2f7f285d50ad74d4$var$_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $2f7f285d50ad74d4$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $2f7f285d50ad74d4$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $2f7f285d50ad74d4$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $2f7f285d50ad74d4$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...$2f7f285d50ad74d4$var$DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $2f7f285d50ad74d4$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $2f7f285d50ad74d4$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $2f7f285d50ad74d4$var$MockReCaptchaLoaderImpl() : new $2f7f285d50ad74d4$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $2f7f285d50ad74d4$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e($2f7f285d50ad74d4$var$_isHttpOrHttps() && !$2f7f285d50ad74d4$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $2f7f285d50ad74d4$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $2f7f285d50ad74d4$var$getRecaptchaParams(this.auth);
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $2f7f285d50ad74d4$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $2f7f285d50ad74d4$export$3a6d5c9ae78a2c08._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    const verificationId = await $2f7f285d50ad74d4$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $2f7f285d50ad74d4$var$ConfirmationResultImpl(verificationId, (cred)=>$2f7f285d50ad74d4$export$ce26c07117d59d6a(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $2f7f285d50ad74d4$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $2f7f285d50ad74d4$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $2f7f285d50ad74d4$var$ConfirmationResultImpl(verificationId, (cred)=>$2f7f285d50ad74d4$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $2f7f285d50ad74d4$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $2f7f285d50ad74d4$var$ConfirmationResultImpl(verificationId, (cred)=>$2f7f285d50ad74d4$export$efca4cbe5dd06740(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $2f7f285d50ad74d4$var$_verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await $2f7f285d50ad74d4$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log("Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.");
    }
    try {
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $2f7f285d50ad74d4$export$24baa2b76016ce0e(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $2f7f285d50ad74d4$var$FAKE_TOKEN) {
                        $2f7f285d50ad74d4$export$24baa2b76016ce0e(verifier?.type === $2f7f285d50ad74d4$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $2f7f285d50ad74d4$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $2f7f285d50ad74d4$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $2f7f285d50ad74d4$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $2f7f285d50ad74d4$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $2f7f285d50ad74d4$export$24baa2b76016ce0e(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                $2f7f285d50ad74d4$export$24baa2b76016ce0e(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $2f7f285d50ad74d4$var$FAKE_TOKEN) {
                        $2f7f285d50ad74d4$export$24baa2b76016ce0e(verifier?.type === $2f7f285d50ad74d4$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $2f7f285d50ad74d4$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $2f7f285d50ad74d4$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $2f7f285d50ad74d4$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $2f7f285d50ad74d4$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $2f7f285d50ad74d4$var$FAKE_TOKEN) {
                    $2f7f285d50ad74d4$export$24baa2b76016ce0e(verifier?.type === $2f7f285d50ad74d4$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $2f7f285d50ad74d4$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $2f7f285d50ad74d4$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $2f7f285d50ad74d4$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $2f7f285d50ad74d4$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $2f7f285d50ad74d4$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $2f7f285d50ad74d4$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(recaptchaV2Verifier.type === $2f7f285d50ad74d4$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof recaptchaV2Token === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ("phoneEnrollmentInfo" in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            "phoneEnrollmentInfo": {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ("phoneSignInInfo" in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            "phoneSignInInfo": {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            "recaptchaToken": recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $2f7f285d50ad74d4$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $2f7f285d50ad74d4$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $2f7f285d50ad74d4$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $2f7f285d50ad74d4$export$3a6d5c9ae78a2c08._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $2f7f285d50ad74d4$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $2f7f285d50ad74d4$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $2f7f285d50ad74d4$export$3a6d5c9ae78a2c08._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $2f7f285d50ad74d4$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $2f7f285d50ad74d4$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $2f7f285d50ad74d4$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $2f7f285d50ad74d4$export$cf2f7c5792f80b46(resolverOverride);
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$IdpCredential extends $2f7f285d50ad74d4$export$3a1a48c8f6ef640e {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $2f7f285d50ad74d4$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $2f7f285d50ad74d4$var$_signIn(params) {
    return $2f7f285d50ad74d4$var$_signInWithCredential(params.auth, new $2f7f285d50ad74d4$var$IdpCredential(params), params.bypassAuthState);
}
function $2f7f285d50ad74d4$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $2f7f285d50ad74d4$var$_reauthenticate(user, new $2f7f285d50ad74d4$var$IdpCredential(params), params.bypassAuthState);
}
async function $2f7f285d50ad74d4$var$_link(params) {
    const { auth: auth, user: user } = params;
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $2f7f285d50ad74d4$var$_link$1(user, new $2f7f285d50ad74d4$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $2f7f285d50ad74d4$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $2f7f285d50ad74d4$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $2f7f285d50ad74d4$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $2f7f285d50ad74d4$var$_reauth;
            default:
                $2f7f285d50ad74d4$export$28f7fcd39efa255(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $2f7f285d50ad74d4$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$4368d992c4eafac0(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    $2f7f285d50ad74d4$var$_assertInstanceOf(auth, provider, $2f7f285d50ad74d4$var$FederatedAuthProvider);
    const resolverInternal = $2f7f285d50ad74d4$var$_withDefaultResolver(authInternal, resolver);
    const action = new $2f7f285d50ad74d4$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$2d1720544b23b823(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($2f7f285d50ad74d4$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $2f7f285d50ad74d4$var$_assertInstanceOf(userInternal.auth, provider, $2f7f285d50ad74d4$var$FederatedAuthProvider);
    const resolverInternal = $2f7f285d50ad74d4$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $2f7f285d50ad74d4$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $2f7f285d50ad74d4$var$_assertInstanceOf(userInternal.auth, provider, $2f7f285d50ad74d4$var$FederatedAuthProvider);
    const resolverInternal = $2f7f285d50ad74d4$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $2f7f285d50ad74d4$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $2f7f285d50ad74d4$var$PopupOperation extends $2f7f285d50ad74d4$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($2f7f285d50ad74d4$var$PopupOperation.currentPopupAction) $2f7f285d50ad74d4$var$PopupOperation.currentPopupAction.cancel();
        $2f7f285d50ad74d4$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $2f7f285d50ad74d4$export$c03999cb2f36933f();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($2f7f285d50ad74d4$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject($2f7f285d50ad74d4$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $2f7f285d50ad74d4$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($2f7f285d50ad74d4$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $2f7f285d50ad74d4$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$2f7f285d50ad74d4$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $2f7f285d50ad74d4$var$redirectOutcomeMap = new Map();
class $2f7f285d50ad74d4$var$RedirectAction extends $2f7f285d50ad74d4$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $2f7f285d50ad74d4$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $2f7f285d50ad74d4$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $2f7f285d50ad74d4$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $2f7f285d50ad74d4$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $2f7f285d50ad74d4$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $2f7f285d50ad74d4$var$pendingRedirectKey(auth);
    const persistence = $2f7f285d50ad74d4$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $2f7f285d50ad74d4$var$_setPendingRedirectStatus(resolver, auth) {
    return $2f7f285d50ad74d4$var$resolverPersistence(resolver)._set($2f7f285d50ad74d4$var$pendingRedirectKey(auth), "true");
}
function $2f7f285d50ad74d4$export$a05254e7c3aeba6e() {
    $2f7f285d50ad74d4$var$redirectOutcomeMap.clear();
}
function $2f7f285d50ad74d4$export$b9a6b53f9be3734(auth, result) {
    $2f7f285d50ad74d4$var$redirectOutcomeMap.set(auth._key(), result);
}
function $2f7f285d50ad74d4$var$resolverPersistence(resolver) {
    return $2f7f285d50ad74d4$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $2f7f285d50ad74d4$var$pendingRedirectKey(auth) {
    return $2f7f285d50ad74d4$export$53a70dd1ebbae346($2f7f285d50ad74d4$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$39b482c5e57630a8(auth, provider, resolver) {
    return $2f7f285d50ad74d4$var$_signInWithRedirect(auth, provider, resolver);
}
async function $2f7f285d50ad74d4$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    $2f7f285d50ad74d4$var$_assertInstanceOf(auth, provider, $2f7f285d50ad74d4$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $2f7f285d50ad74d4$var$_withDefaultResolver(authInternal, resolver);
    await $2f7f285d50ad74d4$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$35e795649ee09318(user, provider, resolver) {
    return $2f7f285d50ad74d4$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $2f7f285d50ad74d4$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $2f7f285d50ad74d4$var$_assertInstanceOf(userInternal.auth, provider, $2f7f285d50ad74d4$var$FederatedAuthProvider);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $2f7f285d50ad74d4$var$_withDefaultResolver(userInternal.auth, resolver);
    await $2f7f285d50ad74d4$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $2f7f285d50ad74d4$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $2f7f285d50ad74d4$var$_linkWithRedirect(user, provider, resolver);
}
async function $2f7f285d50ad74d4$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $2f7f285d50ad74d4$var$_assertInstanceOf(userInternal.auth, provider, $2f7f285d50ad74d4$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $2f7f285d50ad74d4$var$_withDefaultResolver(userInternal.auth, resolver);
    await $2f7f285d50ad74d4$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $2f7f285d50ad74d4$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $2f7f285d50ad74d4$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $2f7f285d50ad74d4$export$342063e11d6c3cad(auth, resolver) {
    await $2f7f285d50ad74d4$export$23ebac1979863676(auth)._initializationPromise;
    return $2f7f285d50ad74d4$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $2f7f285d50ad74d4$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($2f7f285d50ad74d4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $2f7f285d50ad74d4$export$23ebac1979863676(auth);
    const resolver = $2f7f285d50ad74d4$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $2f7f285d50ad74d4$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $2f7f285d50ad74d4$var$prepareUserForRedirect(user) {
    const eventId = $2f7f285d50ad74d4$export$c03999cb2f36933f(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $2f7f285d50ad74d4$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $2f7f285d50ad74d4$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$2f7f285d50ad74d4$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !$2f7f285d50ad74d4$var$isNullRedirectEvent(event)) {
            const code = event.error.code?.split("auth/")[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($2f7f285d50ad74d4$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $2f7f285d50ad74d4$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($2f7f285d50ad74d4$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($2f7f285d50ad74d4$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $2f7f285d50ad74d4$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $2f7f285d50ad74d4$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $2f7f285d50ad74d4$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $2f7f285d50ad74d4$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $2f7f285d50ad74d4$export$91c6e00c14e7e6fd(auth, request = {}) {
    return $2f7f285d50ad74d4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $2f7f285d50ad74d4$var$HTTP_REGEX = /^https?/;
async function $2f7f285d50ad74d4$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $2f7f285d50ad74d4$export$91c6e00c14e7e6fd(auth);
    for (const domain of authorizedDomains)try {
        if ($2f7f285d50ad74d4$var$matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $2f7f285d50ad74d4$var$matchDomain(expected) {
    const currentUrl = $2f7f285d50ad74d4$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$2f7f285d50ad74d4$var$HTTP_REGEX.test(protocol)) return false;
    if ($2f7f285d50ad74d4$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$NETWORK_TIMEOUT = new $2f7f285d50ad74d4$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $2f7f285d50ad74d4$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $2f7f285d50ad74d4$var$_window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $2f7f285d50ad74d4$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $2f7f285d50ad74d4$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $2f7f285d50ad74d4$var$resetUnloadedGapiModules();
                    reject($2f7f285d50ad74d4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $2f7f285d50ad74d4$var$NETWORK_TIMEOUT.get()
            });
        }
        if ($2f7f285d50ad74d4$var$_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!$2f7f285d50ad74d4$var$_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $2f7f285d50ad74d4$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $2f7f285d50ad74d4$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($2f7f285d50ad74d4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $2f7f285d50ad74d4$var$_loadJS(`${$2f7f285d50ad74d4$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $2f7f285d50ad74d4$var$cachedGApiLoader = null;
        throw error;
    });
}
let $2f7f285d50ad74d4$var$cachedGApiLoader = null;
function $2f7f285d50ad74d4$var$_loadGapi(auth) {
    $2f7f285d50ad74d4$var$cachedGApiLoader = $2f7f285d50ad74d4$var$cachedGApiLoader || $2f7f285d50ad74d4$var$loadGapi(auth);
    return $2f7f285d50ad74d4$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$PING_TIMEOUT = new $2f7f285d50ad74d4$var$Delay(5000, 15000);
const $2f7f285d50ad74d4$var$IFRAME_PATH = "__/auth/iframe";
const $2f7f285d50ad74d4$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $2f7f285d50ad74d4$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $2f7f285d50ad74d4$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $2f7f285d50ad74d4$var$getIframeUrl(auth) {
    const config = auth.config;
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $2f7f285d50ad74d4$var$_emulatorUrl(config, $2f7f285d50ad74d4$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$2f7f285d50ad74d4$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c)
    };
    const eid = $2f7f285d50ad74d4$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $029952e65115eee5$export$ac4103b836844853)(params).slice(1)}`;
}
async function $2f7f285d50ad74d4$var$_openIframe(auth) {
    const context = await $2f7f285d50ad74d4$var$_loadGapi(auth);
    const gapi1 = $2f7f285d50ad74d4$var$_window().gapi;
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $2f7f285d50ad74d4$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $2f7f285d50ad74d4$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $2f7f285d50ad74d4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $2f7f285d50ad74d4$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $2f7f285d50ad74d4$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $2f7f285d50ad74d4$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $2f7f285d50ad74d4$var$DEFAULT_WIDTH = 500;
const $2f7f285d50ad74d4$var$DEFAULT_HEIGHT = 600;
const $2f7f285d50ad74d4$var$TARGET_BLANK = "_blank";
const $2f7f285d50ad74d4$var$FIREFOX_EMPTY_URL = "http://localhost";
class $2f7f285d50ad74d4$export$2ed0fc6709e59212 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $2f7f285d50ad74d4$var$_open(auth, url, name, width = $2f7f285d50ad74d4$var$DEFAULT_WIDTH, height = $2f7f285d50ad74d4$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = {
        ...$2f7f285d50ad74d4$var$BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $029952e65115eee5$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $2f7f285d50ad74d4$var$_isChromeIOS(ua) ? $2f7f285d50ad74d4$var$TARGET_BLANK : name;
    if ($2f7f285d50ad74d4$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $2f7f285d50ad74d4$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($2f7f285d50ad74d4$var$_isIOSStandalone(ua) && target !== "_self") {
        $2f7f285d50ad74d4$var$openAsNewWindowIOS(url || "", target);
        return new $2f7f285d50ad74d4$export$2ed0fc6709e59212(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $2f7f285d50ad74d4$export$2ed0fc6709e59212(newWin);
}
function $2f7f285d50ad74d4$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $2f7f285d50ad74d4$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $2f7f285d50ad74d4$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $2f7f285d50ad74d4$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $2f7f285d50ad74d4$export$3d12bd131bb975d1(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $2f7f285d50ad74d4$export$24baa2b76016ce0e(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $2f7f285d50ad74d4$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $029952e65115eee5$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $2f7f285d50ad74d4$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$2f7f285d50ad74d4$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$2f7f285d50ad74d4$var$getHandlerBase(auth)}?${(0, $029952e65115eee5$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $2f7f285d50ad74d4$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$2f7f285d50ad74d4$var$WIDGET_PATH}`;
    return $2f7f285d50ad74d4$var$_emulatorUrl(config, $2f7f285d50ad74d4$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $2f7f285d50ad74d4$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $2f7f285d50ad74d4$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $2f7f285d50ad74d4$export$db3b6bfb95261072;
        this._completeRedirectFn = $2f7f285d50ad74d4$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $2f7f285d50ad74d4$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(this.eventManagers[auth._key()]?.manager, "_initialize() not called before _openPopup()");
        const url = await $2f7f285d50ad74d4$export$3d12bd131bb975d1(auth, provider, authType, $2f7f285d50ad74d4$var$_getCurrentUrl(), eventId);
        return $2f7f285d50ad74d4$var$_open(auth, url, $2f7f285d50ad74d4$export$c03999cb2f36933f());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $2f7f285d50ad74d4$export$3d12bd131bb975d1(auth, provider, authType, $2f7f285d50ad74d4$var$_getCurrentUrl(), eventId);
        $2f7f285d50ad74d4$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $2f7f285d50ad74d4$export$d66dc83d8cfc8dd(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $2f7f285d50ad74d4$var$_openIframe(auth);
        const manager = new $2f7f285d50ad74d4$export$158acd800e1ef08b(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $2f7f285d50ad74d4$export$24baa2b76016ce0e(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($2f7f285d50ad74d4$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $2f7f285d50ad74d4$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[$2f7f285d50ad74d4$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $2f7f285d50ad74d4$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $2f7f285d50ad74d4$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $2f7f285d50ad74d4$var$_isMobileBrowser() || $2f7f285d50ad74d4$var$_isSafari() || $2f7f285d50ad74d4$export$92108d983e8ee699();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $2f7f285d50ad74d4$export$953cecd6e717a553 = $2f7f285d50ad74d4$var$BrowserPopupRedirectResolver;
class $2f7f285d50ad74d4$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $2f7f285d50ad74d4$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $2f7f285d50ad74d4$var$PhoneMultiFactorAssertionImpl extends $2f7f285d50ad74d4$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $2f7f285d50ad74d4$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $2f7f285d50ad74d4$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $2f7f285d50ad74d4$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$7ccc53e8f1e7dfc5 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $2f7f285d50ad74d4$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $2f7f285d50ad74d4$export$7ccc53e8f1e7dfc5.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $2f7f285d50ad74d4$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $2f7f285d50ad74d4$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $2f7f285d50ad74d4$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof mfaSession.user?.auth !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $2f7f285d50ad74d4$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $2f7f285d50ad74d4$export$ae1af26003f05816._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $2f7f285d50ad74d4$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $2f7f285d50ad74d4$var$TotpMultiFactorAssertionImpl extends $2f7f285d50ad74d4$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $2f7f285d50ad74d4$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $2f7f285d50ad74d4$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $2f7f285d50ad74d4$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $2f7f285d50ad74d4$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $2f7f285d50ad74d4$export$ae1af26003f05816 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $2f7f285d50ad74d4$export$ae1af26003f05816(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if ($2f7f285d50ad74d4$var$_isEmptyString(accountName) || $2f7f285d50ad74d4$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($2f7f285d50ad74d4$var$_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || "unknownuser";
            if ($2f7f285d50ad74d4$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $2f7f285d50ad74d4$var$_isEmptyString(input) {
    return typeof input === "undefined" || input?.length === 0;
}
var $2f7f285d50ad74d4$var$name = "@firebase/auth";
var $2f7f285d50ad74d4$var$version = "1.11.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2f7f285d50ad74d4$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2f7f285d50ad74d4$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return "web-extension";
        default:
            return undefined;
    }
}
/** @internal */ function $2f7f285d50ad74d4$var$registerAuth(clientPlatform) {
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $2f7f285d50ad74d4$export$24baa2b76016ce0e(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $2f7f285d50ad74d4$export$faec65b429be379(clientPlatform)
        };
        const authInstance = new $2f7f285d50ad74d4$export$9f4f30ee63539e24(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $2f7f285d50ad74d4$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $2f7f285d50ad74d4$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $2f7f285d50ad74d4$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($2f7f285d50ad74d4$var$name, $2f7f285d50ad74d4$var$version, $2f7f285d50ad74d4$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($2f7f285d50ad74d4$var$name, $2f7f285d50ad74d4$var$version, "esm2020");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2f7f285d50ad74d4$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $2f7f285d50ad74d4$var$authIdTokenMaxAge = (0, $029952e65115eee5$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $2f7f285d50ad74d4$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $2f7f285d50ad74d4$var$lastPostedIdToken = null;
const $2f7f285d50ad74d4$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $2f7f285d50ad74d4$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if ($2f7f285d50ad74d4$var$lastPostedIdToken === idToken) return;
        $2f7f285d50ad74d4$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $2f7f285d50ad74d4$export$ffb5f4729a158638(app = (0, $5e587d655f0a08bb$export$f9962582c9e66d99)()) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $2f7f285d50ad74d4$export$3466f893ebf79586(app, {
        popupRedirectResolver: $2f7f285d50ad74d4$export$953cecd6e717a553,
        persistence: [
            $2f7f285d50ad74d4$export$23f2a1d2818174ef,
            $2f7f285d50ad74d4$export$8b22cf2602fb60ce,
            $2f7f285d50ad74d4$export$db3b6bfb95261072
        ]
    });
    const authTokenSyncPath = (0, $029952e65115eee5$export$5539a1a3afe87d6)("authTokenSyncURL");
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === "boolean" && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $2f7f285d50ad74d4$var$mintCookieFactory(authTokenSyncUrl.toString());
            $2f7f285d50ad74d4$export$4a5767248b18ef41(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $2f7f285d50ad74d4$export$d141bba7fdc215a3(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $029952e65115eee5$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $2f7f285d50ad74d4$export$61196ced6d74a310(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $2f7f285d50ad74d4$var$getScriptParentElement() {
    return document.getElementsByTagName("head")?.[0] ?? document;
}
$2f7f285d50ad74d4$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement("script");
            el.setAttribute("src", url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $2f7f285d50ad74d4$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = "text/javascript";
            el.charset = "UTF-8";
            $2f7f285d50ad74d4$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: "https://apis.google.com/js/api.js",
    recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
    recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
$2f7f285d50ad74d4$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );














var $906344b47e605252$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $906344b47e605252$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $906344b47e605252$export$70ffa26850098d01;
var $906344b47e605252$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $906344b47e605252$export$9f5a3dfc7a9f5dd = $906344b47e605252$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $906344b47e605252$export$70ffa26850098d01 = $906344b47e605252$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $906344b47e605252$var$commonjsGlobal !== "undefined" ? $906344b47e605252$var$commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});


var $33cb313d667e3306$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $33cb313d667e3306$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $33cb313d667e3306$export$26404658cda3ee02;
var $33cb313d667e3306$export$ddb1030448106742;
var $33cb313d667e3306$export$aa726fb96ad3e039;
var $33cb313d667e3306$export$3d7865934588d77e;
var $33cb313d667e3306$export$d4e71bc0b80dc0fb;
var $33cb313d667e3306$export$cbbc350c1dfc80cb;
var $33cb313d667e3306$export$d61e24a684f9e51;
var $33cb313d667e3306$export$888d0d9ab79d08fc;
var $33cb313d667e3306$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $33cb313d667e3306$var$commonjsGlobal && $33cb313d667e3306$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a;
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        const b = a.length;
        if (0 < b) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(let c = 1; c < arguments.length; c++){
            const d = arguments[c];
            if (ha(d)) {
                const e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(let g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    class na {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class Aa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = Ba.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var Ba = new na(()=>new Ca, (a)=>a.reset());
    class Ca {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let x, y = !1, za = new Aa, Ea = ()=>{
        const a = k.Promise.resolve(void 0);
        x = ()=>{
            a.then(Da);
        };
    };
    var Da = ()=>{
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(()=>{
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class eb extends z {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : cb(this);
        }
        N() {
            super.N();
            this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = class {
        stringify(a) {
            return k.JSON.stringify(a, void 0);
        }
        parse(a) {
            return k.JSON.parse(a, void 0);
        }
    };
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        const b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        const b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        const b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const w = P(this.g);
                var b = this.g.Ba();
                const O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            let B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        const a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    let l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            const v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            const w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            const O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            const B = a.g;
                            if (B) {
                                const ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    const db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.D);
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(const d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(let d = 0; d < b.length; d++){
            const e = a[d];
            for(let f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        let b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            const f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        const c = new vb;
        if (k.Image) {
            const d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        const c = new vb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        const d = c || "";
        try {
            nc(a, function(e, f) {
                let g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        const b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function() {
            return "include" === this.m;
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        let b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    const g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            const c = a.g, d = a.v[0] ? ()=>{} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        const b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            const e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    const e = new M(this, this.j, a);
                    let f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        const d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            let f = -1;
            for(;;){
                const g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                let m = !0;
                for(let q = 0; q < c; q++){
                    let l = e[q].g;
                    const v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        let c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            const b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $33cb313d667e3306$export$66869136fc133c3a = $33cb313d667e3306$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new hd;
    };
    $33cb313d667e3306$export$888d0d9ab79d08fc = $33cb313d667e3306$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return qb();
    };
    $33cb313d667e3306$export$d61e24a684f9e51 = $33cb313d667e3306$export$2e2bcd8739ae039.Event = I;
    $33cb313d667e3306$export$cbbc350c1dfc80cb = $33cb313d667e3306$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $33cb313d667e3306$export$d4e71bc0b80dc0fb = $33cb313d667e3306$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $33cb313d667e3306$export$3d7865934588d77e = $33cb313d667e3306$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $33cb313d667e3306$export$aa726fb96ad3e039 = $33cb313d667e3306$export$2e2bcd8739ae039.WebChannel = mb;
    $33cb313d667e3306$export$ddb1030448106742 = $33cb313d667e3306$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $33cb313d667e3306$export$26404658cda3ee02 = $33cb313d667e3306$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $33cb313d667e3306$var$commonjsGlobal !== "undefined" ? $33cb313d667e3306$var$commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $a33cbddcd7bfa0a9$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $a33cbddcd7bfa0a9$var$F = "@firebase/firestore", $a33cbddcd7bfa0a9$var$M = "4.9.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $a33cbddcd7bfa0a9$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $a33cbddcd7bfa0a9$var$User.UNAUTHENTICATED = new $a33cbddcd7bfa0a9$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$a33cbddcd7bfa0a9$var$User.GOOGLE_CREDENTIALS = new $a33cbddcd7bfa0a9$var$User("google-credentials-uid"), $a33cbddcd7bfa0a9$var$User.FIRST_PARTY = new $a33cbddcd7bfa0a9$var$User("first-party-uid"), $a33cbddcd7bfa0a9$var$User.MOCK_USER = new $a33cbddcd7bfa0a9$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $a33cbddcd7bfa0a9$var$x = "12.2.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$O = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $a33cbddcd7bfa0a9$var$__PRIVATE_getLogLevel() {
    return $a33cbddcd7bfa0a9$var$O.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $a33cbddcd7bfa0a9$export$c622e99c0ce7b1c9(e) {
    $a33cbddcd7bfa0a9$var$O.setLogLevel(e);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug(e, ...t) {
    if ($a33cbddcd7bfa0a9$var$O.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($a33cbddcd7bfa0a9$var$__PRIVATE_argToString);
        $a33cbddcd7bfa0a9$var$O.debug(`Firestore (${$a33cbddcd7bfa0a9$var$x}): ${e}`, ...n);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_logError(e, ...t) {
    if ($a33cbddcd7bfa0a9$var$O.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) {
        const n = t.map($a33cbddcd7bfa0a9$var$__PRIVATE_argToString);
        $a33cbddcd7bfa0a9$var$O.error(`Firestore (${$a33cbddcd7bfa0a9$var$x}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb(e, ...t) {
    if ($a33cbddcd7bfa0a9$var$O.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) {
        const n = t.map($a33cbddcd7bfa0a9$var$__PRIVATE_argToString);
        $a33cbddcd7bfa0a9$var$O.warn(`Firestore (${$a33cbddcd7bfa0a9$var$x}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$fail(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $a33cbddcd7bfa0a9$var$__PRIVATE__fail(e, r, n);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$a33cbddcd7bfa0a9$var$x}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $a33cbddcd7bfa0a9$var$__PRIVATE_logError(r), new Error(r);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $a33cbddcd7bfa0a9$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $a33cbddcd7bfa0a9$export$1d2b90eea9bba017(e, t) {
    e || $a33cbddcd7bfa0a9$var$fail(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$N = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $a33cbddcd7bfa0a9$export$8fada0bf726bf278 extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $a33cbddcd7bfa0a9$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($a33cbddcd7bfa0a9$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $a33cbddcd7bfa0a9$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert("string" == typeof t.accessToken, 31837, {
                l: t
            }), new $a33cbddcd7bfa0a9$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(null === e || "string" == typeof e, 2055, {
            h: e
        }), new $a33cbddcd7bfa0a9$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n, this.type = "FirstParty", this.user = $a33cbddcd7bfa0a9$var$User.FIRST_PARTY, this.A = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ R() {
        return this.I ? this.I() : null;
    }
    get headers() {
        this.A.set("X-Goog-AuthUser", this.P);
        // Use array notation to prevent minification
        const e = this.R();
        return e && this.A.set("Authorization", e), this.T && this.A.set("X-Goog-Iam-Authorization-Token", this.T), this.A;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n;
    }
    getToken() {
        return Promise.resolve(new $a33cbddcd7bfa0a9$var$__PRIVATE_FirstPartyToken(this.P, this.T, this.I));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($a33cbddcd7bfa0a9$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $a33cbddcd7bfa0a9$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new $a33cbddcd7bfa0a9$var$AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new $a33cbddcd7bfa0a9$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $a33cbddcd7bfa0a9$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $a33cbddcd7bfa0a9$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $a33cbddcd7bfa0a9$export$253bcaa5572dcc83 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $a33cbddcd7bfa0a9$var$__PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    const n = Math.min(e.length, t.length);
    for(let r = 0; r < n; r++){
        const n = e.charAt(r), i = t.charAt(r);
        if (n !== i) return $a33cbddcd7bfa0a9$var$__PRIVATE_isSurrogate(n) === $a33cbddcd7bfa0a9$var$__PRIVATE_isSurrogate(i) ? $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n, i) : $a33cbddcd7bfa0a9$var$__PRIVATE_isSurrogate(n) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
const $a33cbddcd7bfa0a9$var$B = 55296, $a33cbddcd7bfa0a9$var$L = 57343;
function $a33cbddcd7bfa0a9$var$__PRIVATE_isSurrogate(e) {
    const t = e.charCodeAt(0);
    return t >= $a33cbddcd7bfa0a9$var$B && t <= $a33cbddcd7bfa0a9$var$L;
}
/** Helper to compare arrays using isEqual(). */ function $a33cbddcd7bfa0a9$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\x00";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$k = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $a33cbddcd7bfa0a9$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $a33cbddcd7bfa0a9$var$fail(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $a33cbddcd7bfa0a9$var$fail(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $a33cbddcd7bfa0a9$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $a33cbddcd7bfa0a9$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $a33cbddcd7bfa0a9$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $a33cbddcd7bfa0a9$var$BasePath.isNumericId(e), r = $a33cbddcd7bfa0a9$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $a33cbddcd7bfa0a9$var$BasePath.extractNumericId(e).compare($a33cbddcd7bfa0a9$var$BasePath.extractNumericId(t)) : $a33cbddcd7bfa0a9$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $906344b47e605252$export$70ffa26850098d01).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $a33cbddcd7bfa0a9$var$ResourcePath extends $a33cbddcd7bfa0a9$var$BasePath {
    construct(e, t, n) {
        return new $a33cbddcd7bfa0a9$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $a33cbddcd7bfa0a9$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $a33cbddcd7bfa0a9$var$ResourcePath([]);
    }
}
const $a33cbddcd7bfa0a9$var$q = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $a33cbddcd7bfa0a9$export$b7871852b967eaf1 extends $a33cbddcd7bfa0a9$var$BasePath {
    construct(e, t, n) {
        return new $a33cbddcd7bfa0a9$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $a33cbddcd7bfa0a9$var$q.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $a33cbddcd7bfa0a9$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $a33cbddcd7bfa0a9$var$k;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $a33cbddcd7bfa0a9$export$b7871852b967eaf1([
            $a33cbddcd7bfa0a9$var$k
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $a33cbddcd7bfa0a9$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $a33cbddcd7bfa0a9$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $a33cbddcd7bfa0a9$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $a33cbddcd7bfa0a9$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $a33cbddcd7bfa0a9$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(new $a33cbddcd7bfa0a9$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $a33cbddcd7bfa0a9$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateDocumentPath(e) {
    if (!$a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(e)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateCollectionPath(e) {
    if ($a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(e)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isPlainObject(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $a33cbddcd7bfa0a9$var$fail(12329, {
        type: typeof e
    });
}
function $a33cbddcd7bfa0a9$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_valueDescription(e);
            throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $a33cbddcd7bfa0a9$var$property(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json A JSON object to validate.
 * @param scheme a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(e, t) {
    if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isPlainObject(e)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const o = e[r];
        if (i && typeof o !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && o !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $a33cbddcd7bfa0a9$var$Q = -62135596800, $a33cbddcd7bfa0a9$var$$ = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $a33cbddcd7bfa0a9$var$$);
        return new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $a33cbddcd7bfa0a9$var$Q) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $a33cbddcd7bfa0a9$var$$;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(e, $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430._jsonSchema)) return new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $a33cbddcd7bfa0a9$var$Q;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430._jsonSchemaVersion = "firestore/timestamp/1.0", $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430._jsonSchema = {
    type: $a33cbddcd7bfa0a9$var$property("string", $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430._jsonSchemaVersion),
    seconds: $a33cbddcd7bfa0a9$var$property("number"),
    nanoseconds: $a33cbddcd7bfa0a9$var$property("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $a33cbddcd7bfa0a9$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $a33cbddcd7bfa0a9$var$SnapshotVersion(e);
    }
    static min() {
        return new $a33cbddcd7bfa0a9$var$SnapshotVersion(new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $a33cbddcd7bfa0a9$var$SnapshotVersion(new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $a33cbddcd7bfa0a9$var$U = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $a33cbddcd7bfa0a9$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $a33cbddcd7bfa0a9$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $a33cbddcd7bfa0a9$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $a33cbddcd7bfa0a9$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $a33cbddcd7bfa0a9$var$IndexState(0, $a33cbddcd7bfa0a9$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $a33cbddcd7bfa0a9$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(n + 1, 0) : new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(n, r));
    return new $a33cbddcd7bfa0a9$var$IndexOffset(i, $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $a33cbddcd7bfa0a9$var$IndexOffset(e.readTime, e.key, $a33cbddcd7bfa0a9$var$U);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $a33cbddcd7bfa0a9$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $a33cbddcd7bfa0a9$var$IndexOffset($a33cbddcd7bfa0a9$var$SnapshotVersion.min(), $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty(), $a33cbddcd7bfa0a9$var$U);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $a33cbddcd7bfa0a9$var$IndexOffset($a33cbddcd7bfa0a9$var$SnapshotVersion.max(), $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty(), $a33cbddcd7bfa0a9$var$U);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$K = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $a33cbddcd7bfa0a9$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION || e.message !== $a33cbddcd7bfa0a9$var$K) throw e;
    $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $a33cbddcd7bfa0a9$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $a33cbddcd7bfa0a9$var$fail(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $a33cbddcd7bfa0a9$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $a33cbddcd7bfa0a9$var$PersistencePromise ? t : $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $a33cbddcd7bfa0a9$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $a33cbddcd7bfa0a9$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $a33cbddcd7bfa0a9$var$W = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.S = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.S.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.S.reject(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.S.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.S.reject(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get D() {
        return this.S.promise;
    }
    abort(e) {
        e && this.S.reject(e), this.aborted || ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    C() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "Removing database:", e);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest((0, $029952e65115eee5$export$a4e55266d2135a7f)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static v() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return !1;
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $029952e65115eee5$export$c36915b22ce77c19)(), t = $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.M(e), n = 0 < t && t < 10, r = $a33cbddcd7bfa0a9$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        return "undefined" != typeof $cfae44f0dfdf62c0$exports && "YES" === $cfae44f0dfdf62c0$exports.__PRIVATE_env?.__PRIVATE_USE_MOCK_PERSISTENCE;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static O(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static M(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.N = n, this.B = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.M((0, $029952e65115eee5$export$c36915b22ce77c19)()) && $a33cbddcd7bfa0a9$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async L(e) {
        return this.db || ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.N.k(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.q && (this.db.onversionchange = (e)=>this.q(e)), this.db;
    }
    $(e) {
        this.q = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.L(e);
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.C(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $a33cbddcd7bfa0a9$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.D, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IterationController {
    constructor(e){
        this.U = e, this.K = !1, this.W = null;
    }
    get isDone() {
        return this.K;
    }
    get G() {
        return this.W;
    }
    set cursor(e) {
        this.U = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.K = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ j(e) {
        this.W = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest(this.U.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransactionError extends $a33cbddcd7bfa0a9$export$8fada0bf726bf278 {
    constructor(e, t){
        super($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "ADD", this.store.name, e, e);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "DELETE", this.store.name, e);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "COUNT", this.store.name);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest(this.store.count());
    }
    J(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $a33cbddcd7bfa0a9$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.H(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ Y(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    Z(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$W, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.X = !1;
        const r = this.cursor(n);
        return this.H(r, (e, t, n)=>n.delete());
    }
    ee(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.H(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ te(e) {
        const t = this.cursor({});
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    H(e, t) {
        const n = [];
        return new $a33cbddcd7bfa0a9$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $a33cbddcd7bfa0a9$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $a33cbddcd7bfa0a9$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $a33cbddcd7bfa0a9$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.G ? i.continue() : i.continue(s.G);
            };
        }).next(()=>$a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.X ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_wrapRequest(e) {
    return new $a33cbddcd7bfa0a9$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $a33cbddcd7bfa0a9$var$G = !1;
function $a33cbddcd7bfa0a9$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.M((0, $029952e65115eee5$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $a33cbddcd7bfa0a9$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $a33cbddcd7bfa0a9$var$G || ($a33cbddcd7bfa0a9$var$G = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $a33cbddcd7bfa0a9$var$z = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ne = t, this.task = null;
    }
    start() {
        this.re(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    re(e) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$z, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.ne.ie();
                $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$z, `Documents written: ${e}`);
            } catch (e) {
                $a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e) ? $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$z, "Ignoring IndexedDB error during index backfill: ", e) : await $a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.re(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ie(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.se(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ se(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $a33cbddcd7bfa0a9$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$z, `Processing collection: ${t}`), this.oe(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ oe(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this._e(r, n)).next((n)=>($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$z, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ _e(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $a33cbddcd7bfa0a9$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $a33cbddcd7bfa0a9$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ae(e), this.ue = (e)=>t.writeSequenceNumber(e));
    }
    ae(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ue && this.ue(e), e;
    }
}
$a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $a33cbddcd7bfa0a9$var$j = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $a33cbddcd7bfa0a9$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$a33cbddcd7bfa0a9$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$J = "\x01";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $a33cbddcd7bfa0a9$var$__PRIVATE_encodeSeparator(t)), t = $a33cbddcd7bfa0a9$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $a33cbddcd7bfa0a9$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\x00":
                n += "\x01\x10";
                break;
            case $a33cbddcd7bfa0a9$var$J:
                n += "\x01\x11";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $a33cbddcd7bfa0a9$var$__PRIVATE_encodeSeparator(e) {
    return e + $a33cbddcd7bfa0a9$var$J + "\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(t >= 2, 64408, {
        path: e
    }), 2 === t) return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.charAt(0) === $a33cbddcd7bfa0a9$var$J && "\x01" === e.charAt(1), 56145, {
        path: e
    }), $a33cbddcd7bfa0a9$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($a33cbddcd7bfa0a9$var$J, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $a33cbddcd7bfa0a9$var$fail(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "\x01":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "\x10":
                r += e.substring(i, t), r += "\x00";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $a33cbddcd7bfa0a9$var$fail(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $a33cbddcd7bfa0a9$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$H = "remoteDocuments", $a33cbddcd7bfa0a9$var$Y = "owner", $a33cbddcd7bfa0a9$var$Z = "owner", $a33cbddcd7bfa0a9$var$X = "mutationQueues", $a33cbddcd7bfa0a9$var$ee = "userId", $a33cbddcd7bfa0a9$var$te = "mutations", $a33cbddcd7bfa0a9$var$ne = "batchId", $a33cbddcd7bfa0a9$var$re = "userMutationsIndex", $a33cbddcd7bfa0a9$var$ie = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $a33cbddcd7bfa0a9$var$se = {}, $a33cbddcd7bfa0a9$var$oe = "documentMutations", $a33cbddcd7bfa0a9$var$_e = "remoteDocumentsV14", $a33cbddcd7bfa0a9$var$ae = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $a33cbddcd7bfa0a9$var$ue = "documentKeyIndex", $a33cbddcd7bfa0a9$var$ce = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $a33cbddcd7bfa0a9$var$le = "collectionGroupIndex", $a33cbddcd7bfa0a9$var$he = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $a33cbddcd7bfa0a9$var$Pe = "remoteDocumentGlobal", $a33cbddcd7bfa0a9$var$Te = "remoteDocumentGlobalKey", $a33cbddcd7bfa0a9$var$Ie = "targets", $a33cbddcd7bfa0a9$var$Ee = "queryTargetsIndex", $a33cbddcd7bfa0a9$var$de = [
    "canonicalId",
    "targetId"
], $a33cbddcd7bfa0a9$var$Ae = "targetDocuments", $a33cbddcd7bfa0a9$var$Re = [
    "targetId",
    "path"
], $a33cbddcd7bfa0a9$var$Ve = "documentTargetsIndex", $a33cbddcd7bfa0a9$var$me = [
    "path",
    "targetId"
], $a33cbddcd7bfa0a9$var$fe = "targetGlobalKey", $a33cbddcd7bfa0a9$var$ge = "targetGlobal", $a33cbddcd7bfa0a9$var$pe = "collectionParents", $a33cbddcd7bfa0a9$var$ye = [
    "collectionId",
    "parent"
], $a33cbddcd7bfa0a9$var$we = "clientMetadata", $a33cbddcd7bfa0a9$var$Se = "clientId", $a33cbddcd7bfa0a9$var$be = "bundles", $a33cbddcd7bfa0a9$var$De = "bundleId", $a33cbddcd7bfa0a9$var$Ce = "namedQueries", $a33cbddcd7bfa0a9$var$ve = "name", $a33cbddcd7bfa0a9$var$Fe = "indexConfiguration", $a33cbddcd7bfa0a9$var$Me = "indexId", $a33cbddcd7bfa0a9$var$xe = "collectionGroupIndex", $a33cbddcd7bfa0a9$var$Oe = "collectionGroup", $a33cbddcd7bfa0a9$var$Ne = "indexState", $a33cbddcd7bfa0a9$var$Be = [
    "indexId",
    "uid"
], $a33cbddcd7bfa0a9$var$Le = "sequenceNumberIndex", $a33cbddcd7bfa0a9$var$ke = [
    "uid",
    "sequenceNumber"
], $a33cbddcd7bfa0a9$var$qe = "indexEntries", $a33cbddcd7bfa0a9$var$Qe = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $a33cbddcd7bfa0a9$var$$e = "documentKeyIndex", $a33cbddcd7bfa0a9$var$Ue = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $a33cbddcd7bfa0a9$var$Ke = "documentOverlays", $a33cbddcd7bfa0a9$var$We = [
    "userId",
    "collectionPath",
    "documentId"
], $a33cbddcd7bfa0a9$var$Ge = "collectionPathOverlayIndex", $a33cbddcd7bfa0a9$var$ze = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $a33cbddcd7bfa0a9$var$je = "collectionGroupOverlayIndex", $a33cbddcd7bfa0a9$var$Je = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $a33cbddcd7bfa0a9$var$He = "globals", $a33cbddcd7bfa0a9$var$Ye = "name", $a33cbddcd7bfa0a9$var$Ze = [
    $a33cbddcd7bfa0a9$var$X,
    $a33cbddcd7bfa0a9$var$te,
    $a33cbddcd7bfa0a9$var$oe,
    $a33cbddcd7bfa0a9$var$H,
    $a33cbddcd7bfa0a9$var$Ie,
    $a33cbddcd7bfa0a9$var$Y,
    $a33cbddcd7bfa0a9$var$ge,
    $a33cbddcd7bfa0a9$var$Ae,
    $a33cbddcd7bfa0a9$var$we,
    $a33cbddcd7bfa0a9$var$Pe,
    $a33cbddcd7bfa0a9$var$pe,
    $a33cbddcd7bfa0a9$var$be,
    $a33cbddcd7bfa0a9$var$Ce
], $a33cbddcd7bfa0a9$var$Xe = [
    ...$a33cbddcd7bfa0a9$var$Ze,
    $a33cbddcd7bfa0a9$var$Ke
], $a33cbddcd7bfa0a9$var$et = [
    $a33cbddcd7bfa0a9$var$X,
    $a33cbddcd7bfa0a9$var$te,
    $a33cbddcd7bfa0a9$var$oe,
    $a33cbddcd7bfa0a9$var$_e,
    $a33cbddcd7bfa0a9$var$Ie,
    $a33cbddcd7bfa0a9$var$Y,
    $a33cbddcd7bfa0a9$var$ge,
    $a33cbddcd7bfa0a9$var$Ae,
    $a33cbddcd7bfa0a9$var$we,
    $a33cbddcd7bfa0a9$var$Pe,
    $a33cbddcd7bfa0a9$var$pe,
    $a33cbddcd7bfa0a9$var$be,
    $a33cbddcd7bfa0a9$var$Ce,
    $a33cbddcd7bfa0a9$var$Ke
], $a33cbddcd7bfa0a9$var$tt = $a33cbddcd7bfa0a9$var$et, $a33cbddcd7bfa0a9$var$nt = [
    ...$a33cbddcd7bfa0a9$var$tt,
    $a33cbddcd7bfa0a9$var$Fe,
    $a33cbddcd7bfa0a9$var$Ne,
    $a33cbddcd7bfa0a9$var$qe
], $a33cbddcd7bfa0a9$var$rt = $a33cbddcd7bfa0a9$var$nt, $a33cbddcd7bfa0a9$var$it = [
    ...$a33cbddcd7bfa0a9$var$nt,
    $a33cbddcd7bfa0a9$var$He
], $a33cbddcd7bfa0a9$var$st = $a33cbddcd7bfa0a9$var$it;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransaction extends $a33cbddcd7bfa0a9$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.le = e, this.currentSequenceNumber = t;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.O(n.le, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $a33cbddcd7bfa0a9$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $a33cbddcd7bfa0a9$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $a33cbddcd7bfa0a9$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $a33cbddcd7bfa0a9$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $a33cbddcd7bfa0a9$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $a33cbddcd7bfa0a9$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $a33cbddcd7bfa0a9$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $a33cbddcd7bfa0a9$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $a33cbddcd7bfa0a9$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $a33cbddcd7bfa0a9$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $a33cbddcd7bfa0a9$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $a33cbddcd7bfa0a9$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $a33cbddcd7bfa0a9$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $a33cbddcd7bfa0a9$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $a33cbddcd7bfa0a9$var$LLRBNode.RED, this.left = null != r ? r : $a33cbddcd7bfa0a9$var$LLRBNode.EMPTY, this.right = null != i ? i : $a33cbddcd7bfa0a9$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $a33cbddcd7bfa0a9$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $a33cbddcd7bfa0a9$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $a33cbddcd7bfa0a9$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $a33cbddcd7bfa0a9$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $a33cbddcd7bfa0a9$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $a33cbddcd7bfa0a9$var$fail(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $a33cbddcd7bfa0a9$var$fail(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $a33cbddcd7bfa0a9$var$fail(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$a33cbddcd7bfa0a9$var$LLRBNode.EMPTY = null, $a33cbddcd7bfa0a9$var$LLRBNode.RED = !0, $a33cbddcd7bfa0a9$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$a33cbddcd7bfa0a9$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $a33cbddcd7bfa0a9$var$fail(57766);
    }
    get value() {
        throw $a33cbddcd7bfa0a9$var$fail(16141);
    }
    get color() {
        throw $a33cbddcd7bfa0a9$var$fail(16727);
    }
    get left() {
        throw $a33cbddcd7bfa0a9$var$fail(29726);
    }
    get right() {
        throw $a33cbddcd7bfa0a9$var$fail(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $a33cbddcd7bfa0a9$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $a33cbddcd7bfa0a9$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $a33cbddcd7bfa0a9$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $a33cbddcd7bfa0a9$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $a33cbddcd7bfa0a9$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $a33cbddcd7bfa0a9$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $a33cbddcd7bfa0a9$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $a33cbddcd7bfa0a9$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $a33cbddcd7bfa0a9$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $a33cbddcd7bfa0a9$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $a33cbddcd7bfa0a9$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $a33cbddcd7bfa0a9$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $a33cbddcd7bfa0a9$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $a33cbddcd7bfa0a9$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $a33cbddcd7bfa0a9$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $a33cbddcd7bfa0a9$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $a33cbddcd7bfa0a9$export$67460cdabfa21253("");
const $a33cbddcd7bfa0a9$var$ot = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $a33cbddcd7bfa0a9$var$ot.exec(e);
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $a33cbddcd7bfa0a9$export$67460cdabfa21253.fromBase64String(e) : $a33cbddcd7bfa0a9$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $a33cbddcd7bfa0a9$var$_t = "server_timestamp", $a33cbddcd7bfa0a9$var$at = "__type__", $a33cbddcd7bfa0a9$var$ut = "__previous_value__", $a33cbddcd7bfa0a9$var$ct = "__local_write_time__";
function $a33cbddcd7bfa0a9$var$__PRIVATE_isServerTimestamp(e) {
    const t = (e?.mapValue?.fields || {})[$a33cbddcd7bfa0a9$var$at]?.stringValue;
    return t === $a33cbddcd7bfa0a9$var$_t;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$a33cbddcd7bfa0a9$var$ut];
    return $a33cbddcd7bfa0a9$var$__PRIVATE_isServerTimestamp(t) ? $a33cbddcd7bfa0a9$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$a33cbddcd7bfa0a9$var$ct].timestampValue);
    return new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a, u){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a, this.isUsingEmulator = u;
    }
}
/** The default database name for a project. */ const $a33cbddcd7bfa0a9$var$lt = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $a33cbddcd7bfa0a9$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || $a33cbddcd7bfa0a9$var$lt;
    }
    static empty() {
        return new $a33cbddcd7bfa0a9$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return this.database === $a33cbddcd7bfa0a9$var$lt;
    }
    isEqual(e) {
        return e instanceof $a33cbddcd7bfa0a9$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$ht = "__type__", $a33cbddcd7bfa0a9$var$Pt = "__max__", $a33cbddcd7bfa0a9$var$Tt = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $a33cbddcd7bfa0a9$var$Pt
            }
        }
    }
}, $a33cbddcd7bfa0a9$var$It = "__vector__", $a33cbddcd7bfa0a9$var$Et = "value", $a33cbddcd7bfa0a9$var$dt = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $a33cbddcd7bfa0a9$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $a33cbddcd7bfa0a9$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $a33cbddcd7bfa0a9$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $a33cbddcd7bfa0a9$var$fail(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(e);
    if (n !== $a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalWriteTime(e).isEqual($a33cbddcd7bfa0a9$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.integerValue) === $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $a33cbddcd7bfa0a9$var$__PRIVATE_isNegativeZero(n) === $a33cbddcd7bfa0a9$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($a33cbddcd7bfa0a9$var$__PRIVATE_objectSize(n) !== $a33cbddcd7bfa0a9$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $a33cbddcd7bfa0a9$var$fail(52216, {
                left: e
            });
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(e, t));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_compareTimestamps($a33cbddcd7bfa0a9$var$__PRIVATE_getLocalWriteTime(e), $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.latitude), $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.longitude), $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                const n = e.fields || {}, r = t.fields || {}, i = n[$a33cbddcd7bfa0a9$var$Et]?.arrayValue, s = r[$a33cbddcd7bfa0a9$var$Et]?.arrayValue, o = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(i?.values?.length || 0, s?.values?.length || 0);
                if (0 !== o) return o;
                return $a33cbddcd7bfa0a9$var$__PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $a33cbddcd7bfa0a9$var$Tt.mapValue && t === $a33cbddcd7bfa0a9$var$Tt.mapValue) return 0;
                if (e === $a33cbddcd7bfa0a9$var$Tt.mapValue) return 1;
                if (t === $a33cbddcd7bfa0a9$var$Tt.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $a33cbddcd7bfa0a9$var$fail(23264, {
                he: n
            });
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e, t);
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(t), i = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $a33cbddcd7bfa0a9$var$canonicalId(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyValue(e);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $a33cbddcd7bfa0a9$var$fail(61005, {
        value: e
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_estimateByteSize(e) {
    switch($a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $a33cbddcd7bfa0a9$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $a33cbddcd7bfa0a9$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $a33cbddcd7bfa0a9$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $a33cbddcd7bfa0a9$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $a33cbddcd7bfa0a9$var$fail(13486, {
                value: e
            });
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $a33cbddcd7bfa0a9$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $a33cbddcd7bfa0a9$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isVectorValue(e) {
    const t = (e?.mapValue?.fields || {})[$a33cbddcd7bfa0a9$var$ht]?.stringValue;
    return t === $a33cbddcd7bfa0a9$var$It;
}
/** Creates a deep copy of `source`. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: {
            ...e.geoPointValue
        }
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: {
            ...e.timestampValue
        }
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $a33cbddcd7bfa0a9$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $a33cbddcd7bfa0a9$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $a33cbddcd7bfa0a9$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return {
        ...e
    };
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $a33cbddcd7bfa0a9$var$Pt;
}
const $a33cbddcd7bfa0a9$var$At = {
    mapValue: {
        fields: {
            [$a33cbddcd7bfa0a9$var$ht]: {
                stringValue: $a33cbddcd7bfa0a9$var$It
            },
            [$a33cbddcd7bfa0a9$var$Et]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $a33cbddcd7bfa0a9$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $a33cbddcd7bfa0a9$var$dt : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $a33cbddcd7bfa0a9$var$__PRIVATE_refValue($a33cbddcd7bfa0a9$export$4c3ccc07620ae30a.empty(), $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $a33cbddcd7bfa0a9$var$__PRIVATE_isVectorValue(e) ? $a33cbddcd7bfa0a9$var$At : {
        mapValue: {}
    } : $a33cbddcd7bfa0a9$var$fail(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $a33cbddcd7bfa0a9$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $a33cbddcd7bfa0a9$var$__PRIVATE_refValue($a33cbddcd7bfa0a9$export$4c3ccc07620ae30a.empty(), $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $a33cbddcd7bfa0a9$var$At : "mapValue" in e ? $a33cbddcd7bfa0a9$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $a33cbddcd7bfa0a9$var$Tt : $a33cbddcd7bfa0a9$var$fail(61959, {
        value: e
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $a33cbddcd7bfa0a9$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $a33cbddcd7bfa0a9$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$a33cbddcd7bfa0a9$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $a33cbddcd7bfa0a9$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $a33cbddcd7bfa0a9$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $a33cbddcd7bfa0a9$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $a33cbddcd7bfa0a9$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $a33cbddcd7bfa0a9$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $a33cbddcd7bfa0a9$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $a33cbddcd7bfa0a9$var$ObjectValue($a33cbddcd7bfa0a9$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $a33cbddcd7bfa0a9$var$forEach(e.fields, (e, n)=>{
        const r = new $a33cbddcd7bfa0a9$export$b7871852b967eaf1([
            e
        ]);
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_isMapValue(n)) {
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $a33cbddcd7bfa0a9$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $a33cbddcd7bfa0a9$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $a33cbddcd7bfa0a9$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), /* readTime */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), /* createTime */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), $a33cbddcd7bfa0a9$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $a33cbddcd7bfa0a9$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $a33cbddcd7bfa0a9$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), /* createTime */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), $a33cbddcd7bfa0a9$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $a33cbddcd7bfa0a9$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), /* createTime */ $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), $a33cbddcd7bfa0a9$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $a33cbddcd7bfa0a9$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $a33cbddcd7bfa0a9$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $a33cbddcd7bfa0a9$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $a33cbddcd7bfa0a9$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $a33cbddcd7bfa0a9$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator($a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $a33cbddcd7bfa0a9$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$Filter {
}
class $a33cbddcd7bfa0a9$var$FieldFilter extends $a33cbddcd7bfa0a9$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $a33cbddcd7bfa0a9$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $a33cbddcd7bfa0a9$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $a33cbddcd7bfa0a9$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $a33cbddcd7bfa0a9$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $a33cbddcd7bfa0a9$var$__PRIVATE_KeyFieldInFilter(e, n) : new $a33cbddcd7bfa0a9$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(this.value) === $a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(t) && this.matchesComparison($a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $a33cbddcd7bfa0a9$var$fail(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $a33cbddcd7bfa0a9$var$CompositeFilter extends $a33cbddcd7bfa0a9$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.Pe = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $a33cbddcd7bfa0a9$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.Pe || (this.Pe = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.Pe;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsFlat(e) && $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $a33cbddcd7bfa0a9$var$CompositeFilter) return !1;
    return !0;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $a33cbddcd7bfa0a9$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $a33cbddcd7bfa0a9$var$canonicalId(e.value);
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $a33cbddcd7bfa0a9$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $a33cbddcd7bfa0a9$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $a33cbddcd7bfa0a9$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $a33cbddcd7bfa0a9$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $a33cbddcd7bfa0a9$var$fail(19439);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $a33cbddcd7bfa0a9$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $a33cbddcd7bfa0a9$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$a33cbddcd7bfa0a9$var$canonicalId(e.value)}`;
    }(e) : e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($a33cbddcd7bfa0a9$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_KeyFieldFilter extends $a33cbddcd7bfa0a9$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_KeyFieldInFilter extends $a33cbddcd7bfa0a9$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $a33cbddcd7bfa0a9$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_KeyFieldNotInFilter extends $a33cbddcd7bfa0a9$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $a33cbddcd7bfa0a9$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    return (t.arrayValue?.values || []).map((e)=>$a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayContainsFilter extends $a33cbddcd7bfa0a9$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $a33cbddcd7bfa0a9$var$isArray(t) && $a33cbddcd7bfa0a9$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_InFilter extends $a33cbddcd7bfa0a9$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $a33cbddcd7bfa0a9$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_NotInFilter extends $a33cbddcd7bfa0a9$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$a33cbddcd7bfa0a9$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayContainsAnyFilter extends $a33cbddcd7bfa0a9$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$a33cbddcd7bfa0a9$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $a33cbddcd7bfa0a9$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.Te = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    if (null === t.Te) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $a33cbddcd7bfa0a9$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$a33cbddcd7bfa0a9$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$a33cbddcd7bfa0a9$var$canonicalId(e)).join(",")), t.Te = e;
    }
    return t.Te;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$a33cbddcd7bfa0a9$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$a33cbddcd7bfa0a9$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$a33cbddcd7bfa0a9$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $a33cbddcd7bfa0a9$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $a33cbddcd7bfa0a9$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $a33cbddcd7bfa0a9$var$dt, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $a33cbddcd7bfa0a9$var$dt, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $a33cbddcd7bfa0a9$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $a33cbddcd7bfa0a9$var$dt;
        }
        $a33cbddcd7bfa0a9$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $a33cbddcd7bfa0a9$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $a33cbddcd7bfa0a9$var$Tt, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $a33cbddcd7bfa0a9$var$Tt, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $a33cbddcd7bfa0a9$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $a33cbddcd7bfa0a9$var$Tt;
        }
        $a33cbddcd7bfa0a9$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $a33cbddcd7bfa0a9$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.Ee = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.de = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryForPath(e) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_queryNormalizedOrderBy(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    if (null === t.Ie) {
        t.Ie = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.Ie.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.Ie.push(new $a33cbddcd7bfa0a9$var$OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($a33cbddcd7bfa0a9$export$b7871852b967eaf1.keyField().canonicalString()) || t.Ie.push(new $a33cbddcd7bfa0a9$var$OrderBy($a33cbddcd7bfa0a9$export$b7871852b967eaf1.keyField(), n));
    }
    return t.Ie;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return t.Ee || (t.Ee = $a33cbddcd7bfa0a9$var$__PRIVATE__queryToTarget(t, $a33cbddcd7bfa0a9$var$__PRIVATE_queryNormalizedOrderBy(e))), t.Ee;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return t.de || // Do not include implicit order-bys for aggregate queries.
    (t.de = $a33cbddcd7bfa0a9$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.de;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $a33cbddcd7bfa0a9$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $a33cbddcd7bfa0a9$var$OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $a33cbddcd7bfa0a9$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $a33cbddcd7bfa0a9$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $a33cbddcd7bfa0a9$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_queryEquals(e, t) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_targetEquals($a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(e), $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyQuery(e) {
    return `${$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget($a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $a33cbddcd7bfa0a9$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$a33cbddcd7bfa0a9$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$a33cbddcd7bfa0a9$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $a33cbddcd7bfa0a9$var$__PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $a33cbddcd7bfa0a9$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $a33cbddcd7bfa0a9$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $a33cbddcd7bfa0a9$var$__PRIVATE_queryNormalizedOrderBy(e)){
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $a33cbddcd7bfa0a9$var$__PRIVATE_valueCompare(r, i) : $a33cbddcd7bfa0a9$var$fail(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $a33cbddcd7bfa0a9$var$fail(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $a33cbddcd7bfa0a9$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $a33cbddcd7bfa0a9$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $a33cbddcd7bfa0a9$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Rt = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
function $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap() {
    return $a33cbddcd7bfa0a9$var$Rt;
}
const $a33cbddcd7bfa0a9$var$Vt = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
function $a33cbddcd7bfa0a9$var$documentMap(...e) {
    let t = $a33cbddcd7bfa0a9$var$Vt;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $a33cbddcd7bfa0a9$var$Vt;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap() {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_newDocumentKeyMap();
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_newMutationMap() {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_newDocumentKeyMap();
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_newDocumentKeyMap() {
    return new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $a33cbddcd7bfa0a9$var$mt = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
const $a33cbddcd7bfa0a9$var$ft = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
function $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(...e) {
    let t = $a33cbddcd7bfa0a9$var$ft;
    for (const n of e)t = t.add(n);
    return t;
}
const $a33cbddcd7bfa0a9$var$gt = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator);
function $a33cbddcd7bfa0a9$var$__PRIVATE_targetIdSet() {
    return $a33cbddcd7bfa0a9$var$gt;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $a33cbddcd7bfa0a9$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $a33cbddcd7bfa0a9$var$toNumber(e, t) {
    return $a33cbddcd7bfa0a9$var$isSafeInteger(t) ? $a33cbddcd7bfa0a9$var$__PRIVATE_toInteger(t) : $a33cbddcd7bfa0a9$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $a33cbddcd7bfa0a9$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$a33cbddcd7bfa0a9$var$at]: {
                    stringValue: $a33cbddcd7bfa0a9$var$_t
                },
                [$a33cbddcd7bfa0a9$var$ct]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $a33cbddcd7bfa0a9$var$__PRIVATE_isServerTimestamp(t) && (t = $a33cbddcd7bfa0a9$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$a33cbddcd7bfa0a9$var$ut] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation ? $a33cbddcd7bfa0a9$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation ? $a33cbddcd7bfa0a9$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $a33cbddcd7bfa0a9$var$asNumber(n) + $a33cbddcd7bfa0a9$var$asNumber(e.Ae);
        return $a33cbddcd7bfa0a9$var$isInteger(n) && $a33cbddcd7bfa0a9$var$isInteger(e.Ae) ? $a33cbddcd7bfa0a9$var$__PRIVATE_toInteger(r) : $a33cbddcd7bfa0a9$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation ? $a33cbddcd7bfa0a9$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation ? $a33cbddcd7bfa0a9$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $a33cbddcd7bfa0a9$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampTransform extends $a33cbddcd7bfa0a9$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation extends $a33cbddcd7bfa0a9$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation extends $a33cbddcd7bfa0a9$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $a33cbddcd7bfa0a9$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementTransformOperation extends $a33cbddcd7bfa0a9$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Ae = t;
    }
}
function $a33cbddcd7bfa0a9$var$asNumber(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $a33cbddcd7bfa0a9$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $a33cbddcd7bfa0a9$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation ? $a33cbddcd7bfa0a9$var$__PRIVATE_arrayEquals(e.elements, t.elements, $a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals) : e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementTransformOperation ? $a33cbddcd7bfa0a9$var$__PRIVATE_valueEquals(e.Ae, t.Ae) : e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampTransform && t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $a33cbddcd7bfa0a9$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $a33cbddcd7bfa0a9$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $a33cbddcd7bfa0a9$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $a33cbddcd7bfa0a9$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $a33cbddcd7bfa0a9$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $a33cbddcd7bfa0a9$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteMutation(e.key, $a33cbddcd7bfa0a9$var$Precondition.none()) : new $a33cbddcd7bfa0a9$var$__PRIVATE_SetMutation(e.key, e.data, $a33cbddcd7bfa0a9$var$Precondition.none());
    {
        const n = e.data, r = $a33cbddcd7bfa0a9$var$ObjectValue.empty();
        let i = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation(e.key, r, new $a33cbddcd7bfa0a9$var$FieldMask(i.toArray()), $a33cbddcd7bfa0a9$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $a33cbddcd7bfa0a9$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($a33cbddcd7bfa0a9$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $a33cbddcd7bfa0a9$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($a33cbddcd7bfa0a9$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $a33cbddcd7bfa0a9$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $a33cbddcd7bfa0a9$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $a33cbddcd7bfa0a9$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SetMutation extends $a33cbddcd7bfa0a9$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation extends $a33cbddcd7bfa0a9$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.length === n.length, 32656, {
        Re: n.length,
        Ve: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $a33cbddcd7bfa0a9$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $a33cbddcd7bfa0a9$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteMutation extends $a33cbddcd7bfa0a9$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_VerifyMutation extends $a33cbddcd7bfa0a9$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $a33cbddcd7bfa0a9$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $a33cbddcd7bfa0a9$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($a33cbddcd7bfa0a9$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $a33cbddcd7bfa0a9$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_mutationEquals(e, t)) && $a33cbddcd7bfa0a9$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $a33cbddcd7bfa0a9$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.mutations.length === n.length, 58842, {
            me: e.mutations.length,
            fe: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $a33cbddcd7bfa0a9$var$mt;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $a33cbddcd7bfa0a9$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $a33cbddcd7bfa0a9$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $a33cbddcd7bfa0a9$var$pt, $a33cbddcd7bfa0a9$var$yt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $a33cbddcd7bfa0a9$var$N.OK:
            return $a33cbddcd7bfa0a9$var$fail(64938);
        case $a33cbddcd7bfa0a9$var$N.CANCELLED:
        case $a33cbddcd7bfa0a9$var$N.UNKNOWN:
        case $a33cbddcd7bfa0a9$var$N.DEADLINE_EXCEEDED:
        case $a33cbddcd7bfa0a9$var$N.RESOURCE_EXHAUSTED:
        case $a33cbddcd7bfa0a9$var$N.INTERNAL:
        case $a33cbddcd7bfa0a9$var$N.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $a33cbddcd7bfa0a9$var$N.UNAUTHENTICATED:
            return !1;
        case $a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT:
        case $a33cbddcd7bfa0a9$var$N.NOT_FOUND:
        case $a33cbddcd7bfa0a9$var$N.ALREADY_EXISTS:
        case $a33cbddcd7bfa0a9$var$N.PERMISSION_DENIED:
        case $a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $a33cbddcd7bfa0a9$var$N.ABORTED:
        case $a33cbddcd7bfa0a9$var$N.OUT_OF_RANGE:
        case $a33cbddcd7bfa0a9$var$N.UNIMPLEMENTED:
        case $a33cbddcd7bfa0a9$var$N.DATA_LOSS:
            return !0;
        default:
            return $a33cbddcd7bfa0a9$var$fail(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $a33cbddcd7bfa0a9$var$__PRIVATE_logError("GRPC error has no .code"), $a33cbddcd7bfa0a9$var$N.UNKNOWN;
    switch(e){
        case $a33cbddcd7bfa0a9$var$pt.OK:
            return $a33cbddcd7bfa0a9$var$N.OK;
        case $a33cbddcd7bfa0a9$var$pt.CANCELLED:
            return $a33cbddcd7bfa0a9$var$N.CANCELLED;
        case $a33cbddcd7bfa0a9$var$pt.UNKNOWN:
            return $a33cbddcd7bfa0a9$var$N.UNKNOWN;
        case $a33cbddcd7bfa0a9$var$pt.DEADLINE_EXCEEDED:
            return $a33cbddcd7bfa0a9$var$N.DEADLINE_EXCEEDED;
        case $a33cbddcd7bfa0a9$var$pt.RESOURCE_EXHAUSTED:
            return $a33cbddcd7bfa0a9$var$N.RESOURCE_EXHAUSTED;
        case $a33cbddcd7bfa0a9$var$pt.INTERNAL:
            return $a33cbddcd7bfa0a9$var$N.INTERNAL;
        case $a33cbddcd7bfa0a9$var$pt.UNAVAILABLE:
            return $a33cbddcd7bfa0a9$var$N.UNAVAILABLE;
        case $a33cbddcd7bfa0a9$var$pt.UNAUTHENTICATED:
            return $a33cbddcd7bfa0a9$var$N.UNAUTHENTICATED;
        case $a33cbddcd7bfa0a9$var$pt.INVALID_ARGUMENT:
            return $a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT;
        case $a33cbddcd7bfa0a9$var$pt.NOT_FOUND:
            return $a33cbddcd7bfa0a9$var$N.NOT_FOUND;
        case $a33cbddcd7bfa0a9$var$pt.ALREADY_EXISTS:
            return $a33cbddcd7bfa0a9$var$N.ALREADY_EXISTS;
        case $a33cbddcd7bfa0a9$var$pt.PERMISSION_DENIED:
            return $a33cbddcd7bfa0a9$var$N.PERMISSION_DENIED;
        case $a33cbddcd7bfa0a9$var$pt.FAILED_PRECONDITION:
            return $a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION;
        case $a33cbddcd7bfa0a9$var$pt.ABORTED:
            return $a33cbddcd7bfa0a9$var$N.ABORTED;
        case $a33cbddcd7bfa0a9$var$pt.OUT_OF_RANGE:
            return $a33cbddcd7bfa0a9$var$N.OUT_OF_RANGE;
        case $a33cbddcd7bfa0a9$var$pt.UNIMPLEMENTED:
            return $a33cbddcd7bfa0a9$var$N.UNIMPLEMENTED;
        case $a33cbddcd7bfa0a9$var$pt.DATA_LOSS:
            return $a33cbddcd7bfa0a9$var$N.DATA_LOSS;
        default:
            return $a33cbddcd7bfa0a9$var$fail(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($a33cbddcd7bfa0a9$var$yt = $a33cbddcd7bfa0a9$var$pt || ($a33cbddcd7bfa0a9$var$pt = {}))[$a33cbddcd7bfa0a9$var$yt.OK = 0] = "OK", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.CANCELLED = 1] = "CANCELLED", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.UNKNOWN = 2] = "UNKNOWN", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.NOT_FOUND = 5] = "NOT_FOUND", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.ABORTED = 10] = "ABORTED", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.INTERNAL = 13] = "INTERNAL", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.UNAVAILABLE = 14] = "UNAVAILABLE", $a33cbddcd7bfa0a9$var$yt[$a33cbddcd7bfa0a9$var$yt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $a33cbddcd7bfa0a9$var$wt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$St = new (0, $906344b47e605252$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $a33cbddcd7bfa0a9$var$__PRIVATE_getMd5HashValue(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $906344b47e605252$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $a33cbddcd7bfa0a9$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $a33cbddcd7bfa0a9$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $a33cbddcd7bfa0a9$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $a33cbddcd7bfa0a9$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $a33cbddcd7bfa0a9$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $a33cbddcd7bfa0a9$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.ge = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.pe = (0, $906344b47e605252$export$70ffa26850098d01).fromNumber(this.ge);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    ye(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $906344b47e605252$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($a33cbddcd7bfa0a9$var$St) && (r = new (0, $906344b47e605252$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.pe).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    we(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.ge) return !1;
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_getMd5HashValue(e), [n, r] = $a33cbddcd7bfa0a9$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            if (!this.we(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $a33cbddcd7bfa0a9$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.ge) return;
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_getMd5HashValue(e), [n, r] = $a33cbddcd7bfa0a9$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            this.Se(t);
        }
    }
    Se(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $a33cbddcd7bfa0a9$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $a33cbddcd7bfa0a9$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $a33cbddcd7bfa0a9$var$RemoteEvent($a33cbddcd7bfa0a9$var$SnapshotVersion.min(), r, new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator), $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap(), $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $a33cbddcd7bfa0a9$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $a33cbddcd7bfa0a9$var$TargetChange(n, t, $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.be = e, this.removedTargetIds = t, this.key = n, this.De = r;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.Ce = t;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ve = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Fe = $a33cbddcd7bfa0a9$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Me = $a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.xe = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Oe = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.xe;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Me;
    }
    /** Whether this target has pending target adds or target removes. */ get Ne() {
        return 0 !== this.ve;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Be() {
        return this.Oe;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Le(e) {
        e.approximateByteSize() > 0 && (this.Oe = !0, this.Me = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ke() {
        let e = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), t = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        return this.Fe.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $a33cbddcd7bfa0a9$var$fail(38017, {
                        changeType: i
                    });
            }
        }), new $a33cbddcd7bfa0a9$var$TargetChange(this.Me, this.xe, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ qe() {
        this.Oe = !1, this.Fe = $a33cbddcd7bfa0a9$var$__PRIVATE_snapshotChangesMap();
    }
    Qe(e, t) {
        this.Oe = !0, this.Fe = this.Fe.insert(e, t);
    }
    $e(e) {
        this.Oe = !0, this.Fe = this.Fe.remove(e);
    }
    Ue() {
        this.ve += 1;
    }
    Ke() {
        this.ve -= 1, $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(this.ve >= 0, 3241, {
            ve: this.ve
        });
    }
    We() {
        this.Oe = !0, this.xe = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Ge = e, /** The internal state of all tracked targets. */ this.ze = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.je = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap(), this.Je = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.He = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Ye = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ze(e) {
        for (const t of e.be)e.De && e.De.isFoundDocument() ? this.Xe(t, e.De) : this.et(t, e.key, e.De);
        for (const t of e.removedTargetIds)this.et(t, e.key, e.De);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ tt(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.nt(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.rt(t) && n.Le(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ke(), n.Ne || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.qe(), n.Le(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ke(), n.Ne || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.rt(t) && (n.We(), n.Le(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.rt(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.it(t), n.Le(e.resumeToken));
                    break;
                default:
                    $a33cbddcd7bfa0a9$var$fail(56790, {
                        state: e.state
                    });
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.ze.forEach((e, n)=>{
            this.rt(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ st(e) {
        const t = e.targetId, n = e.Ce.count, r = this.ot(t);
        if (r) {
            const i = r.target;
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(i.path);
                    this.et(t, e, $a33cbddcd7bfa0a9$var$MutableDocument.newNoDocument(e, $a33cbddcd7bfa0a9$var$SnapshotVersion.min()));
                } else $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(1 === n, 20013, {
                    expectedCount: n
                });
            } else {
                const r = this._t(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.ut(e), i = n ? this.ct(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.it(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Ye = this.Ye.insert(t, e);
                    }
                    $a33cbddcd7bfa0a9$var$wt?.lt(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        const s = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, o = t.unchangedNames;
                        o && (s.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: o?.hashCount ?? 0,
                            bitmapLength: o?.bits?.bitmap?.length ?? 0,
                            padding: o?.bits?.padding ?? 0,
                            mightContain: (e)=>r?.mightContain(e) ?? !1
                        });
                        return s;
                    }(r, e.Ce, this.Ge.ht(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ ut(e) {
        const t = e.Ce.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_Base64DecodeError) return $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $a33cbddcd7bfa0a9$var$BloomFilter(s, r, i);
        } catch (e) {
            return $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb(e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.ge ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ ct(e, t, n) {
        return t.Ce.count === n - this.Pt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ Pt(e, t) {
        const n = this.Ge.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Ge.ht(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.et(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Tt(e) {
        const t = new Map;
        this.ze.forEach((n, r)=>{
            const i = this.ot(r);
            if (i) {
                if (n.current && $a33cbddcd7bfa0a9$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(i.target.path);
                    this.It(t).has(r) || this.Et(r, t) || this.et(r, t, $a33cbddcd7bfa0a9$var$MutableDocument.newNoDocument(t, e));
                }
                n.Be && (t.set(r, n.ke()), n.qe());
            }
        });
        let n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.He.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.ot(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.je.forEach((t, n)=>n.setReadTime(e));
        const r = new $a33cbddcd7bfa0a9$var$RemoteEvent(e, t, this.Ye, this.je, n);
        return this.je = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap(), this.Je = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetMap(), this.He = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetMap(), this.Ye = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Xe(e, t) {
        if (!this.rt(e)) return;
        const n = this.Et(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.nt(e).Qe(t.key, n), this.je = this.je.insert(t.key, t), this.Je = this.Je.insert(t.key, this.It(t.key).add(e)), this.He = this.He.insert(t.key, this.dt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    et(e, t, n) {
        if (!this.rt(e)) return;
        const r = this.nt(e);
        this.Et(e, t) ? r.Qe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.$e(t), this.He = this.He.insert(t, this.dt(t).delete(e)), this.He = this.He.insert(t, this.dt(t).add(e)), n && (this.je = this.je.insert(t, n));
    }
    removeTarget(e) {
        this.ze.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ _t(e) {
        const t = this.nt(e).ke();
        return this.Ge.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ Ue(e) {
        this.nt(e).Ue();
    }
    nt(e) {
        let t = this.ze.get(e);
        return t || (t = new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetState, this.ze.set(e, t)), t;
    }
    dt(e) {
        let t = this.He.get(e);
        return t || (t = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator), this.He = this.He.insert(e, t)), t;
    }
    It(e) {
        let t = this.Je.get(e);
        return t || (t = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ rt(e) {
        const t = null !== this.ot(e);
        return t || $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ ot(e) {
        const t = this.ze.get(e);
        return t && t.Ne ? null : this.Ge.At(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ it(e) {
        this.ze.set(e, new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetState);
        this.Ge.getRemoteKeysForTarget(e).forEach((t)=>{
            this.et(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ Et(e, t) {
        return this.Ge.getRemoteKeysForTarget(e).has(t);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetMap() {
    return new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_snapshotChangesMap() {
    return new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
}
const $a33cbddcd7bfa0a9$var$bt = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $a33cbddcd7bfa0a9$var$Dt = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $a33cbddcd7bfa0a9$var$Ct = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $a33cbddcd7bfa0a9$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $a33cbddcd7bfa0a9$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $a33cbddcd7bfa0a9$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ /**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toVersion(e, t) {
    return $a33cbddcd7bfa0a9$var$toTimestamp(e, t.toTimestamp());
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!e, 49232), $a33cbddcd7bfa0a9$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(e);
        return new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toResourceName(e, t) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $a33cbddcd7bfa0a9$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromResourceName(e) {
    const t = $a33cbddcd7bfa0a9$var$ResourcePath.fromString(e);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert($a33cbddcd7bfa0a9$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toName(e, t) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $a33cbddcd7bfa0a9$var$fromName(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryPath(e, t) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromQueryPath(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $a33cbddcd7bfa0a9$var$ResourcePath.emptyPath() : $a33cbddcd7bfa0a9$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $a33cbddcd7bfa0a9$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $a33cbddcd7bfa0a9$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$fromName(e, t.name), i = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.createTime) : $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), o = new $a33cbddcd7bfa0a9$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $a33cbddcd7bfa0a9$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $a33cbddcd7bfa0a9$var$fromName(e, t.found.name), r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.found.createTime) : $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), s = new $a33cbddcd7bfa0a9$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $a33cbddcd7bfa0a9$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!t.missing, 3894), $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!t.readTime, 22933);
        const n = $a33cbddcd7bfa0a9$var$fromName(e, t.missing), r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.readTime);
        return $a33cbddcd7bfa0a9$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $a33cbddcd7bfa0a9$var$fail(7234, {
        result: t
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $a33cbddcd7bfa0a9$var$fail(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t, 58123), $a33cbddcd7bfa0a9$export$67460cdabfa21253.fromBase64String(t || "")) : ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $a33cbddcd7bfa0a9$require$Buffer || t instanceof Uint8Array, 16193), $a33cbddcd7bfa0a9$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $a33cbddcd7bfa0a9$var$N.UNKNOWN : $a33cbddcd7bfa0a9$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $a33cbddcd7bfa0a9$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $a33cbddcd7bfa0a9$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $a33cbddcd7bfa0a9$var$fromName(e, r.document.name), s = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(r.document.createTime) : $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), _ = new $a33cbddcd7bfa0a9$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $a33cbddcd7bfa0a9$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $a33cbddcd7bfa0a9$var$fromName(e, r.document), s = r.readTime ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(r.readTime) : $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), o = $a33cbddcd7bfa0a9$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $a33cbddcd7bfa0a9$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $a33cbddcd7bfa0a9$var$fail(11601, {
            Rt: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $a33cbddcd7bfa0a9$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $a33cbddcd7bfa0a9$var$toMutation(e, t) {
    let n;
    if (t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_SetMutation) n = {
        update: $a33cbddcd7bfa0a9$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteMutation) n = {
        delete: $a33cbddcd7bfa0a9$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation) n = {
        update: $a33cbddcd7bfa0a9$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $a33cbddcd7bfa0a9$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_VerifyMutation)) return $a33cbddcd7bfa0a9$var$fail(16599, {
            Vt: t.type
        });
        n = {
            verify: $a33cbddcd7bfa0a9$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Ae
            };
            throw $a33cbddcd7bfa0a9$var$fail(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $a33cbddcd7bfa0a9$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $a33cbddcd7bfa0a9$var$fail(27497);
    }(e, t.precondition)), n;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $a33cbddcd7bfa0a9$var$Precondition.updateTime($a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $a33cbddcd7bfa0a9$var$Precondition.exists(e.exists) : $a33cbddcd7bfa0a9$var$Precondition.none();
    }(t.currentDocument) : $a33cbddcd7bfa0a9$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $a33cbddcd7bfa0a9$var$fail(16584, {
                proto: t
            });
            const r = $a33cbddcd7bfa0a9$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $a33cbddcd7bfa0a9$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $a33cbddcd7bfa0a9$var$fromName(e, t.update.name), s = new $a33cbddcd7bfa0a9$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $a33cbddcd7bfa0a9$var$FieldMask(t.map((e)=>$a33cbddcd7bfa0a9$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $a33cbddcd7bfa0a9$var$fromName(e, t.delete);
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $a33cbddcd7bfa0a9$var$fromName(e, t.verify);
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $a33cbddcd7bfa0a9$var$fail(1463, {
        proto: t
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e.updateTime) : $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t);
            return n.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t)), new $a33cbddcd7bfa0a9$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_toFilter($a33cbddcd7bfa0a9$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $a33cbddcd7bfa0a9$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $a33cbddcd7bfa0a9$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        ft: n,
        parent: i
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { ft: i, parent: s } = $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        gt: o,
        parent: s
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromFilter(e);
        if (t instanceof $a33cbddcd7bfa0a9$var$CompositeFilter && $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $a33cbddcd7bfa0a9$var$OrderBy($a33cbddcd7bfa0a9$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $a33cbddcd7bfa0a9$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $a33cbddcd7bfa0a9$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $a33cbddcd7bfa0a9$var$Bound(n, t);
    }(n.endAt)), $a33cbddcd7bfa0a9$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $a33cbddcd7bfa0a9$var$fail(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $a33cbddcd7bfa0a9$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $a33cbddcd7bfa0a9$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $a33cbddcd7bfa0a9$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $a33cbddcd7bfa0a9$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $a33cbddcd7bfa0a9$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $a33cbddcd7bfa0a9$var$fail(61313);
            default:
                return $a33cbddcd7bfa0a9$var$fail(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $a33cbddcd7bfa0a9$var$FieldFilter.create($a33cbddcd7bfa0a9$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $a33cbddcd7bfa0a9$var$fail(58110);
                default:
                    return $a33cbddcd7bfa0a9$var$fail(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $a33cbddcd7bfa0a9$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $a33cbddcd7bfa0a9$var$fail(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $a33cbddcd7bfa0a9$var$fail(30097, {
        filter: e
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toDirection(e) {
    return $a33cbddcd7bfa0a9$var$bt[e];
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toOperatorName(e) {
    return $a33cbddcd7bfa0a9$var$Dt[e];
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toCompositeOperatorName(e) {
    return $a33cbddcd7bfa0a9$var$Ct[e];
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromFieldPathReference(e) {
    return $a33cbddcd7bfa0a9$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toFilter(e) {
    return e instanceof $a33cbddcd7bfa0a9$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $a33cbddcd7bfa0a9$var$__PRIVATE_toFieldPathReference(e.field),
                op: $a33cbddcd7bfa0a9$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $a33cbddcd7bfa0a9$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $a33cbddcd7bfa0a9$var$fail(54877, {
        filter: e
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $a33cbddcd7bfa0a9$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), s = $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), o = $a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $a33cbddcd7bfa0a9$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $a33cbddcd7bfa0a9$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $a33cbddcd7bfa0a9$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $a33cbddcd7bfa0a9$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.yt = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDocument(e.yt, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $a33cbddcd7bfa0a9$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $a33cbddcd7bfa0a9$var$fail(56709);
        {
            const e = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $a33cbddcd7bfa0a9$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $a33cbddcd7bfa0a9$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $a33cbddcd7bfa0a9$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $a33cbddcd7bfa0a9$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $a33cbddcd7bfa0a9$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.yt, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $a33cbddcd7bfa0a9$var$fail(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $a33cbddcd7bfa0a9$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_fromMutation(e.yt, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_fromMutation(e.yt, t)), i = $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $a33cbddcd7bfa0a9$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTarget(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $a33cbddcd7bfa0a9$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(1 === t, 1966, {
            count: t
        }), $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget($a33cbddcd7bfa0a9$var$__PRIVATE_newQueryForPath($a33cbddcd7bfa0a9$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget($a33cbddcd7bfa0a9$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $a33cbddcd7bfa0a9$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $a33cbddcd7bfa0a9$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTarget(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $a33cbddcd7bfa0a9$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $a33cbddcd7bfa0a9$var$__PRIVATE_toDocumentsTarget(e.yt, t.target) : $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryTarget(e.yt, t.target).ft;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fromBundledQuery(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $a33cbddcd7bfa0a9$var$Overlay(t.largestBatchId, $a33cbddcd7bfa0a9$var$__PRIVATE_fromMutation(e.yt, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp($a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $a33cbddcd7bfa0a9$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestamp($a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_bundlesStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$be);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_namedQueriesStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Ce);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static wt(e, t) {
        const n = t.uid || "";
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentOverlayStore(e).get($a33cbddcd7bfa0a9$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap();
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $a33cbddcd7bfa0a9$var$Overlay(t, i);
            r.push(this.St(e, s));
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($a33cbddcd7bfa0a9$var$__PRIVATE_documentOverlayStore(e).Z($a33cbddcd7bfa0a9$var$Ge, r));
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap(), i = $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentOverlayStore(e).J($a33cbddcd7bfa0a9$var$Ge, s).next((e)=>{
            for (const t of e){
                const e = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentOverlayStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$je,
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    St(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $a33cbddcd7bfa0a9$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $a33cbddcd7bfa0a9$var$toMutation(e.yt, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_documentOverlayStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Ke);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbGlobalsCache {
    bt(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$He);
    }
    getSessionToken(e) {
        return this.bt(e).get("sessionToken").next((e)=>{
            const t = e?.value;
            return t ? $a33cbddcd7bfa0a9$export$67460cdabfa21253.fromUint8Array(t) : $a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.bt(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Dt(e, t) {
        this.Ct(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.vt();
    }
    Ct(e, t) {
        if ("nullValue" in e) this.Ft(t, 5);
        else if ("booleanValue" in e) this.Ft(t, 10), t.Mt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Ft(t, 15), t.Mt($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Ft(t, 13) : (this.Ft(t, 15), $a33cbddcd7bfa0a9$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.Mt(0) : t.Mt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Ft(t, 20), "string" == typeof n && (n = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(n)), t.xt(`${n.seconds || ""}`), t.Mt(n.nanos || 0);
        } else if ("stringValue" in e) this.Ot(e.stringValue, t), this.Nt(t);
        else if ("bytesValue" in e) this.Ft(t, 30), t.Bt($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Nt(t);
        else if ("referenceValue" in e) this.Lt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Ft(t, 45), t.Mt(n.latitude || 0), t.Mt(n.longitude || 0);
        } else "mapValue" in e ? $a33cbddcd7bfa0a9$var$__PRIVATE_isMaxValue(e) ? this.Ft(t, Number.MAX_SAFE_INTEGER) : $a33cbddcd7bfa0a9$var$__PRIVATE_isVectorValue(e) ? this.kt(e.mapValue, t) : (this.qt(e.mapValue, t), this.Nt(t)) : "arrayValue" in e ? (this.Qt(e.arrayValue, t), this.Nt(t)) : $a33cbddcd7bfa0a9$var$fail(19022, {
            $t: e
        });
    }
    Ot(e, t) {
        this.Ft(t, 25), this.Ut(e, t);
    }
    Ut(e, t) {
        t.xt(e);
    }
    qt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 55);
        for (const e of Object.keys(n))this.Ot(e, t), this.Ct(n[e], t);
    }
    kt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 53);
        // Vectors sort first by length
        const r = $a33cbddcd7bfa0a9$var$Et, i = n[r].arrayValue?.values?.length || 0;
        this.Ft(t, 15), t.Mt($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
        this.Ot(r, t), this.Ct(n[r], t);
    }
    Qt(e, t) {
        const n = e.values || [];
        this.Ft(t, 50);
        for (const e of n)this.Ct(e, t);
    }
    Lt(e, t) {
        this.Ft(t, 37);
        $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.Ft(t, 60), this.Ut(e, t);
        });
    }
    Ft(e, t) {
        e.Mt(t);
    }
    Nt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Mt(2);
    }
}
$a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter.Kt = new $a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $a33cbddcd7bfa0a9$var$vt = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Wt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Gt(n.value), n = t.next();
        this.zt();
    }
    jt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Jt(n.value), n = t.next();
        this.Ht();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Yt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Gt(e);
            else if (e < 2048) this.Gt(960 | e >>> 6), this.Gt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Gt(480 | e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Gt(240 | e >>> 18), this.Gt(128 | 63 & e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            }
        }
        this.zt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Zt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Jt(e);
            else if (e < 2048) this.Jt(960 | e >>> 6), this.Jt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Jt(480 | e >>> 12), this.Jt(128 | 63 & e >>> 6), this.Jt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Jt(240 | e >>> 18), this.Jt(128 | 63 & e >>> 12), this.Jt(128 | 63 & e >>> 6), this.Jt(128 | 63 & e);
            }
        }
        this.Ht();
    }
    Xt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $a33cbddcd7bfa0a9$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    nn(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $a33cbddcd7bfa0a9$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ rn() {
        this.sn($a33cbddcd7bfa0a9$var$vt), this.sn(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ _n() {
        this.an($a33cbddcd7bfa0a9$var$vt), this.an(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.tn(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ un() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ en(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Gt(e) {
        const t = 255 & e;
        0 === t ? (this.sn(0), this.sn(255)) : t === $a33cbddcd7bfa0a9$var$vt ? (this.sn($a33cbddcd7bfa0a9$var$vt), this.sn(0)) : this.sn(t);
    }
    /** Writes a single byte descending to the buffer.  */ Jt(e) {
        const t = 255 & e;
        0 === t ? (this.an(0), this.an(255)) : t === $a33cbddcd7bfa0a9$var$vt ? (this.an($a33cbddcd7bfa0a9$var$vt), this.an(0)) : this.an(e);
    }
    zt() {
        this.sn(0), this.sn(1);
    }
    Ht() {
        this.an(0), this.an(1);
    }
    sn(e) {
        this.tn(1), this.buffer[this.position++] = e;
    }
    an(e) {
        this.tn(1), this.buffer[this.position++] = ~e;
    }
    tn(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.Wt(e);
    }
    xt(e) {
        this.cn.Yt(e);
    }
    Mt(e) {
        this.cn.Xt(e);
    }
    vt() {
        this.cn.rn();
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.jt(e);
    }
    xt(e) {
        this.cn.Zt(e);
    }
    Mt(e) {
        this.cn.nn(e);
    }
    vt() {
        this.cn._n();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.cn = new $a33cbddcd7bfa0a9$var$__PRIVATE_OrderedCodeWriter, this.ln = new $a33cbddcd7bfa0a9$var$__PRIVATE_AscendingIndexByteEncoder(this.cn), this.hn = new $a33cbddcd7bfa0a9$var$__PRIVATE_DescendingIndexByteEncoder(this.cn);
    }
    seed(e) {
        this.cn.seed(e);
    }
    Pn(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.ln : this.hn;
    }
    un() {
        return this.cn.un();
    }
    reset() {
        this.cn.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.Tn = e, this.In = t, this.En = n, this.dn = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ An() {
        const e = this.dn.length, t = 0 === e || 255 === this.dn[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.dn, 0), t !== e ? n.set([
            0
        ], this.dn.length) : ++n[n.length - 1], new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexEntry(this.Tn, this.In, this.En, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    Rn(e, t, n) {
        return {
            indexId: this.Tn,
            uid: e,
            arrayValue: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeKeySafeBytes(this.En),
            directionalValue: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeKeySafeBytes(this.dn),
            orderedDocumentKey: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    Vn(e, t, n) {
        const r = this.Rn(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.Tn - t.Tn;
    return 0 !== n ? n : (n = $a33cbddcd7bfa0a9$var$__PRIVATE_compareByteArrays(e.En, t.En), 0 !== n ? n : (n = $a33cbddcd7bfa0a9$var$__PRIVATE_compareByteArrays(e.dn, t.dn), 0 !== n ? n : $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(e.In, t.In)));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $029952e65115eee5$export$ef10bcfb06572016)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.mn = new $a33cbddcd7bfa0a9$var$SortedSet((e, t)=>$a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.fn = e.orderBy, this.gn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.mn = this.mn.add(e) : this.gn.push(e);
        }
    }
    get pn() {
        return this.mn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ yn(e) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId, 49279), this.pn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.wn(t)) return !1;
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.wn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.mn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.mn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.Sn(e, t) || !this.bn(this.fn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.fn.length || !this.bn(this.fn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ Dn() {
        if (this.pn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator);
        const t = [];
        for (const n of this.gn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $a33cbddcd7bfa0a9$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $a33cbddcd7bfa0a9$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.fn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $a33cbddcd7bfa0a9$var$IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $a33cbddcd7bfa0a9$var$FieldIndex($a33cbddcd7bfa0a9$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $a33cbddcd7bfa0a9$var$IndexState.empty());
    }
    wn(e) {
        for (const t of this.gn)if (this.Sn(t, e)) return !0;
        return !1;
    }
    Sn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    bn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_computeInExpansion(e) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e instanceof $a33cbddcd7bfa0a9$var$FieldFilter || e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter, 20012), e instanceof $a33cbddcd7bfa0a9$var$FieldFilter) {
        if (e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_InFilter) {
            const t = e.value.arrayValue?.values?.map((t)=>$a33cbddcd7bfa0a9$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t)) || [];
            return $a33cbddcd7bfa0a9$var$CompositeFilter.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const t = e.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_computeInExpansion(e));
    return $a33cbddcd7bfa0a9$var$CompositeFilter.create(t, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_computeDistributedNormalForm($a33cbddcd7bfa0a9$var$__PRIVATE_computeInExpansion(e));
    return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert($a33cbddcd7bfa0a9$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $a33cbddcd7bfa0a9$var$__PRIVATE_isSingleFieldFilter(t) || $a33cbddcd7bfa0a9$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $a33cbddcd7bfa0a9$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter && $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_isSingleFieldFilter(e) || $a33cbddcd7bfa0a9$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter && $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isSingleFieldFilter(t) && !$a33cbddcd7bfa0a9$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e instanceof $a33cbddcd7bfa0a9$var$FieldFilter || e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter, 34018), e instanceof $a33cbddcd7bfa0a9$var$FieldFilter) return e;
    if (1 === e.filters.length) return $a33cbddcd7bfa0a9$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $a33cbddcd7bfa0a9$var$CompositeFilter.create(t, e.op);
    return n = $a33cbddcd7bfa0a9$var$__PRIVATE_applyAssociation(n), $a33cbddcd7bfa0a9$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(n instanceof $a33cbddcd7bfa0a9$var$CompositeFilter, 64498), $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert($a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_applyDistribution(e, t)));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e instanceof $a33cbddcd7bfa0a9$var$FieldFilter || e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter, 38388), $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(t instanceof $a33cbddcd7bfa0a9$var$FieldFilter || t instanceof $a33cbddcd7bfa0a9$var$CompositeFilter, 25473), // FieldFilter FieldFilter
    n = e instanceof $a33cbddcd7bfa0a9$var$FieldFilter ? t instanceof $a33cbddcd7bfa0a9$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $a33cbddcd7bfa0a9$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $a33cbddcd7bfa0a9$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $a33cbddcd7bfa0a9$var$FieldFilter ? $a33cbddcd7bfa0a9$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0, 48005), $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsConjunction(e) && $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsConjunction(t)) return $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_applyDistribution(e, r));
        return $a33cbddcd7bfa0a9$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $a33cbddcd7bfa0a9$var$__PRIVATE_applyAssociation(n);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_applyDistribution(e, t));
        return $a33cbddcd7bfa0a9$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_applyAssociation(e) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e instanceof $a33cbddcd7bfa0a9$var$FieldFilter || e instanceof $a33cbddcd7bfa0a9$var$CompositeFilter, 11850), e instanceof $a33cbddcd7bfa0a9$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $a33cbddcd7bfa0a9$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $a33cbddcd7bfa0a9$var$FieldFilter ? r.push(t) : t instanceof $a33cbddcd7bfa0a9$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $a33cbddcd7bfa0a9$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Cn = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Cn.add(t), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.Cn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve($a33cbddcd7bfa0a9$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve($a33cbddcd7bfa0a9$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Ft = "IndexedDbIndexManager", $a33cbddcd7bfa0a9$var$Mt = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.vn = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Fn = new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget(e), (e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.vn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.vn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(r)
            };
            return $a33cbddcd7bfa0a9$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $a33cbddcd7bfa0a9$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_collectionParentsStore(e).J(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($a33cbddcd7bfa0a9$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexConfigurationStore(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_indexStateStore(e), i = $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_indexConfigurationStore(e), n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntriesStore(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_indexStateStore(e);
        return t.Z().next(()=>n.Z()).next(()=>r.Z());
    }
    createTargetIndexes(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(this.Mn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIndexMatcher(t).Dn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(this.Mn(t), (t)=>this.xn(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
                const r = [];
                return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(i, (i, s)=>{
                    $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Ft, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $a33cbddcd7bfa0a9$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $a33cbddcd7bfa0a9$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $a33cbddcd7bfa0a9$var$Bound(n, r);
                    }(s, i), c = this.On(i, s, a), l = this.On(i, s, u), h = this.Nn(i, s, _), P = this.Bn(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(P, (i)=>n.Y(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(null);
        });
    }
    Mn(e) {
        let t = this.Fn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $a33cbddcd7bfa0a9$var$__PRIVATE_getDnfTerms($a33cbddcd7bfa0a9$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Fn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ Bn(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Ln(t[c / a]) : $a33cbddcd7bfa0a9$var$Mt, l = this.kn(e, _, n[c % a], r), h = this.qn(e, _, i[c % a], s), P = o.map((t)=>this.kn(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ kn(e, t, n, r) {
        const i = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexEntry(e, $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.An();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ qn(e, t, n, r) {
        const i = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexEntry(e, $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.An() : i;
    }
    xn(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.yn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.Mn(t);
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(r, (t)=>this.xn(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ Qn(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexByteEncoder;
        for (const r of $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Pn(r.kind);
            $a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter.Kt.Dt(e, i);
        }
        return n.un();
    }
    /** Encodes a single value to the ascending index format. */ Ln(e) {
        const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexByteEncoder;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter.Kt.Dt(e, t.Pn(0 /* IndexKind.ASCENDING */ )), t.un();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ $n(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexByteEncoder;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter.Kt.Dt($a33cbddcd7bfa0a9$var$__PRIVATE_refValue(this.databaseId, t), n.Pn(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.un();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ Nn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.Un(t, s.fieldPath) && $a33cbddcd7bfa0a9$var$isArray(e)) r = this.Kn(r, s, e);
            else {
                const t = n.Pn(s.kind);
                $a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter.Kt.Dt(e, t);
            }
        }
        return this.Wn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ On(e, t, n) {
        return this.Nn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ Wn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].un();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Kn(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.un()), $a33cbddcd7bfa0a9$var$__PRIVATE_FirestoreIndexValueWriter.Kt.Dt(e, r.Pn(t.kind)), i.push(r);
        }
        return i;
    }
    Un(e, t) {
        return !!e.filters.find((e)=>e instanceof $a33cbddcd7bfa0a9$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexConfigurationStore(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_indexStateStore(e);
        return (t ? n.J($a33cbddcd7bfa0a9$var$xe, IDBKeyRange.bound(t, t)) : n.J()).next((e)=>{
            const t = [];
            return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $a33cbddcd7bfa0a9$var$IndexState(t.sequenceNumber, new $a33cbddcd7bfa0a9$var$IndexOffset($a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTimestamp(t.readTime), new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $a33cbddcd7bfa0a9$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $a33cbddcd7bfa0a9$var$IndexSegment($a33cbddcd7bfa0a9$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $a33cbddcd7bfa0a9$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_indexConfigurationStore(e), i = $a33cbddcd7bfa0a9$var$__PRIVATE_indexStateStore(e);
        return this.Gn(e).next((e)=>r.J($a33cbddcd7bfa0a9$var$xe, IDBKeyRange.bound(t, t)).next((t)=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t)=>i.put($a33cbddcd7bfa0a9$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(i, (n)=>this.zn(e, t, n).next((t)=>{
                        const i = this.jn(r, n);
                        return t.isEqual(i) ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve() : this.Jn(e, r, n, t, i);
                    }))));
        });
    }
    Hn(e, t, n, r) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntriesStore(e).put(r.Rn(this.uid, this.$n(n, t.key), t.key));
    }
    Yn(e, t, n, r) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntriesStore(e).delete(r.Vn(this.uid, this.$n(n, t.key), t.key));
    }
    zn(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntriesStore(e);
        let i = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator);
        return r.ee({
            index: $a33cbddcd7bfa0a9$var$$e,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $a33cbddcd7bfa0a9$var$__PRIVATE_encodeKeySafeBytes(this.$n(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexEntry(n.indexId, t, $a33cbddcd7bfa0a9$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $a33cbddcd7bfa0a9$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ jn(e, t) {
        let n = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator);
        const r = this.Qn(t, e);
        if (null == r) return n;
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($a33cbddcd7bfa0a9$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Ln(i), r));
        } else n = n.add(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexEntry(t.indexId, e.key, $a33cbddcd7bfa0a9$var$Mt, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ Jn(e, t, n, r, i) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Ft, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $a33cbddcd7bfa0a9$var$__PRIVATE_advanceIterator(s), a = $a33cbddcd7bfa0a9$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $a33cbddcd7bfa0a9$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $a33cbddcd7bfa0a9$var$__PRIVATE_advanceIterator(s)) : (_ = $a33cbddcd7bfa0a9$var$__PRIVATE_advanceIterator(s), a = $a33cbddcd7bfa0a9$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.Hn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Yn(e, t, n, r));
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(s);
    }
    Gn(e) {
        let t = 1;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_indexStateStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$Le,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator(i, e), s = $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.An();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.An());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Zn(r[e], r[e + 1])) return [];
            const t = r[e].Vn(this.uid, $a33cbddcd7bfa0a9$var$Mt, $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty()), n = r[e + 1].Vn(this.uid, $a33cbddcd7bfa0a9$var$Mt, $a33cbddcd7bfa0a9$export$afc2e57c475b7810.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Zn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($a33cbddcd7bfa0a9$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.mapArray(this.Mn(t), (t)=>this.xn(e, t).next((e)=>e || $a33cbddcd7bfa0a9$var$fail(44426))).next($a33cbddcd7bfa0a9$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_collectionParentsStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$pe);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_indexEntriesStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$qe);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_indexConfigurationStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Fe);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_indexStateStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Ne);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $a33cbddcd7bfa0a9$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $a33cbddcd7bfa0a9$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$xt = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $a33cbddcd7bfa0a9$var$Ot = 41943040;
class $a33cbddcd7bfa0a9$var$LruParams {
    static withCacheSize(e) {
        return new $a33cbddcd7bfa0a9$var$LruParams(e, $a33cbddcd7bfa0a9$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $a33cbddcd7bfa0a9$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $a33cbddcd7bfa0a9$var$removeMutationBatch(e, t, n) {
    const r = e.store($a33cbddcd7bfa0a9$var$te), i = e.store($a33cbddcd7bfa0a9$var$oe), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.ee({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(1 === _, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $a33cbddcd7bfa0a9$var$fail(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $a33cbddcd7bfa0a9$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $a33cbddcd7bfa0a9$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $a33cbddcd7bfa0a9$var$LruParams.DEFAULT = new $a33cbddcd7bfa0a9$var$LruParams($a33cbddcd7bfa0a9$var$Ot, $a33cbddcd7bfa0a9$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $a33cbddcd7bfa0a9$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $a33cbddcd7bfa0a9$var$LruParams.DISABLED = new $a33cbddcd7bfa0a9$var$LruParams(-1, 0, 0);
class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Xn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static wt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$re,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentMutationsStore(e), s = $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert("number" == typeof o, 49019);
            const _ = new $a33cbddcd7bfa0a9$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$a33cbddcd7bfa0a9$var$toMutation(e.yt, t)), i = n.mutations.map((t)=>$a33cbddcd7bfa0a9$var$toMutation(e.yt, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $a33cbddcd7bfa0a9$var$SortedSet((e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $a33cbddcd7bfa0a9$var$se));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Xn[o] = _.keys();
            }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    er(e, t) {
        return this.Xn[t] ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.Xn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Xn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$re,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(t.batchId >= n, 47524, {
                tr: n
            }), i = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $a33cbddcd7bfa0a9$var$j;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$re,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $a33cbddcd7bfa0a9$var$j
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e).J($a33cbddcd7bfa0a9$var$re, t).next((e)=>e.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentMutationsStore(e).ee({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $a33cbddcd7bfa0a9$var$fail(61480, {
                    nr: n,
                    batchId: a
                });
                $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $a33cbddcd7bfa0a9$var$__PRIVATE_documentMutationsStore(e).ee({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(r).next(()=>this.rr(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentMutationsStore(e).ee({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.rr(e, o));
    }
    rr(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $a33cbddcd7bfa0a9$var$fail(35274, {
                    batchId: t
                });
                $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $a33cbddcd7bfa0a9$var$removeMutationBatch(e.le, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.ir(t.batchId);
            }), $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    ir(e) {
        delete this.Xn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $a33cbddcd7bfa0a9$var$__PRIVATE_documentMutationsStore(e).ee({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(0 === r.length, 56720, {
                    sr: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ _r(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $a33cbddcd7bfa0a9$var$j,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $a33cbddcd7bfa0a9$var$__PRIVATE_documentMutationsStore(e).ee({
        range: s,
        X: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_mutationsStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$te);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_documentMutationsStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$oe);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_mutationQueuesStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$X);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.ar = e;
    }
    next() {
        return this.ar += 2, this.ar;
    }
    static ur() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIdGenerator(0);
    }
    static cr() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.lr(e).next((t)=>{
            const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.hr(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.lr(e).next((e)=>$a33cbddcd7bfa0a9$var$SnapshotVersion.fromTimestamp(new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.lr(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.lr(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.hr(e, r)));
    }
    addTargetData(e, t) {
        return this.Pr(e, t).next(()=>this.lr(e).next((n)=>(n.targetCount += 1, this.Tr(t, n), this.hr(e, n))));
    }
    updateTargetData(e, t) {
        return this.Pr(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$a33cbddcd7bfa0a9$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.lr(e)).next((t)=>($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(t.targetCount > 0, 8065), t.targetCount -= 1, this.hr(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $a33cbddcd7bfa0a9$var$__PRIVATE_targetsStore(e).ee((s, o)=>{
            const _ = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_targetsStore(e).ee((e, n)=>{
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    lr(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_globalTargetStore(e).get($a33cbddcd7bfa0a9$var$fe).next((e)=>($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(null !== e, 2888), e));
    }
    hr(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_globalTargetStore(e).put($a33cbddcd7bfa0a9$var$fe, t);
    }
    Pr(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_targetsStore(e).put($a33cbddcd7bfa0a9$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Tr(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.lr(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_targetsStore(e).ee({
            range: r,
            index: $a33cbddcd7bfa0a9$var$Ee
        }, (e, n, r)=>{
            const s = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $a33cbddcd7bfa0a9$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e);
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t)=>{
            const i = $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(t.path);
            return $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e);
        let i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        return r.ee({
            range: n,
            X: !0
        }, (e, t, n)=>{
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(e[1]), s = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $a33cbddcd7bfa0a9$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$Ve,
            X: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    At(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_targetsStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Ie);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_globalTargetStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$ge);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Ae);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Nt = "LruGarbageCollector", $a33cbddcd7bfa0a9$var$Bt = 1048576;
function $a33cbddcd7bfa0a9$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Ir = e, this.buffer = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_bufferEntryComparator), this.Er = 0;
    }
    dr() {
        return ++this.Er;
    }
    Ar(e) {
        const t = [
            e,
            this.dr()
        ];
        if (this.buffer.size < this.Ir) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $a33cbddcd7bfa0a9$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Rr = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Vr(6e4);
    }
    stop() {
        this.Rr && (this.Rr.cancel(), this.Rr = null);
    }
    get started() {
        return null !== this.Rr;
    }
    Vr(e) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Nt, `Garbage collection scheduled in ${e}ms`), this.Rr = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Rr = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e) ? $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Nt, "Ignoring IndexedDB error during garbage collection: ", e) : await $a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Vr(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.mr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.mr.gr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve($a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce);
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.mr.forEachTarget(e, (e)=>n.Ar(e.sequenceNumber)).next(()=>this.mr.pr(e, (e)=>n.Ar(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.mr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.mr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve($a33cbddcd7bfa0a9$var$xt)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $a33cbddcd7bfa0a9$var$xt) : this.yr(e, t));
    }
    getCacheSize(e) {
        return this.mr.getCacheSize(e);
    }
    yr(e, t) {
        let n, r, i, s, o, _, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, _ = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $a33cbddcd7bfa0a9$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (_ - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - _) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $a33cbddcd7bfa0a9$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    gr(e) {
        const t = this.wr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    wr(e) {
        let t = 0;
        return this.pr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    pr(e, t) {
        return this.Sr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ br(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $a33cbddcd7bfa0a9$var$__PRIVATE_mutationQueuesStore(e).te((r)=>$a33cbddcd7bfa0a9$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.Sr(e, (s, o)=>{
            if (o <= t) {
                const t = this.br(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $a33cbddcd7bfa0a9$var$SnapshotVersion.min()), $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Sr(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e);
        let r, i = $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce;
        return n.ee({
            index: $a33cbddcd7bfa0a9$var$Ve
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce && t(new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce && t(new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_writeSentinelKey(e, t) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $a33cbddcd7bfa0a9$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $a33cbddcd7bfa0a9$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.Dr(e, n)));
    }
    getEntry(e, t) {
        let n = $a33cbddcd7bfa0a9$var$MutableDocument.newInvalidDocument(t);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$ue,
            range: IDBKeyRange.only($a33cbddcd7bfa0a9$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.Cr(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ vr(e, t) {
        let n = {
            size: 0,
            document: $a33cbddcd7bfa0a9$var$MutableDocument.newInvalidDocument(t)
        };
        return $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$ue,
            range: IDBKeyRange.only($a33cbddcd7bfa0a9$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.Cr(t, r),
                size: $a33cbddcd7bfa0a9$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
        return this.Fr(e, t, (e, t)=>{
            const r = this.Cr(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ Mr(e, t) {
        let n = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap(), r = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
        return this.Fr(e, t, (e, t)=>{
            const i = this.Cr(e, t);
            n = n.insert(e, i), r = r.insert(e, $a33cbddcd7bfa0a9$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Or: r
            }));
    }
    Fr(e, t, n) {
        if (t.isEmpty()) return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
        let r = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($a33cbddcd7bfa0a9$var$__PRIVATE_dbKey(r.first()), $a33cbddcd7bfa0a9$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$ue,
            range: i
        }, (e, t, r)=>{
            const i = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $a33cbddcd7bfa0a9$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.j($a33cbddcd7bfa0a9$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e).J(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            i?.incrementDocumentReadCount(e.length);
            let n = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.Cr($a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($a33cbddcd7bfa0a9$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $a33cbddcd7bfa0a9$var$__PRIVATE_dbCollectionGroupKey(t, $a33cbddcd7bfa0a9$var$IndexOffset.max());
        return $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $a33cbddcd7bfa0a9$var$le,
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.Cr($a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentGlobalStore(e).get($a33cbddcd7bfa0a9$var$Te).next((e)=>($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!e, 20021), e));
    }
    Dr(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_documentGlobalStore(e).put($a33cbddcd7bfa0a9$var$Te, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Cr(e, t) {
        if (t) {
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min()))) return e;
        }
        return $a33cbddcd7bfa0a9$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $a33cbddcd7bfa0a9$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.Nr = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Br = new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $a33cbddcd7bfa0a9$var$SortedSet((e, t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Br.get(i);
            if (t.push(this.Nr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $a33cbddcd7bfa0a9$var$__PRIVATE_toDbRemoteDocument(this.Nr.serializer, s);
                r = r.add(i.path.popLast());
                const a = $a33cbddcd7bfa0a9$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.Nr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_toDbRemoteDocument(this.Nr.serializer, s.convertToNoDocument($a33cbddcd7bfa0a9$var$SnapshotVersion.min()));
                t.push(this.Nr.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.Nr.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.Nr.updateMetadata(e, n)), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Nr.vr(e, t).next((e)=>(this.Br.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Nr.Mr(e, t).next(({ documents: e, Or: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Br.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_documentGlobalStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Pe);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_remoteDocumentsStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$_e);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $a33cbddcd7bfa0a9$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $a33cbddcd7bfa0a9$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $a33cbddcd7bfa0a9$var$FieldMask.empty(), $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet()) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $a33cbddcd7bfa0a9$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $a33cbddcd7bfa0a9$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $a33cbddcd7bfa0a9$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>o.set(e, new $a33cbddcd7bfa0a9$var$OverlayedDocument(t, s.get(e) ?? null))), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $a33cbddcd7bfa0a9$var$SortedMap((e, t)=>e - t), i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $a33cbddcd7bfa0a9$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $a33cbddcd7bfa0a9$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $a33cbddcd7bfa0a9$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $a33cbddcd7bfa0a9$var$PersistencePromise.resolve($a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = $a33cbddcd7bfa0a9$var$U, _ = i;
            return s.next((t)=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $a33cbddcd7bfa0a9$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $a33cbddcd7bfa0a9$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $a33cbddcd7bfa0a9$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $a33cbddcd7bfa0a9$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $a33cbddcd7bfa0a9$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $a33cbddcd7bfa0a9$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $a33cbddcd7bfa0a9$var$FieldMask.empty(), $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $a33cbddcd7bfa0a9$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Lr = new Map, this.kr = new Map;
    }
    getBundleMetadata(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.Lr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Lr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.kr.get(t));
    }
    saveNamedQuery(e, t) {
        return this.kr.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $a33cbddcd7bfa0a9$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator), this.qr = new Map;
    }
    getOverlay(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap();
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.St(e, t, r);
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.qr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.qr.delete(n)), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $a33cbddcd7bfa0a9$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $a33cbddcd7bfa0a9$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(o);
    }
    St(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.qr.get(r.largestBatchId).delete(n.key);
            this.qr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $a33cbddcd7bfa0a9$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.qr.get(t);
        void 0 === i && (i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), this.qr.set(t, i)), this.qr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Qr = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_DocReference.$r), // A set of outstanding references to a document sorted by target id.
        this.Ur = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_DocReference.Kr);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Qr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(e, t);
        this.Qr = this.Qr.add(n), this.Ur = this.Ur.add(n);
    }
    /** Add references to the given document keys for the given ID. */ Wr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Gr(new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(e, t));
    }
    zr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ jr(e) {
        const t = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(new $a33cbddcd7bfa0a9$var$ResourcePath([])), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t, e), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.Ur.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Gr(e), i.push(e.key);
        }), i;
    }
    Jr() {
        this.Qr.forEach((e)=>this.Gr(e));
    }
    Gr(e) {
        this.Qr = this.Qr.delete(e), this.Ur = this.Ur.delete(e);
    }
    Hr(e) {
        const t = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(new $a33cbddcd7bfa0a9$var$ResourcePath([])), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t, e), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t, e + 1);
        let i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        return this.Ur.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(e, 0), n = this.Qr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.Yr = t;
    }
    /** Compare by key then by ID */ static $r(e, t) {
        return $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(e.key, t.key) || $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.Yr, t.Yr);
    }
    /** Compare by ID then by key */ static Kr(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(e.Yr, t.Yr) || $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.tr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Zr = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_DocReference.$r);
    }
    checkEmpty(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.tr;
        this.tr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $a33cbddcd7bfa0a9$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.Zr = this.Zr.add(new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.Xr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.ei(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $a33cbddcd7bfa0a9$var$j : this.tr - 1);
    }
    getAllMutationBatches(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t, 0), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.Zr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Xr(e.Yr);
            i.push(t);
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(e, 0), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.Zr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.Yr);
            });
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.ti(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator);
        return this.Zr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.Yr)), !0);
        }, s), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.ti(o));
    }
    ti(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Xr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(0 === this.ni(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.Zr;
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.Zr = n;
        });
    }
    ir(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_DocReference(t, 0), r = this.Zr.firstAfterOrEqual(n);
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ni(e, t) {
        return this.ei(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ ei(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Xr(e) {
        const t = this.ei(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.ri = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.ri(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $a33cbddcd7bfa0a9$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $a33cbddcd7bfa0a9$var$MutableDocument.newInvalidDocument(e));
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(s.child("__id-9223372036854775808__")), _ = this.docs.getIteratorFrom(o);
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $a33cbddcd7bfa0a9$var$__PRIVATE_indexOffsetComparator($a33cbddcd7bfa0a9$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $a33cbddcd7bfa0a9$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $a33cbddcd7bfa0a9$var$fail(9500);
    }
    ii(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $a33cbddcd7bfa0a9$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.Nr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.Nr.addEntry(e, r)) : this.Nr.removeEntry(n);
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.Nr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.Nr.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.si = new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget(e), $a33cbddcd7bfa0a9$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.oi = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this._i = new $a33cbddcd7bfa0a9$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.ai = $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIdGenerator.ur();
    }
    forEachTarget(e, t) {
        return this.si.forEach((e, n)=>t(n)), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.oi);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.ai.next(), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.oi && (this.oi = t), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    Pr(e) {
        this.si.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.ai = new $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.oi && (this.oi = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Pr(t), this.targetCount += 1, $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Pr(t), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.si.delete(t.target), this._i.jr(t.targetId), this.targetCount -= 1, $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.si.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.si.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.si.get(t) || null;
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this._i.Wr(t, n), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this._i.zr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this._i.jr(t), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this._i.Hr(t);
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this._i.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.ui = {}, this.overlays = {}, this.ci = new $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence(0), this.li = !1, this.li = !0, this.hi = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.Pi = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.Ti(e)), this.serializer = new $a33cbddcd7bfa0a9$var$__PRIVATE_LocalSerializer(t), this.Ii = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.li = !1, Promise.resolve();
    }
    get started() {
        return this.li;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.ui[e.toKey()];
        return n || (n = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.ui[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.hi;
    }
    getTargetCache() {
        return this.Pi;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Ii;
    }
    runTransaction(e, t, n) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryTransaction(this.ci.next());
        return this.referenceDelegate.Ei(), n(r).next((e)=>this.referenceDelegate.di(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Ai(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.or(Object.values(this.ui).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryTransaction extends $a33cbddcd7bfa0a9$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Ri = new $a33cbddcd7bfa0a9$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Vi = null;
    }
    static mi(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get fi() {
        if (this.Vi) return this.Vi;
        throw $a33cbddcd7bfa0a9$var$fail(60996);
    }
    addReference(e, t, n) {
        return this.Ri.addReference(n, t), this.fi.delete(n.toString()), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Ri.removeReference(n, t), this.fi.add(n.toString()), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.fi.add(t.toString()), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Ri.jr(t.targetId).forEach((e)=>this.fi.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.fi.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Ei() {
        this.Vi = new Set;
    }
    di(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(this.fi, (n)=>{
            const r = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromPath(n);
            return this.gi(e, r).next((e)=>{
                e || t.removeEntry(r, $a33cbddcd7bfa0a9$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Vi = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.gi(e, t).next((e)=>{
            e ? this.fi.delete(t.toString()) : this.fi.add(t.toString());
        });
    }
    Ti(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    gi(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.or([
            ()=>$a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.Ri.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Ai(e, t)
        ]);
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.pi = new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $a33cbddcd7bfa0a9$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static mi(e, t) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Ei() {}
    di(e) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    gr(e) {
        const t = this.wr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    wr(e) {
        let t = 0;
        return this.pr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    pr(e, t) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(this.pi, (n, r)=>this.br(e, n, r).next((e)=>e ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.ii(e, (r)=>this.br(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $a33cbddcd7bfa0a9$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.pi.set(t, e.currentSequenceNumber), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.pi.set(n, e.currentSequenceNumber), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.pi.set(n, e.currentSequenceNumber), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.pi.set(t, e.currentSequenceNumber), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
    }
    Ti(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $a33cbddcd7bfa0a9$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    br(e, t, n) {
        return $a33cbddcd7bfa0a9$var$PersistencePromise.or([
            ()=>this.persistence.Ai(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.pi.get(t);
                return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ k(e, t, n, r) {
        const i = new $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($a33cbddcd7bfa0a9$var$Y);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($a33cbddcd7bfa0a9$var$X, {
                keyPath: $a33cbddcd7bfa0a9$var$ee
            });
            const t = e.createObjectStore($a33cbddcd7bfa0a9$var$te, {
                keyPath: $a33cbddcd7bfa0a9$var$ne,
                autoIncrement: !0
            });
            t.createIndex($a33cbddcd7bfa0a9$var$re, $a33cbddcd7bfa0a9$var$ie, {
                unique: !0
            }), e.createObjectStore($a33cbddcd7bfa0a9$var$oe);
        }(e), $a33cbddcd7bfa0a9$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($a33cbddcd7bfa0a9$var$H);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($a33cbddcd7bfa0a9$var$Ae), e.deleteObjectStore($a33cbddcd7bfa0a9$var$Ie), e.deleteObjectStore($a33cbddcd7bfa0a9$var$ge);
        }(e), $a33cbddcd7bfa0a9$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($a33cbddcd7bfa0a9$var$ge), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $a33cbddcd7bfa0a9$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($a33cbddcd7bfa0a9$var$fe, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($a33cbddcd7bfa0a9$var$te);
                return n.J().next((n)=>{
                    e.deleteObjectStore($a33cbddcd7bfa0a9$var$te);
                    e.createObjectStore($a33cbddcd7bfa0a9$var$te, {
                        keyPath: $a33cbddcd7bfa0a9$var$ne,
                        autoIncrement: !0
                    }).createIndex($a33cbddcd7bfa0a9$var$re, $a33cbddcd7bfa0a9$var$ie, {
                        unique: !0
                    });
                    const r = t.store($a33cbddcd7bfa0a9$var$te), i = n.map((e)=>r.put(e));
                    return $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($a33cbddcd7bfa0a9$var$we, {
                    keyPath: $a33cbddcd7bfa0a9$var$Se
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.yi(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($a33cbddcd7bfa0a9$var$Pe);
            })(e), this.wi(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.Si(i))), n < 8 && r >= 8 && (s = s.next(()=>this.bi(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.Di(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($a33cbddcd7bfa0a9$var$be, {
                    keyPath: $a33cbddcd7bfa0a9$var$De
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($a33cbddcd7bfa0a9$var$Ce, {
                    keyPath: $a33cbddcd7bfa0a9$var$ve
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($a33cbddcd7bfa0a9$var$Ke, {
                    keyPath: $a33cbddcd7bfa0a9$var$We
                });
                t.createIndex($a33cbddcd7bfa0a9$var$Ge, $a33cbddcd7bfa0a9$var$ze, {
                    unique: !1
                }), t.createIndex($a33cbddcd7bfa0a9$var$je, $a33cbddcd7bfa0a9$var$Je, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($a33cbddcd7bfa0a9$var$_e, {
                    keyPath: $a33cbddcd7bfa0a9$var$ae
                });
                t.createIndex($a33cbddcd7bfa0a9$var$ue, $a33cbddcd7bfa0a9$var$ce), t.createIndex($a33cbddcd7bfa0a9$var$le, $a33cbddcd7bfa0a9$var$he);
            })(e)).next(()=>this.Ci(e, i)).next(()=>e.deleteObjectStore($a33cbddcd7bfa0a9$var$H))), n < 14 && r >= 14 && (s = s.next(()=>this.Fi(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($a33cbddcd7bfa0a9$var$Fe, {
                    keyPath: $a33cbddcd7bfa0a9$var$Me,
                    autoIncrement: !0
                });
                t.createIndex($a33cbddcd7bfa0a9$var$xe, $a33cbddcd7bfa0a9$var$Oe, {
                    unique: !1
                });
                const n = e.createObjectStore($a33cbddcd7bfa0a9$var$Ne, {
                    keyPath: $a33cbddcd7bfa0a9$var$Be
                });
                n.createIndex($a33cbddcd7bfa0a9$var$Le, $a33cbddcd7bfa0a9$var$ke, {
                    unique: !1
                });
                const r = e.createObjectStore($a33cbddcd7bfa0a9$var$qe, {
                    keyPath: $a33cbddcd7bfa0a9$var$Qe
                });
                r.createIndex($a33cbddcd7bfa0a9$var$$e, $a33cbddcd7bfa0a9$var$Ue, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($a33cbddcd7bfa0a9$var$Ne).clear();
        }).next(()=>{
            t.objectStore($a33cbddcd7bfa0a9$var$qe).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($a33cbddcd7bfa0a9$var$He, {
                    keyPath: $a33cbddcd7bfa0a9$var$Ye
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $029952e65115eee5$export$ef10bcfb06572016)() && (s = s.next(()=>{
            t.objectStore($a33cbddcd7bfa0a9$var$Ne).clear();
        }).next(()=>{
            t.objectStore($a33cbddcd7bfa0a9$var$qe).clear();
        })), s;
    }
    wi(e) {
        let t = 0;
        return e.store($a33cbddcd7bfa0a9$var$H).ee((e, n)=>{
            t += $a33cbddcd7bfa0a9$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($a33cbddcd7bfa0a9$var$Pe).put($a33cbddcd7bfa0a9$var$Te, n);
        });
    }
    yi(e) {
        const t = e.store($a33cbddcd7bfa0a9$var$X), n = e.store($a33cbddcd7bfa0a9$var$te);
        return t.J().next((t)=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $a33cbddcd7bfa0a9$var$j
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.J($a33cbddcd7bfa0a9$var$re, r).next((n)=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(n, (n)=>{
                        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $a33cbddcd7bfa0a9$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ Si(e) {
        const t = e.store($a33cbddcd7bfa0a9$var$Ae), n = e.store($a33cbddcd7bfa0a9$var$H);
        return e.store($a33cbddcd7bfa0a9$var$ge).get($a33cbddcd7bfa0a9$var$fe).next((e)=>{
            const r = [];
            return n.ee((n, i)=>{
                const s = new $a33cbddcd7bfa0a9$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(r));
        });
    }
    bi(e, t) {
        // Create the index.
        e.createObjectStore($a33cbddcd7bfa0a9$var$pe, {
            keyPath: $a33cbddcd7bfa0a9$var$ye
        });
        const n = t.store($a33cbddcd7bfa0a9$var$pe), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $a33cbddcd7bfa0a9$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($a33cbddcd7bfa0a9$var$H).ee({
            X: !0
        }, (e, t)=>{
            const n = new $a33cbddcd7bfa0a9$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($a33cbddcd7bfa0a9$var$oe).ee({
                X: !0
            }, ([e, t, n], r)=>{
                const i = $a33cbddcd7bfa0a9$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    Di(e) {
        const t = e.store($a33cbddcd7bfa0a9$var$Ie);
        return t.ee((e, n)=>{
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbTarget(n), i = $a33cbddcd7bfa0a9$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    Ci(e, t) {
        const n = t.store($a33cbddcd7bfa0a9$var$H), r = [];
        return n.ee((e, n)=>{
            const i = t.store($a33cbddcd7bfa0a9$var$_e), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $a33cbddcd7bfa0a9$var$fail(36783);
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(r));
    }
    Fi(e, t) {
        const n = t.store($a33cbddcd7bfa0a9$var$te), r = $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryPersistence($a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerDelegate.mi, this.serializer.yt);
        return n.J().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                let t = n.get(e.userId) ?? $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
                $a33cbddcd7bfa0a9$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>t = t.add(e)), n.set(e.userId, t);
            }), $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $a33cbddcd7bfa0a9$var$User(n), o = $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, s), _ = i.getIndexManager(s), a = $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbMutationQueue.wt(s, this.serializer, _, i.referenceDelegate);
                return new $a33cbddcd7bfa0a9$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransaction(t, $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce), e).next();
            });
        });
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($a33cbddcd7bfa0a9$var$Ae, {
        keyPath: $a33cbddcd7bfa0a9$var$Re
    }).createIndex($a33cbddcd7bfa0a9$var$Ve, $a33cbddcd7bfa0a9$var$me, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($a33cbddcd7bfa0a9$var$Ie, {
        keyPath: "targetId"
    }).createIndex($a33cbddcd7bfa0a9$var$Ee, $a33cbddcd7bfa0a9$var$de, {
        unique: !0
    }), e.createObjectStore($a33cbddcd7bfa0a9$var$ge);
}
const $a33cbddcd7bfa0a9$var$Lt = "IndexedDbPersistence", $a33cbddcd7bfa0a9$var$kt = 18e5, $a33cbddcd7bfa0a9$var$qt = 5e3, $a33cbddcd7bfa0a9$var$Qt = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $a33cbddcd7bfa0a9$var$$t = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Mi = i, this.window = s, this.document = o, this.xi = a, this.Oi = u, this.Ni = c, this.ci = null, this.li = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Bi = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Li = null, /** The client metadata refresh task. */ this.ki = null, /** The last time we garbage collected the client metadata object store. */ this.qi = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Qi = (e)=>Promise.resolve(), !$a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbPersistence.v()) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.$i = t + $a33cbddcd7bfa0a9$var$$t, this.serializer = new $a33cbddcd7bfa0a9$var$__PRIVATE_LocalSerializer(_), this.Ui = new $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb(this.$i, this.Ni, new $a33cbddcd7bfa0a9$var$__PRIVATE_SchemaConverter(this.serializer)), this.hi = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbGlobalsCache, this.Pi = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Ii = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ki = this.window.localStorage : (this.Ki = null, !1 === u && $a33cbddcd7bfa0a9$var$__PRIVATE_logError($a33cbddcd7bfa0a9$var$Lt, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.Wi().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, $a33cbddcd7bfa0a9$var$Qt);
            return this.Gi(), this.zi(), this.ji(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.Pi.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.ci = new $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence(e, this.xi);
        }).then(()=>{
            this.li = !0;
        }).catch((e)=>(this.Ui && this.Ui.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ji(e) {
        return this.Qi = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.Ui.$(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Mi.enqueueAndForget(async ()=>{
            this.started && await this.Wi();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ Wi() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.Hi(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Mi.enqueueRetryable(()=>this.Qi(!1)));
                });
            }).next(()=>this.Yi(e)).next((t)=>this.isPrimary && !t ? this.Zi(e).next(()=>!1) : !!t && this.Xi(e).next(()=>!0))).catch((e)=>{
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Lt, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Lt, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Mi.enqueueRetryable(()=>this.Qi(e)), this.isPrimary = e;
        });
    }
    Hi(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primaryClientStore(e).get($a33cbddcd7bfa0a9$var$Z).next((e)=>$a33cbddcd7bfa0a9$var$PersistencePromise.resolve(this.es(e)));
    }
    ts(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async ns() {
        if (this.isPrimary && !this.rs(this.qi, $a33cbddcd7bfa0a9$var$kt)) {
            this.qi = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$we);
                return t.J().next((e)=>{
                    const n = this.ss(e, $a33cbddcd7bfa0a9$var$kt), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $a33cbddcd7bfa0a9$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Ki) for (const t of e)this.Ki.removeItem(this._s(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ ji() {
        this.ki = this.Mi.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.Wi().then(()=>this.ns()).then(()=>this.ji()));
    }
    /** Checks whether `client` is the local client. */ es(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Yi(e) {
        if (this.Oi) return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(!0);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primaryClientStore(e).get($a33cbddcd7bfa0a9$var$Z).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.rs(t.leaseTimestampMs, $a33cbddcd7bfa0a9$var$qt) && !this.us(t.ownerId)) {
                if (this.es(t) && this.networkEnabled) return !0;
                if (!this.es(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, $a33cbddcd7bfa0a9$var$Qt);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $a33cbddcd7bfa0a9$var$__PRIVATE_clientMetadataStore(e).J().next((e)=>void 0 === this.ss(e, $a33cbddcd7bfa0a9$var$qt).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Lt, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.li = !1, this.cs(), this.ki && (this.ki.cancel(), this.ki = null), this.ls(), this.hs(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.Ui.runTransaction("shutdown", "readwrite", [
            $a33cbddcd7bfa0a9$var$Y,
            $a33cbddcd7bfa0a9$var$we
        ], (e)=>{
            const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransaction(e, $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce);
            return this.Zi(t).next(()=>this.ts(t));
        }), this.Ui.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Ps();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ ss(e, t) {
        return e.filter((e)=>this.rs(e.updateTimeMs, t) && !this.us(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ts() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_clientMetadataStore(e).J().next((e)=>this.ss(e, $a33cbddcd7bfa0a9$var$kt).map((e)=>e.clientId)));
    }
    get started() {
        return this.li;
    }
    getGlobalsCache() {
        return this.hi;
    }
    getMutationQueue(e, t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbMutationQueue.wt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Pi;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.yt.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, e);
    }
    getBundleCache() {
        return this.Ii;
    }
    runTransaction(e, t, n) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Lt, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $a33cbddcd7bfa0a9$var$st : 17 === e ? $a33cbddcd7bfa0a9$var$it : 16 === e ? $a33cbddcd7bfa0a9$var$rt : 15 === e ? $a33cbddcd7bfa0a9$var$nt : 14 === e ? $a33cbddcd7bfa0a9$var$tt : 13 === e ? $a33cbddcd7bfa0a9$var$et : 12 === e ? $a33cbddcd7bfa0a9$var$Xe : 11 === e ? $a33cbddcd7bfa0a9$var$Ze : void $a33cbddcd7bfa0a9$var$fail(60245);
        }(this.Ni);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.Ui.runTransaction(e, r, i, (r)=>(s = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbTransaction(r, this.ci ? this.ci.next() : $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce), "readwrite-primary" === t ? this.Hi(s).next((e)=>!!e || this.Yi(s)).next((t)=>{
                if (!t) throw $a33cbddcd7bfa0a9$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Mi.enqueueRetryable(()=>this.Qi(!1)), new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, $a33cbddcd7bfa0a9$var$K);
                return n(s);
            }).next((e)=>this.Xi(s).next(()=>e)) : this.Is(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Is(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primaryClientStore(e).get($a33cbddcd7bfa0a9$var$Z).next((e)=>{
            if (null !== e && this.rs(e.leaseTimestampMs, $a33cbddcd7bfa0a9$var$qt) && !this.us(e.ownerId) && !this.es(e) && !(this.Oi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, $a33cbddcd7bfa0a9$var$Qt);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Xi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primaryClientStore(e).put($a33cbddcd7bfa0a9$var$Z, t);
    }
    static v() {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.v();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Zi(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_primaryClientStore(e);
        return t.get($a33cbddcd7bfa0a9$var$Z).next((e)=>this.es(e) ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Lt, "Releasing primary lease."), t.delete($a33cbddcd7bfa0a9$var$Z)) : $a33cbddcd7bfa0a9$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ rs(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($a33cbddcd7bfa0a9$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Gi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Li = ()=>{
            this.Mi.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.Wi()));
        }, this.document.addEventListener("visibilitychange", this.Li), this.inForeground = "visible" === this.document.visibilityState);
    }
    ls() {
        this.Li && (this.document.removeEventListener("visibilitychange", this.Li), this.Li = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ zi() {
        "function" == typeof this.window?.addEventListener && (this.Bi = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.cs();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $029952e65115eee5$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Mi.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Mi.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Bi));
    }
    hs() {
        this.Bi && (this.window.removeEventListener("pagehide", this.Bi), this.Bi = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ us(e) {
        try {
            const t = null !== this.Ki?.getItem(this._s(e));
            return $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Lt, `Client '${e}' ${t ? "is" : "is not"} zombied in LocalStorage`), t;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $a33cbddcd7bfa0a9$var$__PRIVATE_logError($a33cbddcd7bfa0a9$var$Lt, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ cs() {
        if (this.Ki) try {
            this.Ki.setItem(this._s(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $a33cbddcd7bfa0a9$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ Ps() {
        if (this.Ki) try {
            this.Ki.removeItem(this._s(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    _s(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_primaryClientStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$Y);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_clientMetadataStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_getStore(e, $a33cbddcd7bfa0a9$var$we);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Es = n, this.ds = r;
    }
    static As(e, t) {
        let n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), r = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $a33cbddcd7bfa0a9$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_QueryEngine {
    constructor(){
        this.Rs = !1, this.Vs = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.fs = 100, this.gs = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $029952e65115eee5$export$95df08bae54cb4df)() ? 8 : $a33cbddcd7bfa0a9$var$__PRIVATE_getAndroidVersion((0, $029952e65115eee5$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.ps = e, this.indexManager = t, this.Rs = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.ys(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.ws(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $a33cbddcd7bfa0a9$var$QueryContext;
            return this.Ss(e, t, n).next((r)=>{
                if (i.result = r, this.Vs) return this.bs(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    bs(e, t, n, r) {
        return n.documentReadCount < this.fs ? ($a33cbddcd7bfa0a9$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $a33cbddcd7bfa0a9$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.fs, "documents"), $a33cbddcd7bfa0a9$var$PersistencePromise.resolve()) : ($a33cbddcd7bfa0a9$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("QueryEngine", "Query:", $a33cbddcd7bfa0a9$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.gs * r ? ($a33cbddcd7bfa0a9$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $a33cbddcd7bfa0a9$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(t))) : $a33cbddcd7bfa0a9$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ ys(e, t) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(null);
        let n = $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(...r);
                return this.ps.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.Ds(t, r);
                        return this.Cs(t, s, i, n.readTime) ? this.ys(e, $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.vs(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ ws(e, t, n, r) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(null) : this.ps.getDocuments(e, n).next((i)=>{
            const s = this.Ds(t, i);
            return this.Cs(t, s, n, r) ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(null) : ($a33cbddcd7bfa0a9$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $a33cbddcd7bfa0a9$var$__PRIVATE_stringifyQuery(t)), this.vs(e, s, t, $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $a33cbddcd7bfa0a9$var$U)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ Ds(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $a33cbddcd7bfa0a9$var$SortedSet($a33cbddcd7bfa0a9$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $a33cbddcd7bfa0a9$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Cs(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    Ss(e, t, n) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $a33cbddcd7bfa0a9$var$__PRIVATE_stringifyQuery(t)), this.ps.getDocumentsMatchingQuery(e, t, $a33cbddcd7bfa0a9$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ vs(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.ps.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Ut = "LocalStore", $a33cbddcd7bfa0a9$var$Kt = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Fs = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Ms = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.xs = new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyTarget(e), $a33cbddcd7bfa0a9$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Os = new Map, this.Ns = e.getRemoteDocumentCache(), this.Pi = e.getTargetCache(), this.Ii = e.getBundleCache(), this.Bs(n);
    }
    Bs(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $a33cbddcd7bfa0a9$var$LocalDocumentsView(this.Ns, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Ns.setIndexManager(this.indexManager), this.Fs.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.Ms));
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Bs(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Ls: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.Ns.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $a33cbddcd7bfa0a9$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.Pi.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.Ms;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.Ns.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Ms;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Pi.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.Pi.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING, $a33cbddcd7bfa0a9$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $a33cbddcd7bfa0a9$var$Kt) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && o.push(n.Pi.updateTargetData(e, u));
        });
        let _ = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap(), a = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($a33cbddcd7bfa0a9$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.ks, a = e.qs;
        })), !r.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min())) {
            const t = n.Pi.getLastRemoteSnapshotVersion(e).next((t)=>n.Pi.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.Ms = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), i = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Ut, "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            ks: r,
            qs: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $a33cbddcd7bfa0a9$var$j), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.Pi.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(r)) : n.Pi.allocateTargetId(e).next((i)=>(r = new $a33cbddcd7bfa0a9$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.Pi.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.Ms.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.Ms = n.Ms.insert(e.targetId, e), n.xs.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), i = r.Ms.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Ut, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.Ms = r.Ms.remove(t), r.xs.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    let i = $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), s = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), i = r.xs.get(n);
            return void 0 !== i ? $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(r.Ms.get(i)) : r.Pi.getTargetData(t, n);
        })(r, e, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.Pi.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Fs.getDocumentsMatchingQuery(e, t, n ? i : $a33cbddcd7bfa0a9$var$SnapshotVersion.min(), n ? s : $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet())).next((e)=>($a33cbddcd7bfa0a9$var$__PRIVATE_setMaxReadTime(r, $a33cbddcd7bfa0a9$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                Qs: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(n.Pi), i = n.Ms.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.At(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = n.Os.get(t) || $a33cbddcd7bfa0a9$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.Ns.getAllFromCollectionGroup(e, t, $a33cbddcd7bfa0a9$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $a33cbddcd7bfa0a9$var$U), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($a33cbddcd7bfa0a9$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $a33cbddcd7bfa0a9$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.Os.get(t) || $a33cbddcd7bfa0a9$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.Os.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    let s = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), o = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.$s(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.Us(e);
        r.setReadTime(t.Ks(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.Ns.newChangeBuffer({
        trackRemovals: !0
    }), a = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget($a33cbddcd7bfa0a9$var$__PRIVATE_newQueryForPath($a33cbddcd7bfa0a9$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.Pi.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.Pi.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.ks, t.qs)).next(()=>t.ks)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAllocateTarget(e, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget($a33cbddcd7bfa0a9$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Ii.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.Ms = i.Ms.insert(o.targetId, o), i.Pi.updateTargetData(e, o).next(()=>i.Pi.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.Pi.addMatchingKeys(e, n, r.targetId)).next(()=>i.Ii.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $a33cbddcd7bfa0a9$var$Wt = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $a33cbddcd7bfa0a9$var$createWebStorageClientStateKey(e, t) {
    return `${$a33cbddcd7bfa0a9$var$Wt}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $a33cbddcd7bfa0a9$var$Gt = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $a33cbddcd7bfa0a9$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$a33cbddcd7bfa0a9$var$Gt}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $a33cbddcd7bfa0a9$var$zt = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $a33cbddcd7bfa0a9$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$a33cbddcd7bfa0a9$var$zt}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$jt = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $a33cbddcd7bfa0a9$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ws(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $a33cbddcd7bfa0a9$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $a33cbddcd7bfa0a9$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($a33cbddcd7bfa0a9$var$__PRIVATE_logError($a33cbddcd7bfa0a9$var$jt, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Gs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $a33cbddcd7bfa0a9$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ws(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $a33cbddcd7bfa0a9$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($a33cbddcd7bfa0a9$var$__PRIVATE_logError($a33cbddcd7bfa0a9$var$jt, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Gs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ws(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $a33cbddcd7bfa0a9$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $a33cbddcd7bfa0a9$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $a33cbddcd7bfa0a9$var$__PRIVATE_RemoteClientState(e, i) : ($a33cbddcd7bfa0a9$var$__PRIVATE_logError($a33cbddcd7bfa0a9$var$jt, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ws(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $a33cbddcd7bfa0a9$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($a33cbddcd7bfa0a9$var$__PRIVATE_logError($a33cbddcd7bfa0a9$var$jt, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $a33cbddcd7bfa0a9$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $a33cbddcd7bfa0a9$var$__PRIVATE_targetIdSet();
    }
    zs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    js(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Gs() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Mi = t, this.persistenceKey = n, this.Js = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.Hs = this.Ys.bind(this), this.Zs = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Xs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.eo = $a33cbddcd7bfa0a9$var$createWebStorageClientStateKey(this.persistenceKey, this.Js), this.no = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Zs = this.Zs.insert(this.Js, new $a33cbddcd7bfa0a9$var$__PRIVATE_LocalClientState), this.ro = new RegExp(`^${$a33cbddcd7bfa0a9$var$Wt}_${s}_([^_]*)$`), this.io = new RegExp(`^${$a33cbddcd7bfa0a9$var$Gt}_${s}_(\\d+)(?:_(.*))?$`), this.so = new RegExp(`^${$a33cbddcd7bfa0a9$var$zt}_${s}_(\\d+)$`), this.oo = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this._o = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.Hs);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static v(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.Ts();
        for (const t of e){
            if (t === this.Js) continue;
            const e = this.getItem($a33cbddcd7bfa0a9$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_RemoteClientState.Ws(t, e);
                n && (this.Zs = this.Zs.insert(n.clientId, n));
            }
        }
        this.ao();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.oo);
        if (t) {
            const e = this.uo(t);
            e && this.co(e);
        }
        for (const e of this.Xs)this.Ys(e);
        this.Xs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.no, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.lo(this.Zs);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Zs.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.ho(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.ho(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Po(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($a33cbddcd7bfa0a9$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $a33cbddcd7bfa0a9$var$__PRIVATE_QueryTargetMetadata.Ws(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.To.zs(e), this.ao(), n;
    }
    removeLocalQueryTarget(e) {
        this.To.js(e), this.ao();
    }
    isLocalQueryTarget(e) {
        return this.To.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($a33cbddcd7bfa0a9$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.Io(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.Po(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Eo(e);
    }
    notifyBundleLoaded(e) {
        this.Ao(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.Hs), this.removeItem(this.eo), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$jt, "READ", e, t), t;
    }
    setItem(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$jt, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$jt, "REMOVE", e), this.storage.removeItem(e);
    }
    Ys(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$jt, "EVENT", t.key, t.newValue), t.key === this.eo) return void $a33cbddcd7bfa0a9$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Mi.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.ro.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Ro(t.key);
                                return this.Vo(e, null);
                            }
                            {
                                const e = this.mo(t.key, t.newValue);
                                if (e) return this.Vo(e.clientId, e);
                            }
                        } else if (this.io.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.fo(t.key, t.newValue);
                                if (e) return this.po(e);
                            }
                        } else if (this.so.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.yo(t.key, t.newValue);
                                if (e) return this.wo(e);
                            }
                        } else if (t.key === this.oo) {
                            if (null !== t.newValue) {
                                const e = this.uo(t.newValue);
                                if (e) return this.co(e);
                            }
                        } else if (t.key === this.no) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert("number" == typeof n, 30636, {
                                        So: e
                                    }), t = n;
                                } catch (e) {
                                    $a33cbddcd7bfa0a9$var$__PRIVATE_logError($a33cbddcd7bfa0a9$var$jt, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce && this.sequenceNumberHandler(e);
                        } else if (t.key === this._o) {
                            const e = this.bo(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.Do(e)));
                        }
                    }
                } else this.Xs.push(t);
            });
        }
    }
    get To() {
        return this.Zs.get(this.Js);
    }
    ao() {
        this.setItem(this.eo, this.To.Gs());
    }
    ho(e, t, n) {
        const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $a33cbddcd7bfa0a9$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Gs());
    }
    Po(e) {
        const t = $a33cbddcd7bfa0a9$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Eo(e) {
        const t = {
            clientId: this.Js,
            onlineState: e
        };
        this.storage.setItem(this.oo, JSON.stringify(t));
    }
    Io(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Gs());
    }
    Ao(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this._o, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Ro(e) {
        const t = this.ro.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ mo(e, t) {
        const n = this.Ro(e);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_RemoteClientState.Ws(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ fo(e, t) {
        const n = this.io.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $a33cbddcd7bfa0a9$var$__PRIVATE_MutationMetadata.Ws(new $a33cbddcd7bfa0a9$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ yo(e, t) {
        const n = this.so.exec(e), r = Number(n[1]);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_QueryTargetMetadata.Ws(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ uo(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_SharedOnlineState.Ws(e);
    }
    bo(e) {
        return JSON.parse(e);
    }
    async po(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Co(e.batchId, e.state, e.error);
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$jt, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    wo(e) {
        return this.syncEngine.vo(e.targetId, e.state, e.error);
    }
    Vo(e, t) {
        const n = t ? this.Zs.insert(e, t) : this.Zs.remove(e), r = this.lo(this.Zs), i = this.lo(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.Fo(s, o).then(()=>{
            this.Zs = n;
        });
    }
    co(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Zs.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    lo(e) {
        let t = $a33cbddcd7bfa0a9$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.Mo = new $a33cbddcd7bfa0a9$var$__PRIVATE_LocalClientState, this.xo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.Mo.zs(e), this.xo[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.xo[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.Mo.js(e);
    }
    isLocalQueryTarget(e) {
        return this.Mo.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.xo[e];
    }
    getAllActiveQueryTargets() {
        return this.Mo.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.Mo.activeTargetIds.has(e);
    }
    start() {
        return this.Mo = new $a33cbddcd7bfa0a9$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_NoopConnectivityMonitor {
    Oo(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $a33cbddcd7bfa0a9$var$Jt = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.No = ()=>this.Bo(), this.Lo = ()=>this.ko(), this.qo = [], this.Qo();
    }
    Oo(e) {
        this.qo.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.No), window.removeEventListener("offline", this.Lo);
    }
    Qo() {
        window.addEventListener("online", this.No), window.addEventListener("offline", this.Lo);
    }
    Bo() {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Jt, "Network connectivity changed: AVAILABLE");
        for (const e of this.qo)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    ko() {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Jt, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.qo)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static v() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $a33cbddcd7bfa0a9$var$Ht = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_generateUniqueDebugId() {
    return null === $a33cbddcd7bfa0a9$var$Ht ? $a33cbddcd7bfa0a9$var$Ht = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $a33cbddcd7bfa0a9$var$Ht++, "0x" + $a33cbddcd7bfa0a9$var$Ht.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Yt = "RestConnection", $a33cbddcd7bfa0a9$var$Zt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_RestConnection {
    get $o() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Uo = t + "://" + e.host, this.Ko = `projects/${n}/databases/${r}`, this.Wo = this.databaseId.database === $a33cbddcd7bfa0a9$var$lt ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Go(e, t, n, r, i) {
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_generateUniqueDebugId(), o = this.zo(e, t.toUriEncodedString());
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Yt, `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Ko,
            "x-goog-request-params": this.Wo
        };
        this.jo(_, r, i);
        const { host: a } = new URL(o), u = (0, $029952e65115eee5$export$5b4d24b45140ad90)(a);
        return this.Jo(e, o, _, n, u).then((t)=>($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Yt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb($a33cbddcd7bfa0a9$var$Yt, `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    Ho(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Go(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ jo(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $a33cbddcd7bfa0a9$var$x;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    zo(e, t) {
        const n = $a33cbddcd7bfa0a9$var$Zt[e];
        return `${this.Uo}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Yo = e.Yo, this.Zo = e.Zo;
    }
    Xo(e) {
        this.e_ = e;
    }
    t_(e) {
        this.n_ = e;
    }
    r_(e) {
        this.i_ = e;
    }
    onMessage(e) {
        this.s_ = e;
    }
    close() {
        this.Zo();
    }
    send(e) {
        this.Yo(e);
    }
    o_() {
        this.e_();
    }
    __() {
        this.n_();
    }
    a_(e) {
        this.i_(e);
    }
    u_(e) {
        this.s_(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Xt = "WebChannelConnection";
class $a33cbddcd7bfa0a9$var$__PRIVATE_WebChannelConnection extends $a33cbddcd7bfa0a9$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.c_ = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    Jo(e, t, n, r, i) {
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, o)=>{
            const _ = new (0, $33cb313d667e3306$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $33cb313d667e3306$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' ${s} timed out`), o(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' ${s} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = e?.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($a33cbddcd7bfa0a9$var$N).indexOf(t) >= 0 ? t : $a33cbddcd7bfa0a9$var$N.UNKNOWN;
                                    }(t.status);
                                    o(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278(e, t.message));
                                } else o(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $a33cbddcd7bfa0a9$var$fail(9055, {
                                l_: e,
                                streamId: s,
                                h_: _.getLastErrorCode(),
                                P_: _.getLastError()
                            });
                    }
                } finally{
                    $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' ${s} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    T_(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.Uo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $33cb313d667e3306$export$66869136fc133c3a)(), o = (0, $33cb313d667e3306$export$888d0d9ab79d08fc)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), this.jo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        this.I_(c);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $a33cbddcd7bfa0a9$var$__PRIVATE_StreamBridge({
            Yo: (t)=>{
                h ? $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            Zo: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            h || ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} transport opened.`), P.o_());
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            h || (h = !0, $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} transport closed`), P.a_(), this.E_(c));
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            h || (h = !0, $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), P.a_(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            if (!h) {
                const n = t.data[0];
                $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!n, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const i = n, s = i?.error || i[0]?.error;
                if (s) {
                    $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} received error:`, s);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = s.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $a33cbddcd7bfa0a9$var$pt[e];
                        if (void 0 !== t) return $a33cbddcd7bfa0a9$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = s.message;
                    void 0 === n && (n = $a33cbddcd7bfa0a9$var$N.INTERNAL, i = "Unknown error status: " + t + " with message " + s.message), // Mark closed so no further events are propagated
                    h = !0, P.a_(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278(n, i)), c.close();
                } else $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} received:`, n), P.u_(n);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $33cb313d667e3306$export$d61e24a684f9e51).STAT_EVENT, (t)=>{
            t.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).PROXY ? $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).NOPROXY && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Xt, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.__();
        }, 0), P;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.c_.forEach((e)=>e.close()), this.c_ = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ I_(e) {
        this.c_.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ E_(e) {
        this.c_ = this.c_.filter((t)=>t === e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $a33cbddcd7bfa0a9$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(e) {
    return new $a33cbddcd7bfa0a9$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Mi = e, this.timerId = t, this.d_ = n, this.A_ = r, this.R_ = i, this.V_ = 0, this.m_ = null, /** The last backoff attempt, as epoch milliseconds. */ this.f_ = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.V_ = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ g_() {
        this.V_ = this.R_;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ p_(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.V_ + this.y_()), n = Math.max(0, Date.now() - this.f_), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.V_} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.m_ = this.Mi.enqueueAfterDelay(this.timerId, r, ()=>(this.f_ = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.V_ *= this.A_, this.V_ < this.d_ && (this.V_ = this.d_), this.V_ > this.R_ && (this.V_ = this.R_);
    }
    w_() {
        null !== this.m_ && (this.m_.skipDelay(), this.m_ = null);
    }
    cancel() {
        null !== this.m_ && (this.m_.cancel(), this.m_ = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ y_() {
        return (Math.random() - .5) * this.V_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$en = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.Mi = e, this.S_ = n, this.b_ = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.D_ = 0, this.C_ = null, this.v_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.F_ = 0, this.M_ = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ x_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.O_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ O_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.F_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.N_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.x_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ B_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.M_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ L_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.O_() && null === this.C_ && (this.C_ = this.Mi.enqueueAfterDelay(this.S_, 6e4, ()=>this.k_()));
    }
    /** Sends a message to the underlying stream. */ q_(e) {
        this.Q_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async k_() {
        if (this.O_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ Q_() {
        this.C_ && (this.C_.cancel(), this.C_ = null);
    }
    /** Cancels the health check delayed operation. */ U_() {
        this.v_ && (this.v_.cancel(), this.v_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Q_(), this.U_(), this.M_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.D_++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.M_.reset() : t && t.code === $a33cbddcd7bfa0a9$var$N.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($a33cbddcd7bfa0a9$var$__PRIVATE_logError(t.toString()), $a33cbddcd7bfa0a9$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.M_.g_()) : t && t.code === $a33cbddcd7bfa0a9$var$N.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.K_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.r_(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ K_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.W_(this.D_), t = this.D_;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.D_ === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.G_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.z_(e);
            });
        });
    }
    G_(e, t) {
        const n = this.W_(this.D_);
        this.stream = this.j_(e, t), this.stream.Xo(()=>{
            n(()=>this.listener.Xo());
        }), this.stream.t_(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.v_ = this.Mi.enqueueAfterDelay(this.b_, 1e4, ()=>(this.O_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.t_()));
        }), this.stream.r_((e)=>{
            n(()=>this.z_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.F_ ? this.J_(e) : this.onNext(e));
        });
    }
    N_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.M_.p_(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    z_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$en, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ W_(e) {
        return (t)=>{
            this.Mi.enqueueAndForget(()=>this.D_ === e ? t() : ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$en, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentListenStream extends $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    j_(e, t) {
        return this.connection.T_("Listen", e, t);
    }
    J_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.M_.reset();
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $a33cbddcd7bfa0a9$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $a33cbddcd7bfa0a9$var$SnapshotVersion.min() : t.readTime ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.readTime) : $a33cbddcd7bfa0a9$var$SnapshotVersion.min();
        }(e);
        return this.listener.H_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ Y_(e) {
        const t = {};
        t.database = $a33cbddcd7bfa0a9$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $a33cbddcd7bfa0a9$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $a33cbddcd7bfa0a9$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryTarget(e, r).ft
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $a33cbddcd7bfa0a9$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $a33cbddcd7bfa0a9$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $a33cbddcd7bfa0a9$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $a33cbddcd7bfa0a9$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.q_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ Z_(e) {
        const t = {};
        t.database = $a33cbddcd7bfa0a9$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.q_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentWriteStream extends $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get X_() {
        return this.F_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    K_() {
        this.X_ && this.ea([]);
    }
    j_(e, t) {
        return this.connection.T_("Write", e, t);
    }
    J_(e) {
        // Always capture the last stream token.
        return $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.ta();
    }
    onNext(e) {
        // Always capture the last stream token.
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.M_.reset();
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.na(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ ra() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $a33cbddcd7bfa0a9$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.q_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ ea(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$a33cbddcd7bfa0a9$var$toMutation(this.serializer, e))
        };
        this.q_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $a33cbddcd7bfa0a9$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_DatastoreImpl extends $a33cbddcd7bfa0a9$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.ia = !1;
    }
    sa() {
        if (this.ia) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Go(e, t, n, r) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Go(e, $a33cbddcd7bfa0a9$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $a33cbddcd7bfa0a9$var$N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ Ho(e, t, n, r, i) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.Ho(e, $a33cbddcd7bfa0a9$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $a33cbddcd7bfa0a9$var$N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.ia = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.oa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this._a = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.aa = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ ua() {
        0 === this.oa && (this.ca("Unknown" /* OnlineState.Unknown */ ), this._a = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this._a = null, this.la("Backend didn't respond within 10 seconds."), this.ca("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ ha(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.ca("Unknown" /* OnlineState.Unknown */ ) : (this.oa++, this.oa >= 1 && (this.Pa(), this.la(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.ca("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.Pa(), this.oa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.aa = !1), this.ca(e);
    }
    ca(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    la(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.aa ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logError(t), this.aa = !1) : $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    Pa() {
        null !== this._a && (this._a.cancel(), this._a = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$tn = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $a33cbddcd7bfa0a9$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Ta = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ia = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.Ea = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.da = [], this.Aa = i, this.Aa.Oo((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(this) && ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$tn, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
                    t.Ea.add(4 /* OfflineCause.ConnectivityChange */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkInternal(t), t.Ra.set("Unknown" /* OnlineState.Unknown */ ), t.Ea.delete(4 /* OfflineCause.ConnectivityChange */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.Ra = new $a33cbddcd7bfa0a9$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_enableNetworkInternal(e) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(e)) for (const t of e.da)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.da)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    n.Ia.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.Ia.set(t.targetId, t), $a33cbddcd7bfa0a9$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $a33cbddcd7bfa0a9$var$__PRIVATE_startWatchStream(n) : $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchStream(n).O_() && $a33cbddcd7bfa0a9$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchStream(n);
    n.Ia.delete(t), r.O_() && $a33cbddcd7bfa0a9$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.Ia.size && (r.O_() ? r.L_() : $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.Ra.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.Va.Ue(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchStream(e).Y_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.Va.Ue(t), $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchStream(e).Z_(t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_startWatchStream(e) {
    e.Va = new $a33cbddcd7bfa0a9$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        At: (t)=>e.Ia.get(t) || null,
        ht: ()=>e.datastore.serializer.databaseId
    }), $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchStream(e).start(), e.Ra.ua();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_shouldStartWatchStream(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(e) && !$a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchStream(e).x_() && e.Ia.size > 0;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e).Ea.size;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.Va = void 0;
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.Ra.set("Online" /* OnlineState.Online */ );
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamOpen(e) {
    e.Ia.forEach((t, n)=>{
        $a33cbddcd7bfa0a9$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamClose(e, t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $a33cbddcd7bfa0a9$var$__PRIVATE_shouldStartWatchStream(e) ? (e.Ra.ha(t), $a33cbddcd7bfa0a9$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.Ra.set("Unknown" /* OnlineState.Unknown */ );
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.Ra.set("Online" /* OnlineState.Online */ ), t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.Ia.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.Ia.delete(r), e.Va.removeTarget(r));
        }(e, t);
    } catch (n) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$tn, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentWatchChange ? e.Va.Ze(t) : t instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ExistenceFilterChange ? e.Va.st(t) : e.Va.tt(t), !n.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min())) try {
        const t = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.Va.Tt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ia.get(r);
                    // A watched target might have been removed already.
                    i && e.Ia.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ia.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ia.set(t, r.withResumeToken($a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $a33cbddcd7bfa0a9$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $a33cbddcd7bfa0a9$var$TargetData(r.target, t, n, r.sequenceNumber);
                $a33cbddcd7bfa0a9$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$tn, "Failed to raise snapshot:", t), await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.Ea.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkInternal(e), e.Ra.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$tn, "Retrying IndexedDB access"), await n(), e.Ea.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_fillWritePipeline(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), n = $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(t);
    let r = t.Ta.length > 0 ? t.Ta[t.Ta.length - 1].batchId : $a33cbddcd7bfa0a9$var$j;
    for(; $a33cbddcd7bfa0a9$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Ta.length && n.L_();
            break;
        }
        r = e.batchId, $a33cbddcd7bfa0a9$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $a33cbddcd7bfa0a9$var$__PRIVATE_shouldStartWriteStream(t) && $a33cbddcd7bfa0a9$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_canAddToWritePipeline(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(e) && e.Ta.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_addToWritePipeline(e, t) {
    e.Ta.push(t);
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e);
    n.O_() && n.X_ && n.ea(t.mutations);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_shouldStartWriteStream(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(e) && !$a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e).x_() && e.Ta.length > 0;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_startWriteStream(e) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onWriteStreamOpen(e) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e).ra();
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Ta)t.ea(n.mutations);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.Ta.shift(), i = $a33cbddcd7bfa0a9$var$MutationBatchResult.from(r, t, n);
    await $a33cbddcd7bfa0a9$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $a33cbddcd7bfa0a9$var$__PRIVATE_fillWritePipeline(e);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e).X_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $a33cbddcd7bfa0a9$var$__PRIVATE_isPermanentError(e) && e !== $a33cbddcd7bfa0a9$var$N.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Ta.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e).B_(), await $a33cbddcd7bfa0a9$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $a33cbddcd7bfa0a9$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $a33cbddcd7bfa0a9$var$__PRIVATE_shouldStartWriteStream(e) && $a33cbddcd7bfa0a9$var$__PRIVATE_startWriteStream(e);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$tn, "RemoteStore received new credentials");
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.Ea.add(3 /* OfflineCause.CredentialChange */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.Ra.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.Ea.delete(3 /* OfflineCause.CredentialChange */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    t ? (n.Ea.delete(2 /* OfflineCause.IsSecondary */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.Ea.add(2 /* OfflineCause.IsSecondary */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkInternal(n), n.Ra.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchStream(e) {
    return e.ma || // Create stream (but note that it is not started yet).
    (e.ma = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
        return r.sa(), new $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Xo: $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        t_: $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        r_: $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        H_: $a33cbddcd7bfa0a9$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.da.push(async (t)=>{
        t ? (e.ma.B_(), $a33cbddcd7bfa0a9$var$__PRIVATE_shouldStartWatchStream(e) ? $a33cbddcd7bfa0a9$var$__PRIVATE_startWatchStream(e) : e.Ra.set("Unknown" /* OnlineState.Unknown */ )) : (await e.ma.stop(), $a33cbddcd7bfa0a9$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.ma;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWriteStream(e) {
    return e.fa || // Create stream (but note that it is not started yet).
    (e.fa = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
        return r.sa(), new $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Xo: ()=>Promise.resolve(),
        t_: $a33cbddcd7bfa0a9$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        r_: $a33cbddcd7bfa0a9$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        ta: $a33cbddcd7bfa0a9$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        na: $a33cbddcd7bfa0a9$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.da.push(async (t)=>{
        t ? (e.fa.B_(), // This will start the write stream if necessary.
        await $a33cbddcd7bfa0a9$var$__PRIVATE_fillWritePipeline(e)) : (await e.fa.stop(), e.Ta.length > 0 && ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$tn, `Stopping write stream with ${e.Ta.length} pending writes`), e.Ta = []));
    })), e.fa;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $a33cbddcd7bfa0a9$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $a33cbddcd7bfa0a9$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $a33cbddcd7bfa0a9$var$DocumentSet {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $a33cbddcd7bfa0a9$var$DocumentSet(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $a33cbddcd7bfa0a9$var$documentMap(), this.sortedSet = new $a33cbddcd7bfa0a9$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $a33cbddcd7bfa0a9$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.ga = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.ga.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.ga = this.ga.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.ga = this.ga.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.ga = this.ga.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.ga = this.ga.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.ga = this.ga.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.ga = this.ga.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.ga = this.ga.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $a33cbddcd7bfa0a9$var$fail(63341, {
            Rt: e,
            pa: n
        }) : this.ga = this.ga.insert(t, e);
    }
    ya() {
        const e = [];
        return this.ga.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $a33cbddcd7bfa0a9$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $a33cbddcd7bfa0a9$var$ViewSnapshot(e, t, $a33cbddcd7bfa0a9$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $a33cbddcd7bfa0a9$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.wa = void 0, this.Sa = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    ba() {
        return this.Sa.some((e)=>e.Da());
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Ca = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.Sa)e.onError(t);
            });
        }(this, new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.ABORTED, "Firestore shutting down"));
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_newQueriesObjectMap() {
    return new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyQuery(e), $a33cbddcd7bfa0a9$var$__PRIVATE_queryEquals);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.ba() && t.Da() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryListenersInfo, r = t.Da() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.wa = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.wa = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$a33cbddcd7bfa0a9$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.Sa.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.va(n.onlineState), s.wa) t.Fa(s.wa) && $a33cbddcd7bfa0a9$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.Sa.indexOf(t);
        e >= 0 && (s.Sa.splice(e, 1), 0 === s.Sa.length ? i = t.Da() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.ba() && t.Da() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.Sa)t.Fa(e) && (r = !0);
            i.wa = e;
        }
    }
    r && $a33cbddcd7bfa0a9$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.Sa)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Ca.forEach((e)=>{
        e.next();
    });
}
var $a33cbddcd7bfa0a9$var$nn, $a33cbddcd7bfa0a9$var$rn;
/** Listen to both cache and server changes */ ($a33cbddcd7bfa0a9$var$rn = $a33cbddcd7bfa0a9$var$nn || ($a33cbddcd7bfa0a9$var$nn = {})).Ma = "default", /** Listen to changes in cache only */ $a33cbddcd7bfa0a9$var$rn.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.xa = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Oa = !1, this.Na = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Fa(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $a33cbddcd7bfa0a9$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.Oa ? this.Ba(e) && (this.xa.next(e), t = !0) : this.La(e, this.onlineState) && (this.ka(e), t = !0), this.Na = e, t;
    }
    onError(e) {
        this.xa.error(e);
    }
    /** Returns whether a snapshot was raised. */ va(e) {
        this.onlineState = e;
        let t = !1;
        return this.Na && !this.Oa && this.La(this.Na, e) && (this.ka(this.Na), t = !0), t;
    }
    La(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.Da()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.qa || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Ba(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.Na && this.Na.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    ka(e) {
        e = $a33cbddcd7bfa0a9$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Oa = !0, this.xa.next(e);
    }
    Da() {
        return this.options.source !== $a33cbddcd7bfa0a9$var$nn.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.Qa = e, this.byteLength = t;
    }
    $a() {
        return "metadata" in this.Qa;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    $s(e) {
        return $a33cbddcd7bfa0a9$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ Us(e) {
        return e.metadata.exists ? $a33cbddcd7bfa0a9$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $a33cbddcd7bfa0a9$var$MutableDocument.newNoDocument(this.$s(e.metadata.name), this.Ks(e.metadata.readTime));
    }
    Ks(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_BundleLoader {
    constructor(e, t){
        this.Ua = e, this.serializer = t, /** Batched queries to be saved into storage */ this.Ka = [], /** Batched documents to be saved into storage */ this.Wa = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $a33cbddcd7bfa0a9$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.Ka;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.Wa;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Ga(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.Qa.namedQuery) this.Ka.push(e.Qa.namedQuery);
        else if (e.Qa.documentMetadata) {
            this.Wa.push({
                metadata: e.Qa.documentMetadata
            }), e.Qa.documentMetadata.exists || ++t;
            const n = $a33cbddcd7bfa0a9$var$ResourcePath.fromString(e.Qa.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.Qa.document && (this.Wa[this.Wa.length - 1].document = e.Qa.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, {
            ...this.progress
        }) : null;
    }
    za(e) {
        const t = new Map, n = new $a33cbddcd7bfa0a9$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.$s(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async ja(e) {
        const t = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $a33cbddcd7bfa0a9$var$__PRIVATE_BundleConverterImpl(this.serializer), this.Wa, this.Ua.id), n = this.za(this.documents);
        for (const t of this.Ka)await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ja: this.collectionGroups,
            Ha: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Ya = t, this.Za = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Xa = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), this.eu = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryComparator(e), this.tu = new $a33cbddcd7bfa0a9$var$DocumentSet(this.eu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get nu() {
        return this.Ya;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ru(e, t) {
        const n = t ? t.iu : new $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentChangeSet, r = t ? t.tu : this.tu;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $a33cbddcd7bfa0a9$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.su(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.eu(c, _) > 0 || a && this.eu(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            tu: s,
            iu: n,
            Cs: o,
            mutatedKeys: i
        };
    }
    su(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.tu;
        this.tu = e.tu, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.iu.ya();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $a33cbddcd7bfa0a9$var$fail(20277, {
                                Rt: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.eu(e.doc, t.doc)), this.ou(n), r = r ?? !1;
        const o = t && !r ? this._u() : [], _ = 0 === this.Xa.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.Za;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Za = _, 0 !== s.length || a) return {
            snapshot: new $a33cbddcd7bfa0a9$var$ViewSnapshot(this.query, e.tu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            au: o
        };
        // no changes
        return {
            au: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ va(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            tu: this.tu,
            iu: new $a33cbddcd7bfa0a9$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Cs: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            au: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ uu(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Ya.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.tu.has(e) && !this.tu.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ ou(e) {
        e && (e.addedDocuments.forEach((e)=>this.Ya = this.Ya.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Ya = this.Ya.delete(e)), this.current = e.current);
    }
    _u() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Xa;
        this.Xa = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), this.tu.forEach((e)=>{
            this.uu(e.key) && (this.Xa = this.Xa.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Xa.has(e) || t.push(new $a33cbddcd7bfa0a9$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Xa.forEach((n)=>{
            e.has(n) || t.push(new $a33cbddcd7bfa0a9$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    cu(e) {
        this.Ya = e.Qs, this.Xa = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        const t = this.ru(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    lu() {
        return $a33cbddcd7bfa0a9$var$ViewSnapshot.fromInitialDocuments(this.query, this.tu, this.mutatedKeys, 0 /* SyncState.Local */  === this.Za, this.hasCachedResults);
    }
}
const $a33cbddcd7bfa0a9$var$sn = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $a33cbddcd7bfa0a9$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.hu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Pu = {}, this.Tu = new $a33cbddcd7bfa0a9$var$ObjectMap((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_canonifyQuery(e), $a33cbddcd7bfa0a9$var$__PRIVATE_queryEquals), this.Iu = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Eu = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.du = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Au = new Map, this.Ru = new $a33cbddcd7bfa0a9$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.Vu = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.mu = new Map, this.fu = $a33cbddcd7bfa0a9$var$__PRIVATE_TargetIdGenerator.cr(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.gu = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.gu;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.Tu.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.lu()) : i = await $a33cbddcd7bfa0a9$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchCallbacks(e);
    await $a33cbddcd7bfa0a9$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $a33cbddcd7bfa0a9$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.pu = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ru(n);
            i.Cs && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ru(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $a33cbddcd7bfa0a9$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.au), _.snapshot;
        })(e, t, n, r);
    const s = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $a33cbddcd7bfa0a9$var$__PRIVATE_View(t, s.Qs), _ = o.ru(s.documents), a = $a33cbddcd7bfa0a9$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $a33cbddcd7bfa0a9$var$__PRIVATE_updateTrackedLimbos(e, n, u.au);
    const c = new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryView(t, n, o);
    return e.Tu.set(t, c), e.Iu.has(n) ? e.Iu.get(n).push(t) : e.Iu.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), i = r.Tu.get(t), s = r.Iu.get(i.targetId);
    if (s.length > 1) return r.Iu.set(i.targetId, s.filter((e)=>!$a33cbddcd7bfa0a9$var$__PRIVATE_queryEquals(e, t))), void r.Tu.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $a33cbddcd7bfa0a9$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $a33cbddcd7bfa0a9$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = n.Tu.get(t), i = n.Iu.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $a33cbddcd7bfa0a9$var$__PRIVATE_mutableDocumentMap(), a = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
                return n.Ns.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation(e.key, t, $a33cbddcd7bfa0a9$var$__PRIVATE_extractFieldMask(t.value.mapValue), $a33cbddcd7bfa0a9$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $a33cbddcd7bfa0a9$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.Vu[e.currentUser.toKey()];
            r || (r = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.Vu[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $a33cbddcd7bfa0a9$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    try {
        const e = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Au.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.hu = !0 : e.modifiedDocuments.size > 0 ? $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(r.hu, 14607) : e.removedDocuments.size > 0 && ($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(r.hu, 42227), r.hu = !1));
        }), await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Tu.forEach((n, r)=>{
            const i = r.view.va(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.Sa)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.va(t) && (r = !0);
            }), r && $a33cbddcd7bfa0a9$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Pu.H_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Au.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $a33cbddcd7bfa0a9$var$MutableDocument.newNoDocument(s, $a33cbddcd7bfa0a9$var$SnapshotVersion.min()));
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet().add(s), i = new $a33cbddcd7bfa0a9$var$RemoteEvent($a33cbddcd7bfa0a9$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator), e, n);
        await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.du = r.du.remove(s), r.Au.delete(t), $a33cbddcd7bfa0a9$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$a33cbddcd7bfa0a9$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $a33cbddcd7bfa0a9$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $a33cbddcd7bfa0a9$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $a33cbddcd7bfa0a9$var$__PRIVATE_processUserCallback(r, t, n), $a33cbddcd7bfa0a9$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    $a33cbddcd7bfa0a9$var$__PRIVATE_canUseNetwork(n.remoteStore) || $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$sn, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $a33cbddcd7bfa0a9$var$j) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.mu.get(e) || [];
        r.push(t), n.mu.set(e, r);
    } catch (e) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.mu.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.mu.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    let i = r.Vu[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Vu[r.currentUser.toKey()] = i;
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Iu.get(t))e.Tu.delete(r), n && e.Pu.yu(r, n);
    if (e.Iu.delete(t), e.isPrimaryClient) e.Ru.jr(t).forEach((t)=>{
        e.Ru.containsKey(t) || // We removed the last reference for this key
        $a33cbddcd7bfa0a9$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Eu.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.du.get(t);
    null !== n && ($a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.du = e.du.remove(t), e.Au.delete(n), $a33cbddcd7bfa0a9$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_AddedLimboDocument) e.Ru.addReference(r.key, t), $a33cbddcd7bfa0a9$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_RemovedLimboDocument) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$sn, "Document no longer in limbo: " + r.key), e.Ru.removeReference(r.key, t);
        e.Ru.containsKey(r.key) || // We removed the last reference for this key
        $a33cbddcd7bfa0a9$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $a33cbddcd7bfa0a9$var$fail(19791, {
        wu: r
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.du.get(n) || e.Eu.has(r) || ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$sn, "New document in limbo: " + n), e.Eu.add(r), $a33cbddcd7bfa0a9$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Eu.size > 0 && e.du.size < e.maxConcurrentLimboResolutions;){
        const t = e.Eu.values().next().value;
        e.Eu.delete(t);
        const n = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$ResourcePath.fromString(t)), r = e.fu.next();
        e.Au.set(r, new $a33cbddcd7bfa0a9$var$LimboResolution(n)), e.du = e.du.insert(n, r), $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $a33cbddcd7bfa0a9$var$TargetData($a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget($a33cbddcd7bfa0a9$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $a33cbddcd7bfa0a9$var$__PRIVATE_ListenSequence.ce));
    }
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Tu.isEmpty() || (r.Tu.forEach((e, _)=>{
        o.push(r.pu(_, t, n).then((e)=>{
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const t = e ? !e.fromCache : n?.targetChanges.get(_.targetId)?.current;
                r.sharedClientState.updateQueryState(_.targetId, t ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_LocalViewChanges.As(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Pu.H_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t, (t)=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t.Es, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$a33cbddcd7bfa0a9$var$PersistencePromise.forEach(t.ds, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$Ut, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.Ms.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.Ms = n.Ms.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$sn, "User change. New user:", t.toKey());
        const e = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.mu.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.CANCELLED, t));
                });
            }), e.mu.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Ls);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = n.Au.get(t);
    if (r && r.hu) return $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet();
        const r = n.Iu.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Tu.get(t);
            e = e.unionWith(r.view.nu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.cu(r);
    return n.isPrimaryClient && $a33cbddcd7bfa0a9$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.au), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.er(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $a33cbddcd7bfa0a9$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $a33cbddcd7bfa0a9$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($a33cbddcd7bfa0a9$var$__PRIVATE_processUserCallback(i, t, r || null), $a33cbddcd7bfa0a9$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast($a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e).mutationQueue).ir(t);
    }(i.localStore, t)) : $a33cbddcd7bfa0a9$var$fail(6720, "Unknown batchState", {
        Su: n
    }), await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$sn, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchCallbacks(n), $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.gu) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $a33cbddcd7bfa0a9$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.gu = !0, await $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.gu) {
        const e = [];
        let t = Promise.resolve();
        n.Iu.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($a33cbddcd7bfa0a9$var$__PRIVATE_removeAndCleanupTarget(n, i), $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $a33cbddcd7bfa0a9$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            t.Au.forEach((e, n)=>{
                $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Ru.Jr(), t.Au = new Map, t.du = new $a33cbddcd7bfa0a9$var$SortedMap($a33cbddcd7bfa0a9$export$afc2e57c475b7810.comparator);
        }(n), n.gu = !1, await $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Iu.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Tu.get(e), n = await $a33cbddcd7bfa0a9$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $a33cbddcd7bfa0a9$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $a33cbddcd7bfa0a9$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Pu.H_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $a33cbddcd7bfa0a9$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast($a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e).persistence).Ts();
    }($a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    if (i.gu) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$sn, "Ignoring unexpected query state notification.");
    const s = i.Iu.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $a33cbddcd7bfa0a9$var$__PRIVATE_queryCollectionGroup(s[0])), r = $a33cbddcd7bfa0a9$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $a33cbddcd7bfa0a9$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $a33cbddcd7bfa0a9$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $a33cbddcd7bfa0a9$var$fail(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.gu) {
        for (const e of t){
            if (r.Iu.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$sn, "Adding an already active target " + e);
                continue;
            }
            const t = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $a33cbddcd7bfa0a9$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $a33cbddcd7bfa0a9$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Iu.has(e) && // Release queries that are still active.
        await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $a33cbddcd7bfa0a9$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($a33cbddcd7bfa0a9$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Pu.H_ = $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Pu.yu = $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = $a33cbddcd7bfa0a9$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Ii.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($a33cbddcd7bfa0a9$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $a33cbddcd7bfa0a9$var$__PRIVATE_BundleLoader(r, t.serializer);
            let s = await t.bu();
            for(; s;){
                const e = await i.Ga(s);
                e && n._updateProgress(e), s = await t.bu();
            }
            const o = await i.ja(e.localStore);
            return await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ha, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Ii.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Ja);
        } catch (e) {
            return $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb($a33cbddcd7bfa0a9$var$sn, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.Du(e), this.persistence = this.Cu(e), await this.persistence.start(), this.localStore = this.vu(e), this.gcScheduler = this.Fu(e, this.localStore), this.indexBackfillerScheduler = this.Mu(e, this.localStore);
    }
    Fu(e, t) {
        return null;
    }
    Mu(e, t) {
        return null;
    }
    vu(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_newLocalStore(this.persistence, new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Cu(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryPersistence($a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerDelegate.mi, this.serializer);
    }
    Du(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler?.stop(), this.indexBackfillerScheduler?.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$a33cbddcd7bfa0a9$var$__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: ()=>new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryOfflineComponentProvider
};
class $a33cbddcd7bfa0a9$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Fu(e, t) {
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Cu(e) {
        const t = void 0 !== this.cacheSizeBytes ? $a33cbddcd7bfa0a9$var$LruParams.withCacheSize(this.cacheSizeBytes) : $a33cbddcd7bfa0a9$var$LruParams.DEFAULT;
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryPersistence((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruDelegate.mi(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.xu = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.xu.initialize(this, e), // Enqueue writes from a previous session
        await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.xu.syncEngine), await $a33cbddcd7bfa0a9$var$__PRIVATE_fillWritePipeline(this.xu.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ji(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    vu(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_newLocalStore(this.persistence, new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Fu(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Mu(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Cu(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $a33cbddcd7bfa0a9$var$LruParams.withCacheSize(this.cacheSizeBytes) : $a33cbddcd7bfa0a9$var$LruParams.DEFAULT;
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $a33cbddcd7bfa0a9$var$__PRIVATE_getWindow(), $a33cbddcd7bfa0a9$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Du(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabOfflineComponentProvider extends $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.xu = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.xu.syncEngine;
        this.sharedClientState instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Co: $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            vo: $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Fo: $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            Ts: $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            Do: $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ji(async (e)=>{
            await $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyPrimaryState(this.xu.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Du(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_getWindow();
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_WebStorageSharedClientState.v(t)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $a33cbddcd7bfa0a9$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $a33cbddcd7bfa0a9$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $a33cbddcd7bfa0a9$var$__PRIVATE_BrowserConnectivityMonitor.v() ? new $a33cbddcd7bfa0a9$var$__PRIVATE_BrowserConnectivityMonitor : new $a33cbddcd7bfa0a9$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $a33cbddcd7bfa0a9$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.gu = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$tn, "RemoteStore shutting down."), t.Ea.add(5 /* OfflineCause.Shutdown */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkInternal(t), t.Aa.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.Ra.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), this.datastore?.terminate(), this.eventManager?.terminate();
    }
}
$a33cbddcd7bfa0a9$var$OnlineComponentProvider.provider = {
    build: ()=>new $a33cbddcd7bfa0a9$var$OnlineComponentProvider
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.Ou(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.Ou(this.observer.error, e) : $a33cbddcd7bfa0a9$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Nu() {
        this.muted = !0;
    }
    Ou(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Bu = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Lu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.ku().then((e)=>{
            e && e.$a() ? this.metadata.resolve(e.Qa.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(e?.Qa)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Bu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async bu() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.ku();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async ku() {
        const e = await this.qu();
        if (null === e) return null;
        const t = this.Lu.decode(e), n = Number(t);
        isNaN(n) && this.Qu(`length string (${t}) is not valid number`);
        const r = await this.$u(n);
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ Uu() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async qu() {
        for(; this.Uu() < 0;){
            if (await this.Ku()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.Uu();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.Qu("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async $u(e) {
        for(; this.buffer.length < e;)await this.Ku() && this.Qu("Reached the end of bundle when more is expected.");
        const t = this.Lu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    Qu(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Bu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Ku() {
        const e = await this.Bu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.bu();
        if (!n || !n.$a()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(n?.Qa)}`);
        this.metadata = n;
        do n = this.bu(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ Wu() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ bu() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.qu(), t = this.$u(e);
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length how many characters to read.
     * @returns a string parsed from the bundle.
     */ $u(e) {
        if (this.cursor + e > this.bundleData.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ qu() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $a33cbddcd7bfa0a9$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.Ho("BatchGetDocuments", n.serializer.databaseId, $a33cbddcd7bfa0a9$var$ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(!!t, 55234, {
                    key: e
                }), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $a33cbddcd7bfa0a9$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$a33cbddcd7bfa0a9$var$toMutation(n.serializer, e))
            };
            await n.Go("Commit", n.serializer.databaseId, $a33cbddcd7bfa0a9$var$ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $a33cbddcd7bfa0a9$var$fail(50498, {
                Gu: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $a33cbddcd7bfa0a9$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min()) ? $a33cbddcd7bfa0a9$var$Precondition.exists(!1) : $a33cbddcd7bfa0a9$var$Precondition.updateTime(t) : $a33cbddcd7bfa0a9$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($a33cbddcd7bfa0a9$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $a33cbddcd7bfa0a9$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $a33cbddcd7bfa0a9$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.zu = n.maxAttempts, this.M_ = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ ju() {
        this.zu -= 1, this.Ju();
    }
    Ju() {
        this.M_.p_(async ()=>{
            const e = new $a33cbddcd7bfa0a9$var$Transaction$2(this.datastore), t = this.Hu(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Yu(e);
                    }));
            }).catch((e)=>{
                this.Yu(e);
            });
        });
    }
    Hu(e) {
        try {
            const t = this.updateFunction(e);
            return !$a33cbddcd7bfa0a9$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Yu(e) {
        this.zu > 0 && this.Zu(e) ? (this.zu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Ju(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Zu(e) {
        if ("FirebaseError" === e?.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$a33cbddcd7bfa0a9$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$on = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $a33cbddcd7bfa0a9$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $a33cbddcd7bfa0a9$var$User.UNAUTHENTICATED, this.clientId = $a33cbddcd7bfa0a9$export$253bcaa5572dcc83.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOfflineComponents(e);
    $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Using user provided OfflineComponentProvider");
            try {
                await $a33cbddcd7bfa0a9$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION || e.code === $a33cbddcd7bfa0a9$var$N.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $a33cbddcd7bfa0a9$var$__PRIVATE_setOfflineComponentProvider(e, new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryOfflineComponentProvider);
            }
        } else $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Using default OfflineComponentProvider"), await $a33cbddcd7bfa0a9$var$__PRIVATE_setOfflineComponentProvider(e, new $a33cbddcd7bfa0a9$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    }
    return e._offlineComponents;
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Using user provided OnlineComponentProvider"), await $a33cbddcd7bfa0a9$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$on, "Using default OnlineComponentProvider"), await $a33cbddcd7bfa0a9$var$__PRIVATE_setOnlineComponentProvider(e, new $a33cbddcd7bfa0a9$var$OnlineComponentProvider))), e._onlineComponents;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getPersistence(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getRemoteStore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getSyncEngine(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_getDatastore(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $a33cbddcd7bfa0a9$var$__PRIVATE_getEventManager(e) {
    const t = await $a33cbddcd7bfa0a9$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $a33cbddcd7bfa0a9$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $a33cbddcd7bfa0a9$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $a33cbddcd7bfa0a9$var$__PRIVATE_getPersistence(e), n = await $a33cbddcd7bfa0a9$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            return t.Ea.delete(0 /* OfflineCause.UserDisabled */ ), $a33cbddcd7bfa0a9$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $a33cbddcd7bfa0a9$var$__PRIVATE_getPersistence(e), n = await $a33cbddcd7bfa0a9$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            t.Ea.add(0 /* OfflineCause.UserDisabled */ ), await $a33cbddcd7bfa0a9$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.Ra.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $a33cbddcd7bfa0a9$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Nu(), t.enqueueAndForget(()=>$a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryListener($a33cbddcd7bfa0a9$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                qa: !0
            });
            return $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerListen(e, o);
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $a33cbddcd7bfa0a9$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $a33cbddcd7bfa0a9$var$__PRIVATE_View(t, r.Qs), s = i.ru(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $a33cbddcd7bfa0a9$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Nu(), t.enqueueAndForget(()=>$a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                qa: !0
            });
            return $a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerListen(e, o);
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $a33cbddcd7bfa0a9$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                const r = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), { request: i, gt: s, parent: o } = $a33cbddcd7bfa0a9$var$__PRIVATE_toRunAggregationQueryRequest(r.serializer, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToAggregateTarget(t), n);
                r.connection.$o || delete i.parent;
                const _ = (await r.Ho("RunAggregationQuery", r.serializer.databaseId, o, i, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert(1 === _.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const a = _[0].result?.aggregateFields;
                return Object.keys(a).reduce((e, t)=>(e[s[t]] = a[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e).Ca.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Nu(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e).Ca.delete(t);
            })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $a33cbddcd7bfa0a9$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $a33cbddcd7bfa0a9$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $a33cbddcd7bfa0a9$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineLoadBundle(await $a33cbddcd7bfa0a9$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Ii.getNamedQuery(e, t));
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalStore(e), t));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_createBundleReaderSync(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $a33cbddcd7bfa0a9$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$a33cbddcd7bfa0a9$var$PersistencePromise.waitFor(i)));
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalStore(e), t));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e).Fs.Vs = t;
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalStore(e), t));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $a33cbddcd7bfa0a9$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$_n = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $a33cbddcd7bfa0a9$var$an = "firestore.googleapis.com", $a33cbddcd7bfa0a9$var$un = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $a33cbddcd7bfa0a9$var$FirestoreSettingsImpl {
    constructor(e){
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $a33cbddcd7bfa0a9$var$an, this.ssl = $a33cbddcd7bfa0a9$var$un;
        } else this.host = e.host, this.ssl = e.ssl ?? $a33cbddcd7bfa0a9$var$un;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $a33cbddcd7bfa0a9$var$Ot;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $a33cbddcd7bfa0a9$var$Bt) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $a33cbddcd7bfa0a9$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $a33cbddcd7bfa0a9$var$__PRIVATE_cloneLongPollingOptions(e.experimentalLongPollingOptions ?? {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $a33cbddcd7bfa0a9$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $a33cbddcd7bfa0a9$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $a33cbddcd7bfa0a9$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $a33cbddcd7bfa0a9$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $a33cbddcd7bfa0a9$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $a33cbddcd7bfa0a9$var$_n.get(e);
            t && ($a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $a33cbddcd7bfa0a9$var$_n.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $a33cbddcd7bfa0a9$export$966a03d25297d115(e, t, n, r = {}) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$var$Firestore$1);
    const i = (0, $029952e65115eee5$export$5b4d24b45140ad90)(t), s = e._getSettings(), o = {
        ...s,
        emulatorOptions: e._getEmulatorOptions()
    }, _ = `${t}:${n}`;
    i && ((0, $029952e65115eee5$export$c0f0d0ce4283a937)(`https://${_}`), (0, $029952e65115eee5$export$fd3d2954543183b1)("Firestore", !0)), s.host !== $a33cbddcd7bfa0a9$var$an && s.host !== _ && $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const a = {
        ...s,
        host: _,
        ssl: i,
        emulatorOptions: r
    };
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $029952e65115eee5$export$9cb4719e2e525b7a)(a, o) && (e._setSettings(a), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $a33cbddcd7bfa0a9$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $029952e65115eee5$export$367bf224123348f1)(r.mockUserToken, e._app?.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $a33cbddcd7bfa0a9$var$User(i);
        }
        e._authCredentials = new $a33cbddcd7bfa0a9$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $a33cbddcd7bfa0a9$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $a33cbddcd7bfa0a9$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $a33cbddcd7bfa0a9$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $a33cbddcd7bfa0a9$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $a33cbddcd7bfa0a9$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $a33cbddcd7bfa0a9$export$6be62b059fb12175(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $a33cbddcd7bfa0a9$export$6be62b059fb12175._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(t, $a33cbddcd7bfa0a9$export$6be62b059fb12175._jsonSchema)) return new $a33cbddcd7bfa0a9$export$6be62b059fb12175(e, n || null, new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$ResourcePath.fromString(t.referencePath)));
    }
}
$a33cbddcd7bfa0a9$export$6be62b059fb12175._jsonSchemaVersion = "firestore/documentReference/1.0", $a33cbddcd7bfa0a9$export$6be62b059fb12175._jsonSchema = {
    type: $a33cbddcd7bfa0a9$var$property("string", $a33cbddcd7bfa0a9$export$6be62b059fb12175._jsonSchemaVersion),
    referencePath: $a33cbddcd7bfa0a9$var$property("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $a33cbddcd7bfa0a9$export$ab5a1a47940a200e extends $a33cbddcd7bfa0a9$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $a33cbddcd7bfa0a9$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $a33cbddcd7bfa0a9$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $a33cbddcd7bfa0a9$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), $a33cbddcd7bfa0a9$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $a33cbddcd7bfa0a9$var$Firestore$1) {
        const r = $a33cbddcd7bfa0a9$var$ResourcePath.fromString(t, ...n);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateCollectionPath(r), new $a33cbddcd7bfa0a9$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175 || e instanceof $a33cbddcd7bfa0a9$export$ab5a1a47940a200e)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($a33cbddcd7bfa0a9$var$ResourcePath.fromString(t, ...n));
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateCollectionPath(r), new $a33cbddcd7bfa0a9$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $a33cbddcd7bfa0a9$export$473d82a73f88c107(e, t) {
    if (e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$var$Firestore$1), $a33cbddcd7bfa0a9$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $a33cbddcd7bfa0a9$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl($a33cbddcd7bfa0a9$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $a33cbddcd7bfa0a9$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $a33cbddcd7bfa0a9$export$253bcaa5572dcc83.newId()), $a33cbddcd7bfa0a9$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $a33cbddcd7bfa0a9$var$Firestore$1) {
        const r = $a33cbddcd7bfa0a9$var$ResourcePath.fromString(t, ...n);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateDocumentPath(r), new $a33cbddcd7bfa0a9$export$6be62b059fb12175(e, /* converter= */ null, new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175 || e instanceof $a33cbddcd7bfa0a9$export$ab5a1a47940a200e)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($a33cbddcd7bfa0a9$var$ResourcePath.fromString(t, ...n));
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateDocumentPath(r), new $a33cbddcd7bfa0a9$export$6be62b059fb12175(e.firestore, e instanceof $a33cbddcd7bfa0a9$export$ab5a1a47940a200e ? e.converter : null, new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $a33cbddcd7bfa0a9$export$62a32f2da6187d11(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), (e instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175 || e instanceof $a33cbddcd7bfa0a9$export$ab5a1a47940a200e) && (t instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175 || t instanceof $a33cbddcd7bfa0a9$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $a33cbddcd7bfa0a9$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), e instanceof $a33cbddcd7bfa0a9$export$62297b13309008b2 && t instanceof $a33cbddcd7bfa0a9$export$62297b13309008b2 && e.firestore === t.firestore && $a33cbddcd7bfa0a9$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$cn = "AsyncQueue";
class $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Xu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.ec = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.tc = [], // visible for testing
        this.nc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.rc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.sc = !1, // List of TimerIds to fast-forward delays for.
        this.oc = [], // Backoff timer used to schedule retries for retryable operations
        this.M_ = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this._c = ()=>{
            const e = $a33cbddcd7bfa0a9$var$getDocument();
            e && $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$cn, "Visibility state changed to " + e.visibilityState), this.M_.w_();
        }, this.ac = e;
        const t = $a33cbddcd7bfa0a9$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this._c);
    }
    get isShuttingDown() {
        return this.ec;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.uc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.cc(e);
    }
    enterRestrictedMode(e) {
        if (!this.ec) {
            this.ec = !0, this.sc = e || !1;
            const t = $a33cbddcd7bfa0a9$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this._c);
        }
    }
    enqueue(e) {
        if (this.uc(), this.ec) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
        return this.cc(()=>this.ec && this.sc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Xu.push(e), this.lc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async lc() {
        if (0 !== this.Xu.length) {
            try {
                await this.Xu[0](), this.Xu.shift(), this.M_.reset();
            } catch (e) {
                if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $a33cbddcd7bfa0a9$var$__PRIVATE_logDebug($a33cbddcd7bfa0a9$var$cn, "Operation failed with retryable error: " + e);
            }
            this.Xu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.M_.p_(()=>this.lc());
        }
    }
    cc(e) {
        const t = this.ac.then(()=>(this.rc = !0, e().catch((e)=>{
                this.nc = e, this.rc = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $a33cbddcd7bfa0a9$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $a33cbddcd7bfa0a9$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.rc = !1, e))));
        return this.ac = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.uc(), // Fast-forward delays for timerIds that have been overridden.
        this.oc.indexOf(e) > -1 && (t = 0);
        const r = $a33cbddcd7bfa0a9$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.hc(e));
        return this.tc.push(r), r;
    }
    uc() {
        this.nc && $a33cbddcd7bfa0a9$var$fail(47125, {
            Pc: $a33cbddcd7bfa0a9$var$__PRIVATE_getMessageOrStack(this.nc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async Tc() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.ac, await e;
        while (e !== this.ac);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Ic(e) {
        for (const t of this.tc)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Ec(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Tc().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.tc.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.tc)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.Tc();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ dc(e) {
        this.oc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ hc(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.tc.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.tc.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $a33cbddcd7bfa0a9$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $a33cbddcd7bfa0a9$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $a33cbddcd7bfa0a9$export$d0e2b3272814ce82 extends $a33cbddcd7bfa0a9$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = r?.name || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $a33cbddcd7bfa0a9$export$9061557f3e3b42f9(e, t, n) {
    n || (n = $a33cbddcd7bfa0a9$var$lt);
    const r = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $a33cbddcd7bfa0a9$var$Bt) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $029952e65115eee5$export$5b4d24b45140ad90)(t.host) && (0, $029952e65115eee5$export$c0f0d0ce4283a937)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $a33cbddcd7bfa0a9$export$f06a05d14c3a6678(e, n) {
    const r = "object" == typeof e ? e : (0, $5e587d655f0a08bb$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : n || $a33cbddcd7bfa0a9$var$lt, s = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $029952e65115eee5$export$a3febcf1f14a3a0c)("firestore");
        e && $a33cbddcd7bfa0a9$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $a33cbddcd7bfa0a9$export$8da5fbea04405656(e) {
    if (e._terminated) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $a33cbddcd7bfa0a9$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_configureFirestore(e) {
    const t = e._freezeSettings(), n = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $a33cbddcd7bfa0a9$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $a33cbddcd7bfa0a9$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams, r.isUsingEmulator);
    }(e._databaseId, e._app?.options.appId || "", e._persistenceKey, t);
    e._componentsProvider || t.localCache?._offlineComponentProvider && t.localCache?._onlineComponentProvider && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new $a33cbddcd7bfa0a9$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = e?._online.build();
        return {
            _offline: e?._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $a33cbddcd7bfa0a9$export$cebe3b626a79c5f3(e, t) {
    $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistenceProviders(e, $a33cbddcd7bfa0a9$var$OnlineComponentProvider.provider, {
        build: (e)=>new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, t?.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $a33cbddcd7bfa0a9$export$6d4c055e91302ab9(e) {
    $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistenceProviders(e, $a33cbddcd7bfa0a9$var$OnlineComponentProvider.provider, {
        build: (e)=>new $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82))._firestoreClient || e._terminated) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $a33cbddcd7bfa0a9$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $a33cbddcd7bfa0a9$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.v()) return Promise.resolve();
                const t = e + $a33cbddcd7bfa0a9$var$$t;
                await $a33cbddcd7bfa0a9$var$__PRIVATE_SimpleDb.delete(t);
            }($a33cbddcd7bfa0a9$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $a33cbddcd7bfa0a9$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $a33cbddcd7bfa0a9$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $a33cbddcd7bfa0a9$export$ee6bdee8287ecc5f(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientEnableNetwork($a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $a33cbddcd7bfa0a9$export$f35b708ad73d52eb(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientDisableNetwork($a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $a33cbddcd7bfa0a9$export$9aff22d1ec357a14(e) {
    return (0, $5e587d655f0a08bb$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $a33cbddcd7bfa0a9$export$4b8b93c690c9810b(e, t) {
    const n = $a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)), r = new $a33cbddcd7bfa0a9$export$6cac12425252ec14;
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $a33cbddcd7bfa0a9$export$169d2c6fe0f7f4ea(e, t) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetNamedQuery($a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)), t).then((t)=>t ? new $a33cbddcd7bfa0a9$export$62297b13309008b2(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $a33cbddcd7bfa0a9$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(e = "count", t){
        this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $a33cbddcd7bfa0a9$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1($a33cbddcd7bfa0a9$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1($a33cbddcd7bfa0a9$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(e, $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1._jsonSchema)) return $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1.fromBase64String(e.bytes);
    }
}
$a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1._jsonSchemaVersion = "firestore/bytes/1.0", $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1._jsonSchema = {
    type: $a33cbddcd7bfa0a9$var$property("string", $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1._jsonSchemaVersion),
    bytes: $a33cbddcd7bfa0a9$var$property("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $a33cbddcd7bfa0a9$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $a33cbddcd7bfa0a9$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $a33cbddcd7bfa0a9$export$bf6e62266977b8eb() {
    return new $a33cbddcd7bfa0a9$export$a1a8fea822d17659($a33cbddcd7bfa0a9$var$k);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $a33cbddcd7bfa0a9$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $a33cbddcd7bfa0a9$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $a33cbddcd7bfa0a9$export$f9f719d1b6419c4._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(e, $a33cbddcd7bfa0a9$export$f9f719d1b6419c4._jsonSchema)) return new $a33cbddcd7bfa0a9$export$f9f719d1b6419c4(e.latitude, e.longitude);
    }
}
$a33cbddcd7bfa0a9$export$f9f719d1b6419c4._jsonSchemaVersion = "firestore/geoPoint/1.0", $a33cbddcd7bfa0a9$export$f9f719d1b6419c4._jsonSchema = {
    type: $a33cbddcd7bfa0a9$var$property("string", $a33cbddcd7bfa0a9$export$f9f719d1b6419c4._jsonSchemaVersion),
    latitude: $a33cbddcd7bfa0a9$var$property("number"),
    longitude: $a33cbddcd7bfa0a9$var$property("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 *
 * @class VectorValue
 */ class $a33cbddcd7bfa0a9$export$994bb3d317350b37 {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $a33cbddcd7bfa0a9$export$994bb3d317350b37._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(e, $a33cbddcd7bfa0a9$export$994bb3d317350b37._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $a33cbddcd7bfa0a9$export$994bb3d317350b37(e.vectorValues);
            throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$a33cbddcd7bfa0a9$export$994bb3d317350b37._jsonSchemaVersion = "firestore/vectorValue/1.0", $a33cbddcd7bfa0a9$export$994bb3d317350b37._jsonSchema = {
    type: $a33cbddcd7bfa0a9$var$property("string", $a33cbddcd7bfa0a9$export$994bb3d317350b37._jsonSchemaVersion),
    vectorValues: $a33cbddcd7bfa0a9$var$property("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$hn = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $a33cbddcd7bfa0a9$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $a33cbddcd7bfa0a9$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $a33cbddcd7bfa0a9$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $a33cbddcd7bfa0a9$var$fail(40011, {
                Ac: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $a33cbddcd7bfa0a9$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Rc(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get Ac() {
        return this.settings.Ac;
    }
    /** Returns a new context with the specified settings overwritten. */ Vc(e) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_ParseContextImpl({
            ...this.settings,
            ...e
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    mc(e) {
        const t = this.path?.child(e), n = this.Vc({
            path: t,
            fc: !1
        });
        return n.gc(e), n;
    }
    yc(e) {
        const t = this.path?.child(e), n = this.Vc({
            path: t,
            fc: !1
        });
        return n.Rc(), n;
    }
    wc(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.Vc({
            path: void 0,
            fc: !0
        });
    }
    Sc(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.bc || !1, this.path, this.settings.Dc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    Rc() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.gc(this.path.get(e));
    }
    gc(e) {
        if (0 === e.length) throw this.Sc("Document fields must not be empty");
        if ($a33cbddcd7bfa0a9$var$__PRIVATE_isWrite(this.Ac) && $a33cbddcd7bfa0a9$var$hn.test(e)) throw this.Sc('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ Cc(e, t, n, r = !1) {
        return new $a33cbddcd7bfa0a9$var$__PRIVATE_ParseContextImpl({
            Ac: e,
            methodName: t,
            Dc: n,
            path: $a33cbddcd7bfa0a9$export$b7871852b967eaf1.emptyPath(),
            fc: !1,
            bc: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(e._databaseId);
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.Cc(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $a33cbddcd7bfa0a9$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $a33cbddcd7bfa0a9$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $a33cbddcd7bfa0a9$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $a33cbddcd7bfa0a9$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $a33cbddcd7bfa0a9$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $a33cbddcd7bfa0a9$var$ParsedSetData(new $a33cbddcd7bfa0a9$var$ObjectValue(_), a, u);
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteFieldValueImpl extends $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.Ac) throw 1 /* UserDataSource.Update */  === e.Ac ? e.Sc(`${this._methodName}() can only appear at the top level of your update data`) : e.Sc(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_ParseContextImpl({
        Ac: 3 /* UserDataSource.Argument */ ,
        Dc: t.settings.Dc,
        methodName: e._methodName,
        fc: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampFieldValueImpl extends $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $a33cbddcd7bfa0a9$var$FieldTransform(e.path, new $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionFieldValueImpl extends $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_parseData(e, t)), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $a33cbddcd7bfa0a9$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this.vc, e.vc);
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_parseData(e, t)), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $a33cbddcd7bfa0a9$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this.vc, e.vc);
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementFieldValueImpl extends $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Fc = t;
    }
    _toFieldTransform(e) {
        const t = new $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $a33cbddcd7bfa0a9$var$toNumber(e.serializer, this.Fc));
        return new $a33cbddcd7bfa0a9$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Fc === e.Fc;
    }
}
/** Parse update data from an update() call. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.Cc(1 /* UserDataSource.Update */ , t, n);
    $a33cbddcd7bfa0a9$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $a33cbddcd7bfa0a9$var$ObjectValue.empty();
    $a33cbddcd7bfa0a9$var$forEach(r, (e, r)=>{
        const _ = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(r);
        const a = i.yc(_);
        if (r instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $a33cbddcd7bfa0a9$var$FieldMask(s);
    return new $a33cbddcd7bfa0a9$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.Cc(1 /* UserDataSource.Update */ , t, n), _ = [
        $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $a33cbddcd7bfa0a9$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$a33cbddcd7bfa0a9$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n);
        const r = o.yc(t);
        if (n instanceof $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $a33cbddcd7bfa0a9$var$FieldMask(u);
    return new $a33cbddcd7bfa0a9$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_parseData(n, e.Cc(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_parseData(e, t) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return $a33cbddcd7bfa0a9$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $a33cbddcd7bfa0a9$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isWrite(t.Ac)) throw t.Sc(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.Sc(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.fc && 4 /* UserDataSource.ArrayArgument */  !== t.Ac) throw t.Sc("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $a33cbddcd7bfa0a9$var$__PRIVATE_parseData(i, t.wc(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $a33cbddcd7bfa0a9$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $a33cbddcd7bfa0a9$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $a33cbddcd7bfa0a9$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $a33cbddcd7bfa0a9$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $a33cbddcd7bfa0a9$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.Sc(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $a33cbddcd7bfa0a9$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $a33cbddcd7bfa0a9$export$994bb3d317350b37) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = {
                fields: {
                    [$a33cbddcd7bfa0a9$var$ht]: {
                        stringValue: $a33cbddcd7bfa0a9$var$It
                    },
                    [$a33cbddcd7bfa0a9$var$Et]: {
                        arrayValue: {
                            values: e.toArray().map((e)=>{
                                if ("number" != typeof e) throw t.Sc("VectorValues must only contain numeric values.");
                                return $a33cbddcd7bfa0a9$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: n
            };
        }(e, t);
        throw t.Sc(`Unsupported field value: ${$a33cbddcd7bfa0a9$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $a33cbddcd7bfa0a9$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $a33cbddcd7bfa0a9$var$forEach(e, (e, r)=>{
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_parseData(r, t.mc(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430 || e instanceof $a33cbddcd7bfa0a9$export$f9f719d1b6419c4 || e instanceof $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1 || e instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175 || e instanceof $a33cbddcd7bfa0a9$export$c58bc8ee7ecc248d || e instanceof $a33cbddcd7bfa0a9$export$994bb3d317350b37);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$a33cbddcd7bfa0a9$var$__PRIVATE_looksLikeJsonObject(n) || !$a33cbddcd7bfa0a9$var$__PRIVATE_isPlainObject(n)) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.Sc(e + " a custom object") : t.Sc(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)) instanceof $a33cbddcd7bfa0a9$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $a33cbddcd7bfa0a9$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $a33cbddcd7bfa0a9$var$Pn = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($a33cbddcd7bfa0a9$var$Pn) >= 0) throw $a33cbddcd7bfa0a9$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $a33cbddcd7bfa0a9$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $a33cbddcd7bfa0a9$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $a33cbddcd7bfa0a9$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $a33cbddcd7bfa0a9$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $a33cbddcd7bfa0a9$var$QueryDocumentSnapshot$1 extends $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $a33cbddcd7bfa0a9$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
function $a33cbddcd7bfa0a9$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $a33cbddcd7bfa0a9$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$f765fc5789dfd439 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $a33cbddcd7bfa0a9$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $a33cbddcd7bfa0a9$export$62297b13309008b2(e.firestore, e.converter, $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $a33cbddcd7bfa0a9$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            const a = $a33cbddcd7bfa0a9$var$FieldFilter.create(i, s, _);
            return a;
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $a33cbddcd7bfa0a9$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2 extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $a33cbddcd7bfa0a9$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(n, e), n = $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $a33cbddcd7bfa0a9$export$62297b13309008b2(e.firestore, e.converter, $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new $a33cbddcd7bfa0a9$var$OrderBy(t, n);
            return r;
        }(e._query, this._field, this._direction);
        return new $a33cbddcd7bfa0a9$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $a33cbddcd7bfa0a9$export$49bb5356ca788047 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $a33cbddcd7bfa0a9$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $a33cbddcd7bfa0a9$export$62297b13309008b2(e.firestore, e.converter, $a33cbddcd7bfa0a9$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$ee37e834aaad6f7e(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_validatePositiveNumber("limit", e), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f823b3589f69d3b8(e) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$d92e2830aca1d816 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $a33cbddcd7bfa0a9$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $a33cbddcd7bfa0a9$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $a33cbddcd7bfa0a9$export$859941c5fc8eba6b(...e) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $a33cbddcd7bfa0a9$export$dd8dee5f7b804673(...e) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$fd1782fd870d1e06 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $a33cbddcd7bfa0a9$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $a33cbddcd7bfa0a9$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $a33cbddcd7bfa0a9$export$57203950645b8b11(...e) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $a33cbddcd7bfa0a9$export$28ec54a8428bdb3f(...e) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $a33cbddcd7bfa0a9$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $a33cbddcd7bfa0a9$var$__PRIVATE_queryNormalizedOrderBy(e))if (n.field.isKeyField()) s.push($a33cbddcd7bfa0a9$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($a33cbddcd7bfa0a9$var$__PRIVATE_isServerTimestamp(e)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $a33cbddcd7bfa0a9$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($a33cbddcd7bfa0a9$var$ResourcePath.fromString(a));
                    if (!$a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(n)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(n);
                    _.push($a33cbddcd7bfa0a9$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $a33cbddcd7bfa0a9$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $a33cbddcd7bfa0a9$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$a33cbddcd7bfa0a9$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($a33cbddcd7bfa0a9$var$ResourcePath.fromString(n));
        if (!$a33cbddcd7bfa0a9$export$afc2e57c475b7810.isDocumentKey(r)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_refValue(e, new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(r));
    }
    if (n instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175) return $a33cbddcd7bfa0a9$var$__PRIVATE_refValue(e, n._key);
    throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$a33cbddcd7bfa0a9$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439 || t instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2)) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $a33cbddcd7bfa0a9$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($a33cbddcd7bfa0a9$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $a33cbddcd7bfa0a9$var$fail(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $a33cbddcd7bfa0a9$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        const t = e.fields?.[$a33cbddcd7bfa0a9$var$Et].arrayValue?.values?.map((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $a33cbddcd7bfa0a9$export$994bb3d317350b37(t);
    }
    convertGeoPoint(e) {
        return new $a33cbddcd7bfa0a9$export$f9f719d1b6419c4($a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.latitude), $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $a33cbddcd7bfa0a9$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($a33cbddcd7bfa0a9$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_normalizeTimestamp(e);
        return new $a33cbddcd7bfa0a9$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $a33cbddcd7bfa0a9$var$ResourcePath.fromString(e);
        $a33cbddcd7bfa0a9$var$__PRIVATE_hardAssert($a33cbddcd7bfa0a9$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $a33cbddcd7bfa0a9$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $a33cbddcd7bfa0a9$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter extends $a33cbddcd7bfa0a9$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $a33cbddcd7bfa0a9$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function $a33cbddcd7bfa0a9$export$8a63f25cc62965f1(e) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("sum", $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $a33cbddcd7bfa0a9$export$cc6710ee5f037d57(e) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("avg", $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $a33cbddcd7bfa0a9$export$85b9a36db797e02b() {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $a33cbddcd7bfa0a9$export$31fa8ec66e0239ad(e, t) {
    return e instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && t instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && e.aggregateType === t.aggregateType && e._internalFieldPath?.canonicalString() === t._internalFieldPath?.canonicalString();
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $a33cbddcd7bfa0a9$export$104f59389a332076(e, t) {
    return $a33cbddcd7bfa0a9$export$49b1d0de6ba30f41(e.query, t.query) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Tn = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $a33cbddcd7bfa0a9$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 extends $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const e = this._document, t = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (t.type = $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion, t.bundle = "", t.bundleSource = "DocumentSnapshot", t.bundleName = this._key.toString(), !e || !e.isValidDocument() || !e.isFoundDocument()) return t;
        this._userDataWriter.convertObjectMap(e.data.value.mapValue.fields, "previous");
        return t.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), t;
    }
}
function $a33cbddcd7bfa0a9$export$bbac1bdeb8972634(e, t, n) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(t, $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema)) {
        if (t.bundle === $a33cbddcd7bfa0a9$var$Tn) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(e._databaseId), i = $a33cbddcd7bfa0a9$var$__PRIVATE_createBundleReaderSync(t.bundle, r), s = i.Wu(), o = new $a33cbddcd7bfa0a9$var$__PRIVATE_BundleLoader(i.getMetadata(), r);
        for (const e of s)o.Ga(e);
        // Ensure that we have the correct number of documents in the bundle.
        const _ = o.documents;
        if (1 !== _.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${_.length} documents.`);
        // Build out the internal document data.
        const a = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDocument(r, _[0].document), u = new $a33cbddcd7bfa0a9$export$afc2e57c475b7810($a33cbddcd7bfa0a9$var$ResourcePath.fromString(t.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(e, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(e), u, a, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema = {
    type: $a33cbddcd7bfa0a9$var$property("string", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: $a33cbddcd7bfa0a9$var$property("string", "DocumentSnapshot"),
    bundleName: $a33cbddcd7bfa0a9$var$property("string"),
    bundle: $a33cbddcd7bfa0a9$var$property("string")
};
class $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c extends $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $a33cbddcd7bfa0a9$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = {};
        e.type = $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion, e.bundleSource = "QuerySnapshot", e.bundleName = $a33cbddcd7bfa0a9$export$253bcaa5572dcc83.newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const t = [], n = [], r = [];
        return this.docs.forEach((e)=>{
            null !== e._document && (t.push(e._document), n.push(this._userDataWriter.convertObjectMap(e._document.data.value.mapValue.fields, "previous")), r.push(e.ref.path));
        }), e.bundle = (this._firestore, this.query._query, e.bundleName, "NOT SUPPORTED"), e;
    }
}
function $a33cbddcd7bfa0a9$export$5bed7af38da9d026(e, t, n) {
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_validateJSON(t, $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema)) {
        if (t.bundle === $a33cbddcd7bfa0a9$var$Tn) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_newSerializer(e._databaseId), i = $a33cbddcd7bfa0a9$var$__PRIVATE_createBundleReaderSync(t.bundle, r), s = i.Wu(), o = new $a33cbddcd7bfa0a9$var$__PRIVATE_BundleLoader(i.getMetadata(), r);
        for (const e of s)o.Ga(e);
        if (1 !== o.queries.length) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const _ = $a33cbddcd7bfa0a9$var$__PRIVATE_fromBundledQuery(o.queries[0].bundledQuery), a = o.documents;
        // Construct the arrays of document data for the query.
        let u = new $a33cbddcd7bfa0a9$var$DocumentSet;
        a.map((e)=>{
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_fromDocument(r, e.document);
            u = u.add(t);
        });
        // Create a view snapshot of the query and documents.
        const c = $a33cbddcd7bfa0a9$var$ViewSnapshot.fromInitialDocuments(_, u, $a33cbddcd7bfa0a9$var$__PRIVATE_documentKeySet(), /* fromCache= */ !1, /* hasCachedResults= */ !1), l = new $a33cbddcd7bfa0a9$export$62297b13309008b2(e, n || null, _);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(e), l, c);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $a33cbddcd7bfa0a9$var$fail(61501, {
                type: e
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $a33cbddcd7bfa0a9$export$f243a5d948512846(e, t) {
    return e instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 && t instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && t instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && e._firestore === t._firestore && $a33cbddcd7bfa0a9$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $a33cbddcd7bfa0a9$export$11eb3b5ef9574821(e) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$6be62b059fb12175);
    const t = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($a33cbddcd7bfa0a9$export$8da5fbea04405656(t), e._key).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
$a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema = {
    type: $a33cbddcd7bfa0a9$var$property("string", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: $a33cbddcd7bfa0a9$var$property("string", "QuerySnapshot"),
    bundleName: $a33cbddcd7bfa0a9$var$property("string"),
    bundle: $a33cbddcd7bfa0a9$var$property("string")
};
class $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter extends $a33cbddcd7bfa0a9$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $a33cbddcd7bfa0a9$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $a33cbddcd7bfa0a9$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $a33cbddcd7bfa0a9$export$a58bd92642f7fb58(e) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$6be62b059fb12175);
    const t = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), n = $a33cbddcd7bfa0a9$export$8da5fbea04405656(t), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(t);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(t, r, e._key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $a33cbddcd7bfa0a9$export$35dd759aed9686b4(e) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$6be62b059fb12175);
    const t = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($a33cbddcd7bfa0a9$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$81d3477bd73c86ef(e) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$62297b13309008b2);
    const t = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), n = $a33cbddcd7bfa0a9$export$8da5fbea04405656(t), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(t);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$3fd010f18eac1dd(e) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$62297b13309008b2);
    const t = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), n = $a33cbddcd7bfa0a9$export$8da5fbea04405656(t), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(t);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$ec7d9e44f349c77b(e) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$62297b13309008b2);
    const t = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), n = $a33cbddcd7bfa0a9$export$8da5fbea04405656(t), r = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(t);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(t, r, e, n));
}
function $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12(e, t, n) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$6be62b059fb12175);
    const r = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), i = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(r, [
        $a33cbddcd7bfa0a9$var$__PRIVATE_parseSetData($a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $a33cbddcd7bfa0a9$var$Precondition.none())
    ]);
}
function $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$6be62b059fb12175);
    const i = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), s = $a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)) || t instanceof $a33cbddcd7bfa0a9$export$a1a8fea822d17659 ? $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $a33cbddcd7bfa0a9$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $a33cbddcd7bfa0a9$export$a4f20481fae8f78b(e) {
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613($a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), [
        new $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteMutation(e._key, $a33cbddcd7bfa0a9$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $a33cbddcd7bfa0a9$export$a13890143fb1c2dd(e, t) {
    const n = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), r = $a33cbddcd7bfa0a9$export$2a111da947c407d2(e), i = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(n, [
        $a33cbddcd7bfa0a9$var$__PRIVATE_parseSetData($a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $a33cbddcd7bfa0a9$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $a33cbddcd7bfa0a9$export$d36370812fb26935(e, ...t) {
    // onSnapshot for Query or Document.
    e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e);
    let n = {
        includeMetadataChanges: !1,
        source: "default"
    }, r = 0;
    "object" != typeof t[r] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(t[r]) || (n = t[r++]);
    const i = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(t[r])) {
        const e = t[r];
        t[r] = e.next?.bind(e), t[r + 1] = e.error?.bind(e), t[r + 2] = e.complete?.bind(e);
    }
    let s, o, _;
    if (e instanceof $a33cbddcd7bfa0a9$export$6be62b059fb12175) o = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), _ = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryForPath(e._key.path), s = {
        next: (n)=>{
            t[r] && t[r]($a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(o, e, n));
        },
        error: t[r + 1],
        complete: t[r + 2]
    };
    else {
        const n = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$62297b13309008b2);
        o = $a33cbddcd7bfa0a9$export$572106fb5803752c(n.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), _ = n._query;
        const i = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(o);
        s = {
            next: (e)=>{
                t[r] && t[r](new $a33cbddcd7bfa0a9$export$8f21149d8133945c(o, i, n, e));
            },
            error: t[r + 1],
            complete: t[r + 2]
        }, $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $a33cbddcd7bfa0a9$var$__PRIVATE_AsyncObserver(r), s = new $a33cbddcd7bfa0a9$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerListen(await $a33cbddcd7bfa0a9$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.Nu(), e.asyncQueue.enqueueAndForget(async ()=>$a33cbddcd7bfa0a9$var$__PRIVATE_eventManagerUnlisten(await $a33cbddcd7bfa0a9$var$__PRIVATE_getEventManager(e), s));
        };
    }($a33cbddcd7bfa0a9$export$8da5fbea04405656(o), _, i, s);
}
function $a33cbddcd7bfa0a9$export$a1ef90ed3b4a87fa(e, t, ...n) {
    const r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), i = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(e) {
        const t = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in e)) {
                t.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = e[r];
            if ("string" != typeof n) {
                t.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                t.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? t.bundle = n : "bundleName" === r ? t.bundleName = n : "bundleSource" === r && (t.bundleSource = n);
        }
        return t;
    }(t);
    if (i.error) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, i.error);
    let s, o = 0;
    if ("object" != typeof n[o] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o]) || (s = n[o++]), "QuerySnapshot" === i.bundleSource) {
        let e = null;
        if ("object" == typeof n[o] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o])) {
            const t = n[o++];
            e = {
                next: t.next,
                error: t.error,
                complete: t.complete
            };
        } else e = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(e, t, n, r, i) {
            let s, o = !1;
            const _ = $a33cbddcd7bfa0a9$export$4b8b93c690c9810b(e, t.bundle);
            return _.then(()=>$a33cbddcd7bfa0a9$export$169d2c6fe0f7f4ea(e, t.bundleName)).then((e)=>{
                if (e && !o) i && e.withConverter(i), s = $a33cbddcd7bfa0a9$export$d36370812fb26935(e, n || {}, r);
            }).catch((e)=>(r.error && r.error(e), ()=>{})), ()=>{
                o || (o = !0, s && s());
            };
        }(r, i, s, e, n[o]);
    }
    if ("DocumentSnapshot" === i.bundleSource) {
        let e = null;
        if ("object" == typeof n[o] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o])) {
            const t = n[o++];
            e = {
                next: t.next,
                error: t.error,
                complete: t.complete
            };
        } else e = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(e, t, n, r, i) {
            let s, o = !1;
            const _ = $a33cbddcd7bfa0a9$export$4b8b93c690c9810b(e, t.bundle);
            return _.then(()=>{
                if (!o) {
                    const o = new $a33cbddcd7bfa0a9$export$6be62b059fb12175(e, i || null, $a33cbddcd7bfa0a9$export$afc2e57c475b7810.fromPath(t.bundleName));
                    s = $a33cbddcd7bfa0a9$export$d36370812fb26935(o, n || {}, r);
                }
            }).catch((e)=>(r.error && r.error(e), ()=>{})), ()=>{
                o || (o = !0, s && s());
            };
        }(r, i, s, e, n[o]);
    }
    throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, `unsupported bundle source: ${i.bundleSource}`);
}
function $a33cbddcd7bfa0a9$export$9dff4f5aba83e348(e, t) {
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)), $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $a33cbddcd7bfa0a9$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$a33cbddcd7bfa0a9$var$__PRIVATE_syncEngineWrite(await $a33cbddcd7bfa0a9$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($a33cbddcd7bfa0a9$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(e);
    return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(e, i, t._key, r, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
function $a33cbddcd7bfa0a9$export$b1de1b12889d0afb(e) {
    return $a33cbddcd7bfa0a9$export$a51511de2fae49b3(e, {
        count: $a33cbddcd7bfa0a9$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $a33cbddcd7bfa0a9$export$a51511de2fae49b3(e, t) {
    const n = $a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82), r = $a33cbddcd7bfa0a9$export$8da5fbea04405656(n), i = $a33cbddcd7bfa0a9$var$__PRIVATE_mapToArray(t, (e, t)=>new $a33cbddcd7bfa0a9$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(e), i = new $a33cbddcd7bfa0a9$export$40257fef64be808b(t, r, n);
            return i;
        })(n, e, t));
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = $a33cbddcd7bfa0a9$var$OnlineComponentProvider.provider, this._offlineComponentProvider = e?.garbageCollector ? e.garbageCollector._offlineComponentProvider : {
            build: ()=>new $a33cbddcd7bfa0a9$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", e?.tabManager ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryOfflineComponentProvider.provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new $a33cbddcd7bfa0a9$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $a33cbddcd7bfa0a9$export$574728f3be606189() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $a33cbddcd7bfa0a9$export$2340f88905cc0c23(e) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl(e?.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $a33cbddcd7bfa0a9$export$72ef71adb739a32c(e) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $a33cbddcd7bfa0a9$export$51b321e43d5331d5(e) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $a33cbddcd7bfa0a9$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $a33cbddcd7bfa0a9$var$__PRIVATE_IndexedDbOfflineComponentProvider(t, e?.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $a33cbddcd7bfa0a9$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabOfflineComponentProvider(t, e?.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(e) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl(e?.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $a33cbddcd7bfa0a9$export$57e9d290b0b4dc04() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$In = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $a33cbddcd7bfa0a9$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore), i = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $a33cbddcd7bfa0a9$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $a33cbddcd7bfa0a9$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)) || t instanceof $a33cbddcd7bfa0a9$export$a1a8fea822d17659 ? $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $a33cbddcd7bfa0a9$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteMutation(t._key, $a33cbddcd7bfa0a9$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)).firestore !== t) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $a33cbddcd7bfa0a9$var$Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $a33cbddcd7bfa0a9$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $a33cbddcd7bfa0a9$var$fail(24041);
            const r = e[0];
            if (r.isFoundDocument()) return new $a33cbddcd7bfa0a9$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $a33cbddcd7bfa0a9$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $a33cbddcd7bfa0a9$var$fail(18433, {
                doc: r
            });
        });
    }
    set(e, t, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore), i = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $a33cbddcd7bfa0a9$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)) || t instanceof $a33cbddcd7bfa0a9$export$a1a8fea822d17659 ? $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $a33cbddcd7bfa0a9$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $a33cbddcd7bfa0a9$export$febc5573c75cefb0 extends $a33cbddcd7bfa0a9$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(e, this._firestore), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $a33cbddcd7bfa0a9$export$3c54e006bf9c93b7(e, t, n) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82);
    const r = {
        ...$a33cbddcd7bfa0a9$var$In,
        ...n
    };
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $a33cbddcd7bfa0a9$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $a33cbddcd7bfa0a9$var$__PRIVATE_getDatastore(e);
            new $a33cbddcd7bfa0a9$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).ju();
        }), r.promise;
    }($a33cbddcd7bfa0a9$export$8da5fbea04405656(e), (n)=>t(new $a33cbddcd7bfa0a9$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $a33cbddcd7bfa0a9$export$2bbad96c62fdba3e() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $a33cbddcd7bfa0a9$export$3ff8e7e00c3264b7() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $a33cbddcd7bfa0a9$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $a33cbddcd7bfa0a9$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $a33cbddcd7bfa0a9$export$a2647aa13413c947(e) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $a33cbddcd7bfa0a9$export$6074e20ba5c64bef(e) {
    return new $a33cbddcd7bfa0a9$export$994bb3d317350b37(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $a33cbddcd7bfa0a9$export$44cd1c9d57edd9b1(e) {
    return $a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)), new $a33cbddcd7bfa0a9$export$d94ed661b1cfd435(e, (t)=>$a33cbddcd7bfa0a9$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$export$ff1663c0c1304f1a(e, t) {
    const n = $a33cbddcd7bfa0a9$export$8da5fbea04405656(e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82));
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Failed to parse JSON: " + e?.message);
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $a33cbddcd7bfa0a9$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $a33cbddcd7bfa0a9$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $a33cbddcd7bfa0a9$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $a33cbddcd7bfa0a9$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $a33cbddcd7bfa0a9$var$FieldIndex($a33cbddcd7bfa0a9$var$FieldIndex.UNKNOWN_ID, t, r, $a33cbddcd7bfa0a9$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientSetIndexConfiguration(n, r);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(e){
        this._firestore = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $a33cbddcd7bfa0a9$export$61c6347b57bdfa06(e) {
    e = $a33cbddcd7bfa0a9$export$572106fb5803752c(e, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82);
    const t = $a33cbddcd7bfa0a9$var$En.get(e);
    if (t) return t;
    const n = $a33cbddcd7bfa0a9$export$8da5fbea04405656(e);
    if ("persistent" !== n._uninitializedComponentsProvider?._offline.kind) return null;
    const r = new $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8(e);
    return $a33cbddcd7bfa0a9$var$En.set(e, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $a33cbddcd7bfa0a9$export$9b2c0a7aacbcd151(e) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $a33cbddcd7bfa0a9$export$5b460d5f48076743(e) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $a33cbddcd7bfa0a9$export$72809fc2fc5083d5(e) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes($a33cbddcd7bfa0a9$export$8da5fbea04405656(e._firestore)).then((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded")).catch((e)=>$a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled($a33cbddcd7bfa0a9$export$8da5fbea04405656(e._firestore), t).then((e)=>$a33cbddcd7bfa0a9$var$__PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`)).catch((e)=>$a33cbddcd7bfa0a9$export$86cd73f49cc6e0bb(`setting persistent cache index auto creation isEnabled=${t} failed`, e));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $a33cbddcd7bfa0a9$var$En = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a33cbddcd7bfa0a9$export$b22c6725d8899bb4(e) {
    const t = $a33cbddcd7bfa0a9$export$8da5fbea04405656($a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)), n = t._onlineComponents?.datastore.serializer;
    return void 0 === n ? null : $a33cbddcd7bfa0a9$var$__PRIVATE_toQueryTarget(n, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToTarget(e._query)).ft;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $a33cbddcd7bfa0a9$export$5bcaa7c32a88925e(e, t) {
    const n = $a33cbddcd7bfa0a9$var$__PRIVATE_mapToArray(t, (e, t)=>new $a33cbddcd7bfa0a9$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), r = $a33cbddcd7bfa0a9$export$8da5fbea04405656($a33cbddcd7bfa0a9$export$572106fb5803752c(e.firestore, $a33cbddcd7bfa0a9$export$d0e2b3272814ce82)), i = r._onlineComponents?.datastore.serializer;
    return void 0 === i ? null : $a33cbddcd7bfa0a9$var$__PRIVATE_toRunAggregationQueryRequest(i, $a33cbddcd7bfa0a9$var$__PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $a33cbddcd7bfa0a9$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(e) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.Mc = new Map;
    }
    static get instance() {
        return $a33cbddcd7bfa0a9$var$dn || ($a33cbddcd7bfa0a9$var$dn = new $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if ($a33cbddcd7bfa0a9$var$wt) throw new Error("a TestingHooksSpi instance is already set");
            $a33cbddcd7bfa0a9$var$wt = e;
        }($a33cbddcd7bfa0a9$var$dn)), $a33cbddcd7bfa0a9$var$dn;
    }
    lt(e) {
        this.Mc.forEach((t)=>t(e));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Mc;
        return n.set(t, e), ()=>n.delete(t);
    }
}
let $a33cbddcd7bfa0a9$var$dn = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $a33cbddcd7bfa0a9$var$x = e;
    }((0, $5e587d655f0a08bb$export$31499a9cd224b78c)), (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $a33cbddcd7bfa0a9$export$d0e2b3272814ce82(new $a33cbddcd7bfa0a9$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $a33cbddcd7bfa0a9$var$__PRIVATE_FirebaseAppCheckTokenProvider(i, e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $a33cbddcd7bfa0a9$export$8fada0bf726bf278($a33cbddcd7bfa0a9$var$N.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $a33cbddcd7bfa0a9$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = {
            useFetchStreams: t,
            ...r
        }, s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$F, $a33cbddcd7bfa0a9$var$M, e), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$F, $a33cbddcd7bfa0a9$var$M, "esm2020");
}();







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd535d61f8c6f0dc$var$LONG_TYPE = "type.googleapis.com/google.protobuf.Int64Value";
const $fd535d61f8c6f0dc$var$UNSIGNED_LONG_TYPE = "type.googleapis.com/google.protobuf.UInt64Value";
function $fd535d61f8c6f0dc$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    const result = {};
    for(const key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */ function $fd535d61f8c6f0dc$var$encode(data) {
    if (data == null) return null;
    if (data instanceof Number) data = data.valueOf();
    if (typeof data === "number" && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
    if (data === true || data === false) return data;
    if (Object.prototype.toString.call(data) === "[object String]") return data;
    if (data instanceof Date) return data.toISOString();
    if (Array.isArray(data)) return data.map((x)=>$fd535d61f8c6f0dc$var$encode(x));
    if (typeof data === "function" || typeof data === "object") return $fd535d61f8c6f0dc$var$mapValues(data, (x)=>$fd535d61f8c6f0dc$var$encode(x));
    // If we got this far, the data is not encodable.
    throw new Error("Data cannot be encoded in JSON: " + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */ function $fd535d61f8c6f0dc$var$decode(json) {
    if (json == null) return json;
    if (json["@type"]) switch(json["@type"]){
        case $fd535d61f8c6f0dc$var$LONG_TYPE:
        // Fall through and handle this the same as unsigned.
        case $fd535d61f8c6f0dc$var$UNSIGNED_LONG_TYPE:
            {
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                const value = Number(json["value"]);
                if (isNaN(value)) throw new Error("Data cannot be decoded from JSON: " + json);
                return value;
            }
        default:
            throw new Error("Data cannot be decoded from JSON: " + json);
    }
    if (Array.isArray(json)) return json.map((x)=>$fd535d61f8c6f0dc$var$decode(x));
    if (typeof json === "function" || typeof json === "object") return $fd535d61f8c6f0dc$var$mapValues(json, (x)=>$fd535d61f8c6f0dc$var$decode(x));
    // Anything else is safe to return.
    return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ const $fd535d61f8c6f0dc$var$FUNCTIONS_TYPE = "functions";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ const $fd535d61f8c6f0dc$var$errorCodeMap = {
    OK: "ok",
    CANCELLED: "cancelled",
    UNKNOWN: "unknown",
    INVALID_ARGUMENT: "invalid-argument",
    DEADLINE_EXCEEDED: "deadline-exceeded",
    NOT_FOUND: "not-found",
    ALREADY_EXISTS: "already-exists",
    PERMISSION_DENIED: "permission-denied",
    UNAUTHENTICATED: "unauthenticated",
    RESOURCE_EXHAUSTED: "resource-exhausted",
    FAILED_PRECONDITION: "failed-precondition",
    ABORTED: "aborted",
    OUT_OF_RANGE: "out-of-range",
    UNIMPLEMENTED: "unimplemented",
    INTERNAL: "internal",
    UNAVAILABLE: "unavailable",
    DATA_LOSS: "data-loss"
};
/**
 * An error returned by the Firebase Functions client SDK.
 *
 * See {@link FunctionsErrorCode} for full documentation of codes.
 *
 * @public
 */ class $fd535d61f8c6f0dc$export$738689d52335bb3c extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    /**
     * Constructs a new instance of the `FunctionsError` class.
     */ constructor(/**
     * A standard error code that will be returned to the client. This also
     * determines the HTTP status code of the response, as defined in code.proto.
     */ code, message, /**
     * Additional details to be converted to JSON and included in the error response.
     */ details){
        super(`${$fd535d61f8c6f0dc$var$FUNCTIONS_TYPE}/${code}`, message || "");
        this.details = details;
        // Since the FirebaseError constructor sets the prototype of `this` to FirebaseError.prototype,
        // we also have to do it in all subclasses to allow for correct `instanceof` checks.
        Object.setPrototypeOf(this, $fd535d61f8c6f0dc$export$738689d52335bb3c.prototype);
    }
}
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $fd535d61f8c6f0dc$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return "ok";
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return "internal";
        case 400:
            return "invalid-argument";
        case 401:
            return "unauthenticated";
        case 403:
            return "permission-denied";
        case 404:
            return "not-found";
        case 409:
            return "aborted";
        case 429:
            return "resource-exhausted";
        case 499:
            return "cancelled";
        case 500:
            return "internal";
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline-exceeded";
    }
    return "unknown";
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $fd535d61f8c6f0dc$var$_errorForResponse(status, bodyJSON) {
    let code = $fd535d61f8c6f0dc$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    let description = code;
    let details = undefined;
    // Then look through the body for explicit details.
    try {
        const errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            const status = errorJSON.status;
            if (typeof status === "string") {
                if (!$fd535d61f8c6f0dc$var$errorCodeMap[status]) // They must've included an unknown error code in the body.
                return new $fd535d61f8c6f0dc$export$738689d52335bb3c("internal", "internal");
                code = $fd535d61f8c6f0dc$var$errorCodeMap[status];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status;
            }
            const message = errorJSON.message;
            if (typeof message === "string") description = message;
            details = errorJSON.details;
            if (details !== undefined) details = $fd535d61f8c6f0dc$var$decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === "ok") // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $fd535d61f8c6f0dc$export$738689d52335bb3c(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */ class $fd535d61f8c6f0dc$var$ContextProvider {
    constructor(app, authProvider, messagingProvider, appCheckProvider){
        this.app = app;
        this.auth = null;
        this.messaging = null;
        this.appCheck = null;
        this.serverAppAppCheckToken = null;
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(app) && app.settings.appCheckToken) this.serverAppAppCheckToken = app.settings.appCheckToken;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then((auth)=>this.auth = auth, ()=>{
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then((messaging)=>this.messaging = messaging, ()=>{
        /* get() never rejects */ });
        if (!this.appCheck) appCheckProvider?.get().then((appCheck)=>this.appCheck = appCheck, ()=>{
        /* get() never rejects */ });
    }
    async getAuthToken() {
        if (!this.auth) return undefined;
        try {
            const token = await this.auth.getToken();
            return token?.accessToken;
        } catch (e) {
            // If there's any error when trying to get the auth token, leave it off.
            return undefined;
        }
    }
    async getMessagingToken() {
        if (!this.messaging || !("Notification" in self) || Notification.permission !== "granted") return undefined;
        try {
            return await this.messaging.getToken();
        } catch (e) {
            // We don't warn on this, because it usually means messaging isn't set up.
            // console.warn('Failed to retrieve instance id token.', e);
            // If there's any error when trying to get the token, leave it off.
            return undefined;
        }
    }
    async getAppCheckToken(limitedUseAppCheckTokens) {
        if (this.serverAppAppCheckToken) return this.serverAppAppCheckToken;
        if (this.appCheck) {
            const result = limitedUseAppCheckTokens ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
            if (result.error) // Do not send the App Check header to the functions endpoint if
            // there was an error from the App Check exchange endpoint. The App
            // Check SDK will already have logged the error to console.
            return null;
            return result.token;
        }
        return null;
    }
    async getContext(limitedUseAppCheckTokens) {
        const authToken = await this.getAuthToken();
        const messagingToken = await this.getMessagingToken();
        const appCheckToken = await this.getAppCheckToken(limitedUseAppCheckTokens);
        return {
            authToken: authToken,
            messagingToken: messagingToken,
            appCheckToken: appCheckToken
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd535d61f8c6f0dc$var$DEFAULT_REGION = "us-central1";
const $fd535d61f8c6f0dc$var$responseLineRE = /^data: (.*?)(?:\n|$)/;
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $fd535d61f8c6f0dc$var$failAfter(millis) {
    // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer = null;
    return {
        promise: new Promise((_, reject)=>{
            timer = setTimeout(()=>{
                reject(new $fd535d61f8c6f0dc$export$738689d52335bb3c("deadline-exceeded", "deadline-exceeded"));
            }, millis);
        }),
        cancel: ()=>{
            if (timer) clearTimeout(timer);
        }
    };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */ class $fd535d61f8c6f0dc$var$FunctionsService {
    /**
     * Creates a new Functions service for the given app.
     * @param app - The FirebaseApp to use.
     */ constructor(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain = $fd535d61f8c6f0dc$var$DEFAULT_REGION, fetchImpl = (...args)=>fetch(...args)){
        this.app = app;
        this.fetchImpl = fetchImpl;
        this.emulatorOrigin = null;
        this.contextProvider = new $fd535d61f8c6f0dc$var$ContextProvider(app, authProvider, messagingProvider, appCheckProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise((resolve)=>{
            this.deleteService = ()=>{
                return Promise.resolve(resolve());
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            const url = new URL(regionOrCustomDomain);
            this.customDomain = url.origin + (url.pathname === "/" ? "" : url.pathname);
            this.region = $fd535d61f8c6f0dc$var$DEFAULT_REGION;
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain;
        }
    }
    _delete() {
        return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */ _url(name) {
        const projectId = this.app.options.projectId;
        if (this.emulatorOrigin !== null) {
            const origin = this.emulatorOrigin;
            return `${origin}/${projectId}/${this.region}/${name}`;
        }
        if (this.customDomain !== null) return `${this.customDomain}/${name}`;
        return `https://${this.region}-${projectId}.cloudfunctions.net/${name}`;
    }
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */ function $fd535d61f8c6f0dc$var$connectFunctionsEmulator$1(functionsInstance, host, port) {
    const useSsl = (0, $029952e65115eee5$export$5b4d24b45140ad90)(host);
    functionsInstance.emulatorOrigin = `http${useSsl ? "s" : ""}://${host}:${port}`;
    // Workaround to get cookies in Firebase Studio
    if (useSsl) {
        (0, $029952e65115eee5$export$c0f0d0ce4283a937)(functionsInstance.emulatorOrigin + "/backends");
        (0, $029952e65115eee5$export$fd3d2954543183b1)("Functions", true);
    }
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$var$httpsCallable$1(functionsInstance, name, options) {
    const callable = (data)=>{
        return $fd535d61f8c6f0dc$var$call(functionsInstance, name, data, options || {});
    };
    callable.stream = (data, options)=>{
        return $fd535d61f8c6f0dc$var$stream(functionsInstance, name, data, options);
    };
    return callable;
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$var$httpsCallableFromURL$1(functionsInstance, url, options) {
    const callable = (data)=>{
        return $fd535d61f8c6f0dc$var$callAtURL(functionsInstance, url, data, options || {});
    };
    callable.stream = (data, options)=>{
        return $fd535d61f8c6f0dc$var$streamAtURL(functionsInstance, url, data, options || {});
    };
    return callable;
}
function $fd535d61f8c6f0dc$var$getCredentials(functionsInstance) {
    return functionsInstance.emulatorOrigin && (0, $029952e65115eee5$export$5b4d24b45140ad90)(functionsInstance.emulatorOrigin) ? "include" : undefined;
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @param functionsInstance functions instance that is calling postJSON
 * @return A Promise that will succeed when the request finishes.
 */ async function $fd535d61f8c6f0dc$var$postJSON(url, body, headers, fetchImpl, functionsInstance) {
    headers["Content-Type"] = "application/json";
    let response;
    try {
        response = await fetchImpl(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: headers,
            credentials: $fd535d61f8c6f0dc$var$getCredentials(functionsInstance)
        });
    } catch (e) {
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        return {
            status: 0,
            json: null
        };
    }
    let json = null;
    try {
        json = await response.json();
    } catch (e) {
    // If we fail to parse JSON, it will fail the same as an empty body.
    }
    return {
        status: response.status,
        json: json
    };
}
/**
 * Creates authorization headers for Firebase Functions requests.
 * @param functionsInstance The Firebase Functions service instance.
 * @param options Options for the callable function, including AppCheck token settings.
 * @return A Promise that resolves a headers map to include in outgoing fetch request.
 */ async function $fd535d61f8c6f0dc$var$makeAuthHeaders(functionsInstance, options) {
    const headers = {};
    const context = await functionsInstance.contextProvider.getContext(options.limitedUseAppCheckTokens);
    if (context.authToken) headers["Authorization"] = "Bearer " + context.authToken;
    if (context.messagingToken) headers["Firebase-Instance-ID-Token"] = context.messagingToken;
    if (context.appCheckToken !== null) headers["X-Firebase-AppCheck"] = context.appCheckToken;
    return headers;
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.
 */ function $fd535d61f8c6f0dc$var$call(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $fd535d61f8c6f0dc$var$callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.
 */ async function $fd535d61f8c6f0dc$var$callAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $fd535d61f8c6f0dc$var$encode(data);
    const body = {
        data: data
    };
    // Add a header for the authToken.
    const headers = await $fd535d61f8c6f0dc$var$makeAuthHeaders(functionsInstance, options);
    // Default timeout to 70s, but let the options override it.
    const timeout = options.timeout || 70000;
    const failAfterHandle = $fd535d61f8c6f0dc$var$failAfter(timeout);
    const response = await Promise.race([
        $fd535d61f8c6f0dc$var$postJSON(url, body, headers, functionsInstance.fetchImpl, functionsInstance),
        failAfterHandle.promise,
        functionsInstance.cancelAllRequests
    ]);
    // Always clear the failAfter timeout
    failAfterHandle.cancel();
    // If service was deleted, interrupted response throws an error.
    if (!response) throw new $fd535d61f8c6f0dc$export$738689d52335bb3c("cancelled", "Firebase Functions instance was deleted.");
    // Check for an error status, regardless of http status.
    const error = $fd535d61f8c6f0dc$var$_errorForResponse(response.status, response.json);
    if (error) throw error;
    if (!response.json) throw new $fd535d61f8c6f0dc$export$738689d52335bb3c("internal", "Response is not valid JSON object.");
    let responseData = response.json.data;
    // TODO(klimt): For right now, allow "result" instead of "data", for
    // backwards compatibility.
    if (typeof responseData === "undefined") responseData = response.json.result;
    if (typeof responseData === "undefined") // Consider the response malformed.
    throw new $fd535d61f8c6f0dc$export$738689d52335bb3c("internal", "Response is missing data field.");
    // Decode any special types, such as dates, in the returned data.
    const decodedData = $fd535d61f8c6f0dc$var$decode(responseData);
    return {
        data: decodedData
    };
}
/**
 * Calls a callable function asynchronously and returns a streaming result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.
 * @param options Streaming request options.
 */ function $fd535d61f8c6f0dc$var$stream(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $fd535d61f8c6f0dc$var$streamAtURL(functionsInstance, url, data, options || {});
}
/**
 * Calls a callable function asynchronously and return a streaming result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.
 * @param options Streaming request options.
 */ async function $fd535d61f8c6f0dc$var$streamAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $fd535d61f8c6f0dc$var$encode(data);
    const body = {
        data: data
    };
    //
    // Add a header for the authToken.
    const headers = await $fd535d61f8c6f0dc$var$makeAuthHeaders(functionsInstance, options);
    headers["Content-Type"] = "application/json";
    headers["Accept"] = "text/event-stream";
    let response;
    try {
        response = await functionsInstance.fetchImpl(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: headers,
            signal: options?.signal,
            credentials: $fd535d61f8c6f0dc$var$getCredentials(functionsInstance)
        });
    } catch (e) {
        if (e instanceof Error && e.name === "AbortError") {
            const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c("cancelled", "Request was cancelled.");
            return {
                data: Promise.reject(error),
                stream: {
                    [Symbol.asyncIterator] () {
                        return {
                            next () {
                                return Promise.reject(error);
                            }
                        };
                    }
                }
            };
        }
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        const error = $fd535d61f8c6f0dc$var$_errorForResponse(0, null);
        return {
            data: Promise.reject(error),
            // Return an empty async iterator
            stream: {
                [Symbol.asyncIterator] () {
                    return {
                        next () {
                            return Promise.reject(error);
                        }
                    };
                }
            }
        };
    }
    let resultResolver;
    let resultRejecter;
    const resultPromise = new Promise((resolve, reject)=>{
        resultResolver = resolve;
        resultRejecter = reject;
    });
    options?.signal?.addEventListener("abort", ()=>{
        const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c("cancelled", "Request was cancelled.");
        resultRejecter(error);
    });
    const reader = response.body.getReader();
    const rstream = $fd535d61f8c6f0dc$var$createResponseStream(reader, resultResolver, resultRejecter, options?.signal);
    return {
        stream: {
            [Symbol.asyncIterator] () {
                const rreader = rstream.getReader();
                return {
                    async next () {
                        const { value: value, done: done } = await rreader.read();
                        return {
                            value: value,
                            done: done
                        };
                    },
                    async return () {
                        await rreader.cancel();
                        return {
                            done: true,
                            value: undefined
                        };
                    }
                };
            }
        },
        data: resultPromise
    };
}
/**
 * Creates a ReadableStream that processes a streaming response from a streaming
 * callable function that returns data in server-sent event format.
 *
 * @param reader The underlying reader providing raw response data
 * @param resultResolver Callback to resolve the final result when received
 * @param resultRejecter Callback to reject with an error if encountered
 * @param signal Optional AbortSignal to cancel the stream processing
 * @returns A ReadableStream that emits decoded messages from the response
 *
 * The returned ReadableStream:
 *   1. Emits individual messages when "message" data is received
 *   2. Resolves with the final result when a "result" message is received
 *   3. Rejects with an error if an "error" message is received
 */ function $fd535d61f8c6f0dc$var$createResponseStream(reader, resultResolver, resultRejecter, signal) {
    const processLine = (line, controller)=>{
        const match = line.match($fd535d61f8c6f0dc$var$responseLineRE);
        // ignore all other lines (newline, comments, etc.)
        if (!match) return;
        const data = match[1];
        try {
            const jsonData = JSON.parse(data);
            if ("result" in jsonData) {
                resultResolver($fd535d61f8c6f0dc$var$decode(jsonData.result));
                return;
            }
            if ("message" in jsonData) {
                controller.enqueue($fd535d61f8c6f0dc$var$decode(jsonData.message));
                return;
            }
            if ("error" in jsonData) {
                const error = $fd535d61f8c6f0dc$var$_errorForResponse(0, jsonData);
                controller.error(error);
                resultRejecter(error);
                return;
            }
        } catch (error) {
            if (error instanceof $fd535d61f8c6f0dc$export$738689d52335bb3c) {
                controller.error(error);
                resultRejecter(error);
                return;
            }
        // ignore other parsing errors
        }
    };
    const decoder = new TextDecoder();
    return new ReadableStream({
        start (controller) {
            let currentText = "";
            return pump();
            async function pump() {
                if (signal?.aborted) {
                    const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c("cancelled", "Request was cancelled");
                    controller.error(error);
                    resultRejecter(error);
                    return Promise.resolve();
                }
                try {
                    const { value: value, done: done } = await reader.read();
                    if (done) {
                        if (currentText.trim()) processLine(currentText.trim(), controller);
                        controller.close();
                        return;
                    }
                    if (signal?.aborted) {
                        const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c("cancelled", "Request was cancelled");
                        controller.error(error);
                        resultRejecter(error);
                        await reader.cancel();
                        return;
                    }
                    currentText += decoder.decode(value, {
                        stream: true
                    });
                    const lines = currentText.split("\n");
                    currentText = lines.pop() || "";
                    for (const line of lines)if (line.trim()) processLine(line.trim(), controller);
                    return pump();
                } catch (error) {
                    const functionsError = error instanceof $fd535d61f8c6f0dc$export$738689d52335bb3c ? error : $fd535d61f8c6f0dc$var$_errorForResponse(0, null);
                    controller.error(functionsError);
                    resultRejecter(functionsError);
                }
            }
        },
        cancel () {
            return reader.cancel();
        }
    });
}
const $fd535d61f8c6f0dc$var$name = "@firebase/functions";
const $fd535d61f8c6f0dc$var$version = "0.13.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd535d61f8c6f0dc$var$AUTH_INTERNAL_NAME = "auth-internal";
const $fd535d61f8c6f0dc$var$APP_CHECK_INTERNAL_NAME = "app-check-internal";
const $fd535d61f8c6f0dc$var$MESSAGING_INTERNAL_NAME = "messaging-internal";
function $fd535d61f8c6f0dc$var$registerFunctions(variant) {
    const factory = (container, { instanceIdentifier: regionOrCustomDomain })=>{
        // Dependencies
        const app = container.getProvider("app").getImmediate();
        const authProvider = container.getProvider($fd535d61f8c6f0dc$var$AUTH_INTERNAL_NAME);
        const messagingProvider = container.getProvider($fd535d61f8c6f0dc$var$MESSAGING_INTERNAL_NAME);
        const appCheckProvider = container.getProvider($fd535d61f8c6f0dc$var$APP_CHECK_INTERNAL_NAME);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $fd535d61f8c6f0dc$var$FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain);
    };
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)($fd535d61f8c6f0dc$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($fd535d61f8c6f0dc$var$name, $fd535d61f8c6f0dc$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($fd535d61f8c6f0dc$var$name, $fd535d61f8c6f0dc$var$version, "esm2020");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */ function $fd535d61f8c6f0dc$export$7d4c14593b8a2193(app = (0, $5e587d655f0a08bb$export$f9962582c9e66d99)(), regionOrCustomDomain = $fd535d61f8c6f0dc$var$DEFAULT_REGION) {
    // Dependencies
    const functionsProvider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)((0, $029952e65115eee5$export$4befe9b5fa509a1b)(app), $fd535d61f8c6f0dc$var$FUNCTIONS_TYPE);
    const functionsInstance = functionsProvider.getImmediate({
        identifier: regionOrCustomDomain
    });
    const emulator = (0, $029952e65115eee5$export$a3febcf1f14a3a0c)("functions");
    if (emulator) $fd535d61f8c6f0dc$export$472343ee9d485d97(functionsInstance, ...emulator);
    return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */ function $fd535d61f8c6f0dc$export$472343ee9d485d97(functionsInstance, host, port) {
    $fd535d61f8c6f0dc$var$connectFunctionsEmulator$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$export$438b58c7f2c6bf5e(functionsInstance, name, options) {
    return $fd535d61f8c6f0dc$var$httpsCallable$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$export$486b60b301a0b194(functionsInstance, url, options) {
    return $fd535d61f8c6f0dc$var$httpsCallableFromURL$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */ $fd535d61f8c6f0dc$var$registerFunctions();




// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const $61264a5118d4bae6$var$firebaseConfig = {
    apiKey: "AIzaSyBzpYas5BAcVubWIKkCURbKzKo-gel47Yw",
    authDomain: "niram-616e5.firebaseapp.com",
    projectId: "niram-616e5",
    storageBucket: "niram-616e5.firebasestorage.app",
    messagingSenderId: "604775691532",
    appId: "1:604775691532:web:07bba4f95857c89ff14529"
};
// Initialize Firebase
const $61264a5118d4bae6$export$729c8b7179294ba = (0, $5e587d655f0a08bb$export$c55cfd413944906d)($61264a5118d4bae6$var$firebaseConfig);
const $61264a5118d4bae6$export$73693bad9f5880b0 = (0, $2f7f285d50ad74d4$export$ffb5f4729a158638)($61264a5118d4bae6$export$729c8b7179294ba);
const $61264a5118d4bae6$export$f932f06c7eb6abeb = (0, $a33cbddcd7bfa0a9$export$f06a05d14c3a6678)($61264a5118d4bae6$export$729c8b7179294ba);
const $61264a5118d4bae6$var$functions = (0, $fd535d61f8c6f0dc$export$7d4c14593b8a2193)($61264a5118d4bae6$export$729c8b7179294ba, "us-central1"); // Specify region explicitly
const $61264a5118d4bae6$export$f701fb0689f465b8 = new (0, $2f7f285d50ad74d4$export$8743009a87fcb00f)();
const $61264a5118d4bae6$export$a845bfa6d190b609 = (0, $fd535d61f8c6f0dc$export$438b58c7f2c6bf5e)($61264a5118d4bae6$var$functions, "processGoogleSignIn");


// Get references to UI elements
const $2b6e161c9edcf319$var$userStatus = document.getElementById("userStatus");
const $2b6e161c9edcf319$var$signOutButton = document.getElementById("sign-out-button");
const $2b6e161c9edcf319$var$signInButton = document.getElementById("signInButton");
// Function to update the UI based on auth state (inspired by kibbutz design)
const $2b6e161c9edcf319$var$updateUI = (user)=>{
    if (user) {
        $2b6e161c9edcf319$var$userStatus.textContent = `Signed in as: ${user.displayName || user.email}`;
        $2b6e161c9edcf319$var$userStatus.classList.remove("signed-out");
        $2b6e161c9edcf319$var$userStatus.classList.add("signed-in");
        $2b6e161c9edcf319$var$signInButton.style.display = "none"; // Hide Google button
        $2b6e161c9edcf319$var$signOutButton.style.display = "block"; // Show sign out button
    } else {
        $2b6e161c9edcf319$var$userStatus.textContent = "Not signed in.";
        $2b6e161c9edcf319$var$userStatus.classList.remove("signed-in");
        $2b6e161c9edcf319$var$userStatus.classList.add("signed-out");
        $2b6e161c9edcf319$var$signInButton.style.display = "block"; // Show Google button
        $2b6e161c9edcf319$var$signOutButton.style.display = "none"; // Hide sign out button
    }
};
async function $2b6e161c9edcf319$var$signInWithGoogle() {
    try {
        const result = await (0, $2f7f285d50ad74d4$export$4368d992c4eafac0)((0, $61264a5118d4bae6$export$73693bad9f5880b0), (0, $61264a5118d4bae6$export$f701fb0689f465b8));
        const user = result.user; // Firebase Authentication User object
        console.log("Firebase Auth signed in user:", user.displayName, user.email);
        const payload = {
            uid: user.uid,
            displayName: user.displayName,
            email: user.email
        };
        console.log("Client sending to Cloud Function:", payload);
        console.log("Payload validation:", {
            uid: !!payload.uid,
            displayName: !!payload.displayName,
            email: !!payload.email,
            uidType: typeof payload.uid,
            emailType: typeof payload.email
        });
        // Call your Cloud Function to process the sign-in and update Firestore
        const functionResult = await (0, $61264a5118d4bae6$export$a845bfa6d190b609)(payload);
        console.log("Cloud Function response:", functionResult.data);
        const { status: status, message: message, userData: userData, redirectUrl: redirectUrl } = functionResult.data;
        if (status === "user_exists") console.log("Welcome back!", message);
        else if (status === "user_created") console.log("Welcome to the app!", message);
        // Handle redirect if provided by Cloud Function
        if (redirectUrl) window.location.href = redirectUrl;
    // UI will be updated by onAuthStateChanged listener
    } catch (error) {
        if (error.code === "auth/popup-closed-by-user") console.warn("Sign-in popup closed by user.");
        else if (error.code === "functions/internal") console.error("Error from Cloud Function:", error.message, error.details);
        else console.error("Error during sign-in process:", error.message);
    }
}
// Sign Out functionality
async function $2b6e161c9edcf319$var$signOutUser() {
    try {
        await (0, $61264a5118d4bae6$export$73693bad9f5880b0).signOut();
        console.log("User signed out from Firebase.");
    // UI will be updated by onAuthStateChanged listener
    } catch (error) {
        console.error("Error signing out:", error.message);
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    // Add event listeners
    if ($2b6e161c9edcf319$var$signInButton) $2b6e161c9edcf319$var$signInButton.addEventListener("click", $2b6e161c9edcf319$var$signInWithGoogle);
    if ($2b6e161c9edcf319$var$signOutButton) $2b6e161c9edcf319$var$signOutButton.addEventListener("click", $2b6e161c9edcf319$var$signOutUser);
    // Firebase Auth State Listener (updates UI automatically)
    (0, $61264a5118d4bae6$export$73693bad9f5880b0).onAuthStateChanged((user)=>{
        $2b6e161c9edcf319$var$updateUI(user);
        if (user) console.log("Auth state changed: User is signed in:", user.displayName);
        else console.log("Auth state changed: No user is signed in.");
    });
});


//# sourceMappingURL=index.7b93b9bd.js.map
